/* eslint-disable no-dupe-keys */

export const common = {
  en: {
    AnalysisType: 'Analysis Type',
    Global: 'Global',
    Local: 'Partial',
    Sieve: 'Sieve',
    ParticleSieveOpenings: 'Particle Sieve Openings',
    SieveOpening: 'Sieve Opening',
    CodeMigrations: 'Code Migrations',
    CodeMigrationsDynamic: 'Code Migrations (Dynamic)',
    UnavailableModule: 'Unavailable Module',
    KnowMore: 'Know More',
    Settings: 'Settings',
    Logout: 'Logout',
    MiningControl: 'Mining Control',
    WelcomeTo: 'Welcome to',
    Parameter: 'Parameter',
    EquipmentConfigurations: 'Equipment Configurations',
    GeneralConfigurations: 'General Configurations',
    CyclesAutomation: 'Cycles Automation',
    ControlType: 'Control Type',
    Front: 'Front',
    Equipments: 'Equipments',
    ReserveEquipment: 'Reserve Equipment',
    PerforatorSchedules: 'Perforator Schedules',
    EffectiveSchedules: 'Effective Schedules',
    InactiveTurnPersistency: 'Inactive turn persistency',
    RainMode: 'Rain Mode',
    ToggleRainMode: 'Toggle Rain Mode',
    SpeedLimit: 'Speed Limit',
    Issue: 'Issue',
    Accept: 'Accept',
    ScreenCount: 'Screen Count',
    NumberOfArches: 'Number of Arches',
    NumberOfLatticeGirders: 'Number of lattice girders',
    NumberOfDowels: 'Number of Dowels',
    NumberOfSheets: 'Number of Sheets',
    CrusherTab: 'Crusher',
    CrusherTime: 'Crusher Time',
    CrusherStopTime: 'Crusher Stop Time',
    Source: 'Source',
    FeatureInDevelopment: 'Test this feature in development',
    LastServerConnection: 'Last Server Connection',
    LastDataSent: 'Last Data Sent',
    DiconnectedTime: 'Diconnected Time',
    DataToSend: 'Data To Send',
    AddEditAllocation: 'Add/Edit Allocation',
    EditEquipmentScheduling: 'Edit Equipment Scheduling',
    GoalTypes: 'Goal Types',
    Goal: 'Goal',
    Planning: 'Planning',
    Short: 'Short',
    Medium: 'Medium',
    Long: 'Long',
    Granularity: 'Granularity',
    DefinitiveNote: 'Definitive Note',
    Class: 'Class',
    Goals: 'Goals',
    GoalsBETA: 'Goals (BETA)',
    Production: 'Production',
    State: 'State',
    ValueType: 'Value Type',
    Number: 'Number',
    TotalTimeInCode: 'Total Time In Code',
    FullDistance: 'Full Distance',
    EmptyDistance: 'Empty Distance',
    LoadLatitude: 'Latitude Loading',
    LoadLongitude: 'Longitude Loading',
    LoadAltitude: 'Altitude Loading',
    UnloadLatitude: 'Latitude Download',
    UnloadLongitude: 'Unloading length',
    UnloadAltitude: 'Altitude Unloading',
    LoadEquipmentNumber: 'Load Equipment Number',
    CycleStageTimes: 'Cycle Stage Times',
    railroad_cycle_time_port_exit: 'Port departure maneuver',
    railroad_cycle_time_empty: 'Empty train circulation',
    railroad_cycle_time_load_entry: 'Mine Entry Maneuver',
    railroad_cycle_time_load_queue: 'Loading queue',
    railroad_cycle_time_load: 'Loading',
    railroad_cycle_time_load_exit: 'Mine exit maneuver',
    railroad_cycle_time_full: 'Loaded train circulation',
    railroad_cycle_time_port_entry: 'Port entry maneuver',
    railroad_cycle_time_unload_queue: 'Unloading queue',
    railroad_cycle_time_unload: 'Unloading',
    TotalInCode: 'Total time in Code',
    StandardLoad: 'Standard Load',
    ConfirmChanges: 'Confirm changes?',
    Step: 'Step',
    LoadingEquipment: 'Nº Loading Equipment',
    Finalize: 'Finalize',
    Text: 'Text',
    ThereAreNoChanges: 'There are no changes',
    AutoAllocationLogs: 'Auto allocation logs',
    AllocationEdit: 'Allocation Edit',
    DynamicAllocationExplanation: 'Determines if this allocation should be dynamic',
    AllocationGroupExplanation: 'Defines the allocation group for this load allocation',
    MinAllocationCapacityExplanation: 'Defines a minimum hauling capacity for an excavator',
    MaxAllocationCapacityExplanation: 'Defines the maximum capacity of trucks that can be allocated to this load allocation',
    MaxLoadQueueTimeExplanation: 'Maximum queue time allowed for the load equipment',
    MeanQueueTimeRangeExplanation: 'Time range (minutes) to calculate the mean queue time for a load equipment',
    MinPermanentAllocationCyclesExplanation: 'Minimum cycles that the truck has to complete in its permanent allocation',
    MaxTemporaryAllocationCyclesExplanation: 'Maximum number of cycles to be completed in temporary allocations before the truck is forced to return to its permanent allocation',
    MinAllocationCapacityExplanation: 'Maximum number of cycles that the truck must remain in temporary allocations before being required to return to its permanent allocation',
    MinAllocationCapacity: 'Min. Allocation Capacity',
    DynamicAllocation: 'Dynamic allocation',
    MaxAllocationCapacity: 'Maximum allocation capacity',
    MaxLoadQueueTime: 'Maximum load queue time (min)',
    MeanQueueTimeRange: 'Mean queue time range (min)',
    MinimumPermanentAllocationCycles: 'Minimum cycles in permanent allocation',
    MaximumTemporaryAllocationCycles: 'Maximum cycles in temporary allocation',
    Resources: 'Resources',
    Elevation: 'Elevation',
    FilterByElevation: 'Filter by elevation',
    DependentElements: 'Dependent elements',
    DependentSubElements: 'Dependent sub-elements',
    Precedences: 'Precedences',
    CalculatePrecedences: 'Calculate precedences',
    MineAvailability: 'Mine availability',
    AvailableMass: 'Available mass (t)',
    ScenarioInConfiguration: 'Scenario in configuration',
    Configure: 'Configure',
    AppliedToAllocations: 'Applied to allocations',
    AllocationGroup: 'Allocation group',
    MaxQueueTime: 'Max queue time (min)',
    Elevations: 'Elevations',
    ElevationGroups: 'Elevation groups',
    ElevationGroup: 'Elevation group',
    ElementLimits: 'Element limits',
    ElevationsAssociatedToTheElement: 'Elevations associated to the element',
    InitialElevation: 'Initial elevation',
    FinalElevation: 'Final elevation',
    Creation: 'Creation',
    Current: 'Current',
    LoadScenarioToContinue: 'Load a scenario to continue',
    Loaded: 'Loaded',
    LoadAction: 'Load',
    FilterByDate: 'Filter by date',
    ElementsAssociatedToTheScenario: 'Elements associated to the scenario',
    SubelementsAssociatedToTheScenario: 'Subelements associated to the scenario',
    LineupNewSchedule: 'Line-up: New Schedule',
    LineupPlanning: 'Line-up: Planning',
    Scenarios: 'Scenarios',
    Empty: 'Empty',
    Full: 'Full',
    Queue: 'Queue',
    Maneuver: 'Maneuver',
    Dump: 'Dump',
    Stop: 'Stop',
    NotStarted: 'Not started',
    Disapproved: 'Disapproved',
    Paused: 'Paused',
    InProgress: 'In progress',
    OnApproval: 'On approval',
    Finalized: 'Finalized',
    DeleteSchedule: 'Delete Schedule',
    Time: 'Time',
    MassT: 'Mass (t)',
    Closings: 'Closings',
    ClosingsList: 'Closings list',
    Condition: 'Condition',
    Entry: 'Entry',
    LoginLogout: 'Login/Logout',
    StockClosings: 'Stock closings',
    Velocity: 'Velocity',
    AllocationMode: 'Allocation mode',
    Permanent: 'Permanent',
    Standard: 'Standard',
    Temporary: 'Temporary',
    AllocatedTo: 'Allocated to',
    CurrentElement: 'Current element',
    CurrentElementPoint: 'Current subelement',
    CurrentCycleStep: 'Current cycle step',
    OriginSubElement: 'Origin Sub-Element',
    AllocateTo: 'Allocate to',
    LastModified: 'Last modified',
    Origins: 'Origins',
    Destinations: 'Destinations',
    Category: 'Category',
    Input: 'Input',
    MaintenanceType: 'Maintenance Type',
    MaintenanceGroup: 'Maintenance Group',
    Maintenance: 'Maintenance',
    SelectAll: 'Select All',
    HideInterruptedOrDeletedCycles: 'Hide interrupted or deleted cycles',
    HideDeletedEvents: 'Hide deleted events',
    ShiftGroupConnectedToUndergroundModule: 'Shift Group Associated To The Underground Module',
    ShiftGroupConnectedToOpenPitModule: 'Shift Group Associated To The Open Pit Module',
    FilterByEquipmentGroup: 'Filter By Equipment Group',
    FilterByMaterial: 'Filter By Material',
    FilterByShiftGroup: 'Filter By Shift Group',
    NumberOfIntervals: 'Number of Intervals',
    RpmNoRotation: 'RPM No Rotation (initial)',
    RpmSlowRunning: 'RPM Slow Running (initial)',
    RpmHighSpin: 'RPM High Spin (initial)',
    RpmOperation: 'RPM Operation (initial)',
    Content: 'Content',
    ContentVariables: 'Manage Contents',
    Associations: 'Associations',
    AssociationsList: 'Associations List',
    ConnectSubElements: 'Associate Sub-Elements',
    FilterByProjectGroup: 'Filter By Project Group',
    FilterByElement: 'Filter By Element',
    OriginSubElements: 'Origin Sub Elements',
    CodeTime: 'Code Time',
    MaintenanceLogoutLimit: 'Maintenance Logout Limit',
    SelectMaintenanceLogoutLevel: 'Select the logout level for maintenance',
    ClearCache: 'Clear Cache',
    DisableCache: 'Disable Cache',
    AccessYourAccount: 'Access your account',
    AverageLoad: 'Average Load',
    Load: 'Load',
    MonthlyAdvance: 'Monthly Advance',
    MonthlyAdvanceMeters: 'Monthly Advance (meters)',
    LoadFactor: 'Load Factor',
    Welcome: 'Welcome to the Mining Control Platform',
    RefuellingPerEquipment: 'Refuelling Per Equipment',
    RemainingLitersAlarm: 'Remaining Liters Alarm',
    ConnectCodes: 'Associate Codes',
    GreenPercentage: 'Green (%)',
    YellowPercentage: 'Yellow (%)',
    RedPercentage: 'Red (%)',
    PurplePercentage: 'Purple (%)',
    FilterByEquipType: 'Filter By Equip. Type',
    FilterByEquipGroup: 'Filter by equip. group',
    TankCapacityLiters: 'Tank Capacity (liters)',
    LitersPerHourConsumption: 'Consumption (liters/hour)',
    MapElement: 'Map Element',
    MapMaterial: 'Map Material',
    OriginPlural: 'Origin(s)',
    DestinationPlural: 'Destination(s)',
    FilterOriginElements: 'Filter By Origin Elements',
    FilterDestinationElements: 'Filter By Destination Elements',
    FireID: 'Fire ID',
    FireDescription: 'Fire Description',
    HoleType: 'Hole Type',
    HoleMeters: 'Hole Footage',
    Fan: 'Fan',
    FanName: 'Fan Name',
    OriginElement: 'Origin Element',
    SubOriginElement: 'Origin Sub-Element',
    DestinationElement: 'Destination Element',
    SubDestinationElement: 'Destination Sub-Element',
    DMTMeters: 'Haul (meters)',
    OperationalControl: 'Operational Control',
    OperationalStop: 'Operational Stop',
    Operation: 'Operation',
    AnomalyLogs: 'Anomaly Logs',
    AnomalyType: 'Anomaly Type',
    Anomaly: 'Anomalys',
    AnomalousTable: 'Anomalous Table',
    Occurrences: 'Occurrences',
    Registers: 'Registers',
    EquipScheduling: 'Equip. Scheduling',
    EquipmentScheduling: 'Equipment Scheduling',
    PendenciesApproval: 'Pendencies Approval',
    Approve: 'Approve',
    Duration: 'Duration',
    DurationMatch: 'Current Duration (min)',
    DurationPercentage: 'Duration (%)',
    Delay: 'Delay',
    Observation: 'Comment',
    PreventiveType: 'Preventive Type',
    RefuelOperatorRegistration: 'Refuel Operator Registration',
    RefuelEquipmentGroup: 'Refuel Equipment Group',
    RefuelEquipment: 'Refuel Equipment',
    RefueledEquipmentType: 'Refueled Equipment Type',
    RefueledEquipmentGroup: 'Refueled Equipment Group',
    RefueledEquipment: 'Refueled Equipment',
    RefueledOperatorGroup: 'Refueled Operator Group',
    RefueledOperator: 'Refueled Operator',
    RefuelInitialLatitude: 'Refuel Initial Latitude',
    RefuelInitialLongitude: 'Refuel Initial Longitude',
    RefuelInitialElement: 'Refuel Initial Element',
    RefuelInitialSubElement: 'Refule Initial Sub-Element',
    RefuelFinalElement: 'Refuel Final Element',
    RefuelFinalLatitude: 'Refuel Final Latitude',
    RefuelFinalLongitude: 'Refuel Final Longitude',
    RefuelFinalSubElement: 'Refule Final Sub-Element',
    RefueledHourmeterEquipment: 'Refueled Hourmeter Equipment',
    RefueledEquipmentKilometer: 'Refueled Equipment Footage',
    RefueledLiters: 'Liters Refueled',
    StopOperationTime: 'Operation Stoppage Code Time / Maint.',
    RefuelTime: 'Refuel TIme',
    RefuelIntervalTime: 'Refuel Interval Time',
    RefuelIntervalDistance: 'Refuel Interval Distance',
    ReturnDate: 'Return Date',
    ReturnTime: 'Return Time',
    ReturnLatitude: 'Return Latitude',
    ReturnLongitude: 'Return Longitude',
    ReturnAltitude: 'Return Altitude',
    ReturnElement: 'Return Element',
    ReturnSubElement: 'Return Sub-Element',
    ReturnDistance: 'Return Distance',
    ReturnDuration: 'Return Duration',
    CutDate: 'Cut Date',
    CutTime: 'Cut Time',
    CutLatitude: 'Cut Latitude',
    CutLongitude: 'Cut Longitude',
    CutAltitude: 'Cut Altitude',
    CutElement: 'Cut Element',
    CutSubElement: 'Cut Sub-Element',
    CutDistance: 'Cut Distance',
    CutDuration: 'Cut Duration',
    UnloadTime: 'Unload Time',
    UnloadTimeAB: 'U. Time',
    LoadQueueTime: 'Load Queue Time',
    LoadQueueTimeAB: 'L. Q. Time',
    UnloadQueueTime: 'Unload Queue Time',
    UnloadQueueTimeAB: 'U. Q. Time',
    LoadManeuverTime: 'Load Maneuver Time',
    LoadManeuverTimeAB: 'L. M. Time',
    UnloadManeuverTime: 'Unload Maneuver Time',
    UnloadManeuverTimeAB: 'U. M. Time',
    EmptyTrafficTime: 'Empty Traffic Time',
    EmptyTrafficTimeAB: 'E. Traffic Time',
    FullTrafficTime: 'Full Traffic Time',
    FullTrafficTimeAB: 'F. Traffic Time',
    EmptyTrafficDistance: 'Empty Traffic Distance',
    EmptyTrafficDistanceAB: 'E. Traffic Dist.',
    FullTrafficDistance: 'Full Traffic Distance',
    FullTrafficDistanceAB: 'F. Traffic Dist.',
    MaintenanceStopTime: 'Operational Stops Duration / Maintenance',
    MaintenanceStopTimeAB: 'Op. Stops Duration / Maint.',
    LoadDefault: 'Load Default',
    LoadDefaultAB: 'L. Default',
    LoadBalance: 'Load Balance (Kg)',
    LoadBalanceAB: 'L. Balance (Kg)',
    DMTRangesRegister: 'Haul Ranges Registration',
    RangeCostRegister: 'Range Cost Registration',
    ManageMoneyPerWorkedHour: 'Manage $/WH',
    EquipmentType: 'Equipment Type',
    EquipmentTypeAB: 'E. Type',
    EquipmentGroup: 'Equipment Group',
    EquipmentGroupMatch: 'Equipment Group',
    EquipmentGroupAB: 'Equipment Group',
    RangeName: 'Range Name',
    InitialM: 'Initial (m)',
    FinalM: 'Final (m)',
    InitialRangeM: 'Initial Range (meters)',
    FinalRangeM: 'Final Range (meters)',
    CostMoneyTime: 'Cost ($/t)',
    ValueMoneyTime: 'Value ($/ht)',
    CheckListItem: 'Checklist Item',
    Checklist: 'Checklist',
    ConnectChecklist: 'Associate Checklist',
    FilterByEquipmentType: 'Filter by equip. type',
    ChecklistItems: 'Checklist Items',
    ObligatoryStop: 'Mandatory Stop',
    DurationMinutes: 'Duration (minutes)',
    MaintenanceData: 'Maintenance info',
    AllocatedTrucks: 'Allocated trucks',
    ClearAllocations: 'Clear allocations',
    AvailableEquipments: 'Available equipments',
    MaintenanceEquipments: 'Maintenance equipments',
    NewAllocation: 'New allocation',
    TruckEquipments: 'Trucks',
    TruckEquipmentGroups: 'Truck groups',
    NoRegisteredAllocations: 'No registered allocations',
    DeleteAllocation: 'Delete allocation',
    Allocation: 'Allocation',
    LoadManager: 'Material Volume',
    ApplyFilterToFetchData: 'Apply filters to fetch data',
    Mapping: 'Mapping',
    Filter: 'Filter',
    Filters: 'Filters',
    LoadSchedules: 'Load Schedules',
    ShowAll: 'Show all',
    ShiftGroupConnectedToMaintenanceModule: 'Shift Group Associated To The Maintenance Module',
    NoOptions: 'No options',
    DestinationSubElement: 'Destination Sub-Element',
    LoadEquipment: 'Load Equipment',
    LoadEquipmentGroup: 'Load Equipment Group',
    TruckEquipment: 'Truck',
    TruckEquipmentGroup: 'Truck Group',
    RodNumber: 'Rod Number',
    RodPosition: 'Rod Position',
    HolePosition: 'Hole Position',
    Rod: 'Rod',
    NewSchedule: 'New Schedule',
    RpmRanges: 'RPM Ranges',
    HourmeterLimits: 'Hourmeter Limits',
    HourmeterStart: 'Hourmeter Start',
    HourmeterMax: 'Hourmeter Max',
    EquipmentStatus: 'Equipment Status',
    EquipmentStatusAbbreviated: 'Equip. Status',
    EquipmentStatusAbbreviatedV2: 'Equipment Status',
    AverageAdvance: 'Average Advance',
    InputRework: 'Rework',
    InputEffective: 'Effective',
    ConnectItems: 'Associate System Items',
    CodeTab: 'Codes',
    HourmeterTab: 'Hourmeter',
    LoadTab: 'Load',
    PerforatorTab: 'Perforator',
    RefuelerTab: 'Refueler',
    TransportTab: 'Transport',
    Transport: 'Transport',
    TractorTab: 'Tractor',
    LoaderTab: 'Loader',
    InfrastructureTab: 'Infrastructure',
    ShaftTab: 'Shaft',
    Active: 'Active',
    InpUnit: 'Inp. Unit',
    InputUnit: 'Input Unit',
    Unit: 'Unit',
    Until: 'Until',
    DailyPartsModule: 'Database',
    ManagementModule: 'Management',
    FuelModule: 'Fuel',
    ContractsModule: 'Contracts',
    UndergroundModule: 'Underground',
    OpenPitModule: 'Open Pit',
    DynamicModule: 'Dynamic',
    MaintenanceModule: 'Maintenance',
    DispatchModule: 'Dispatch',
    TelemetryModule: 'Telemetry',
    LineupModule: 'Line-Up',
    ReportModule: 'Reports',
    DateAndTurn: 'Date and Shift',
    No: 'No',
    Yes: 'Yes',
    Start: 'Start',
    Finish: 'End',
    All: 'All',
    Add: 'Add',
    Year: 'Year',
    Month: 'Month',
    Day: 'Day',
    Days: 'Days',
    DaysQuantity: 'Number of Days',
    Register: 'Register',
    Enter: 'Enter',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    NoName: 'No Name',
    NoEntries: 'No Records',
    Select: 'Select...',
    Understood: 'Understood',
    Origin: 'Origin',
    Destination: 'Destination',
    DestinationPoint: 'Destination Point',
    DestinationPointAB: 'D. Point',
    OriginPoint: 'Origin Point',
    OriginPointAB: 'O. Point',
    Name: 'Name',
    Password: 'Password',
    MaxVariation: 'Maximum Variation',
    PasswordRedefiniton: 'Password Reset',
    ConfirmPassword: 'Confirm Password',
    Description: 'Description',
    Codes: 'Codes',
    Code: 'Code',
    OriginCode: 'Origin Code',
    OriginCodeMatch: 'Current Code',
    DestinationCode: 'Destination Code',
    DestinationCodeMatch: 'Added Code',
    CodeReportTable: 'Code Report',
    CloudPointReportTable: 'Points History',
    CodeGroup: 'Code Group',
    OriginCodeGroup: 'Origin Code Group',
    DestinationCodeGroup: 'Destination Code Group',
    CodeGroups: 'Code Groups',
    CodeType: 'Code Type',
    OriginCodeType: 'Origin Code Type',
    DestinationCodeType: 'Destination Code Type',
    CodeTypes: 'Code Types',
    Visible: 'Visible',
    Equipment: 'Equipment',
    EquipmentMach: 'Equip.',
    Range: 'Range',
    Material: 'Material',
    UpperSieveOpening: 'Upper Sieve Opening',
    UpperLimitPercentage: 'Upper Limit Percentage',
    LowerSieveOpening: 'Lower Sieve Opening',
    LowerLimitPercentage: 'Lower Limit Percentage',
    TotalMassSample: 'Total Mass Sample',
    Granulometry: 'Granulometry',
    ControlSieves: 'Control Sieves',
    MaterialSpecifications: 'Material Specifications',
    ControlParams: 'Control Parameters',
    AssociationRegistry: 'Association Registry',
    MaterialsGroup: 'Materials Group',
    MaterialGroup: 'Material Group',
    Materials: 'Materials',
    NumOfBoons: 'Number of Boons',
    BitDiameter: 'Bit Diameter',
    BitDiameterSecond: 'Bit Diameter 2',
    BitDiameterName: 'Bit Diameter Name',
    BitDiameterNameSecond: 'Bit Diameter Name 2',
    Footage: 'Footage',
    RodFootage: 'Rod Footage',
    Diameter: 'Diameter',
    Element: 'Element',
    Elements: 'Elements',
    SubElement: 'Sub-Element',
    SubElements: 'Sub-Elements',
    Polygon: 'Polygon',
    Polygons: 'Polygons',
    Type: 'Type',
    Group: 'Group',
    Warning: 'Warning',
    Success: 'Success',
    Error: 'Error',
    NetworkError: 'Network Error',
    NoConnection: 'INTERNET CONNECTION FAILURE',
    DiscardChanges: 'Discard Changes',
    Discard: 'Discard',
    End: 'Finish',
    InsertNewEntries: 'Insert New Records',
    ImportSheet: 'Import Sheet',
    EditEntries: 'Edit Records',
    EditRecordsInBatches: 'Edit records in batches',
    ExportEntries: 'Export Records',
    EntryType: 'Record Type',
    Movement: 'Movement',
    MovementType: 'Movement Type',
    ProjectGroup: 'Project Group',
    Order: 'Order',
    Priority: 'Priority',
    Priorities: 'Priorities',
    UnitOperation: 'Unitary Operation',
    UnitOperationGroup: 'Unitary Operation Group',
    UnitOpGroup: 'Unitary Op. Group',
    UnitOperationTime: 'Unitary Operation Time',
    SaveData: 'Save Data',
    Save: 'Save',
    Cycle: 'Cycle',
    Cycles: 'Cycles',
    CycleId: 'Cycle ID',
    CycleTime: 'Cycle Time',
    CycleDuration: 'Cycle Duration',
    CycleType: 'Cycle Type',
    CycleInitialTime: 'Cycle Start Time',
    CycleFinalTime: 'Cycle End Time',
    CycleInitialDate: 'Cycle Start Date',
    CycleFinalDate: 'Cycle End Data',
    SaveDataAndStartNewCycle: 'Save Data and Start New Cycle',
    Comment: 'Comment',
    ClearFilters: 'Clear Filters',
    FilterBy: 'Filter By',
    NoElement: 'No Element',
    NotConnected: 'Not associated',
    Productivity: 'Productivity',
    OperationType: 'Operation Type',
    Value: 'Value',
    Operator: 'Operator',
    OperatorGroup: 'Operator Group',
    OperatorGroupAB: 'O. Group',
    OperatorTeam: 'Operator Team',
    Registration: 'Registration',
    Team: 'Team',
    Teams: 'Teams',
    TeamGroup: 'Team Group',
    TeamGroups: 'Team Groups',
    TeamsGroup: 'Teams Group',
    TeamsListing: 'Teams Listing',
    Pause: 'Pause',
    AddPause: 'Add Pause',
    Period: 'Period',
    Shift: 'Shift',
    ShiftsGroup: 'Shifts Group',
    ShiftGroup: 'Shift Group',
    ShiftRegistration: 'Shift Registration',
    ShiftSchedule: 'Shift Schedule',
    ConnectShift: 'Associate Shift',
    Color: 'Color',
    InitialDate: 'Start Date',
    StartDate: 'Start Date',
    FinalDate: 'End Date',
    StartDateTime: 'Start Date Time',
    EndDateTime: 'End Date Time',
    EndDate: 'End Date',
    EndTime: 'End Time',
    Date: 'Date',
    DateMatch: 'Initial Date/Time',
    EndDateMatch: 'End Date/Time',
    Hour: 'Time',
    InitialHour: 'Start Time',
    FinalHour: 'End Time',
    InitialTime: 'Start Time',
    FinalTime: 'End Time',
    AddEditPause: 'Add/Edit Pause',
    DayOff: 'Day Off',
    Interval: 'Interval',
    Inactive: 'Inactive',
    Weighing: 'Weighing',
    Advances: 'Advances',
    Advance: 'Advance',
    EstimatedAdvance: 'Estimated Advance',
    MeasuredAdvance: 'Measured Advance',
    Search: 'Search',
    Find: 'Find',
    ResultsFor: 'Results For',
    Pointer: 'Pointer',
    SeeMore: 'See More',
    Export: 'Export',
    EntyType: 'Record Type',
    Latitude: 'Latitude',
    Longitude: 'Longitude',
    Altitude: 'Altitude',
    InitialHourmeter: 'Initial Hourmeter',
    FinalHourmeter: 'Final Hourmeter',
    Hourmeter: 'Hourmeter',
    Initial: 'Initial',
    Final: 'Final',
    NamesVisibility: 'Names/Visibility',
    InitialHourmeterDiesel: 'Initial Hourmeter Diesel Motor',
    FinalHourmeterDiesel: 'Final Hourmeter Diesel Motor',
    InitialHourmeterElectric: 'Initial Hourmeter Electric Motor',
    FinalHourmeterElectric: 'Final Hourmeter Electric Motor',
    InitialKilometer: 'Initial Footage',
    FinalKilometer: 'Final Footage',
    HourMachine: 'Hour Machine',
    HourMachineTab: 'Hour Machine',
    BulkUpdateTransportReportTab: 'Bulk Edit',
    MaterialWeight: 'Material Weight',
    MaterialAndOrigin: 'Material and Origin',
    LoadTime: 'Load Time',
    LoadTimeAB: 'L. Time',
    IdleTime: 'Idle Time',
    Drilling: 'Drilling',
    DrillingStartTime: 'Drilling Start Time',
    DrillingStartDate: 'Drilling Start Date',
    DrillingType: 'Drilling Type',
    DrillingID: 'Drilling ID',
    DrillingCount: 'Number of Holes',
    DrillingCountSecond: 'Number of Holes 2',
    DrillingDepth: 'Hole Depth',
    DrillingDepthSecond: 'Hole Depth 2',
    DrillingDuration: 'Drilling Duration',
    DrillingInformation: 'Drilling Information',
    DrillingEquipment: 'Drilling Equipment',
    Bulldozer: 'Bulldozer',
    SleepLevel: 'Sleep Level',
    SleepLevelAB: 'S. Level',
    RailRoadTab: 'Locomotive',
    TaskCodes: 'Activities',
    TaskCodesAndAlerts: 'Activities Alerts',
    Task: 'Activity',
    TaskCodeGroup: 'Activity Group',
    TaskCodeType: 'Activity Type',
    TaskCodeItem: 'Activity Item',
    MandatoryStop: 'Mandatory stop',
    System: 'System',
    SystemItems: 'System Items',
    FailureModes: 'Failure Modes',
    ConnectFailureModes: 'Associate Failure Modes',
    FilterSystem: 'Filter System',
    FilterSystemItem: 'Filter System Items',
    UpdateApps: 'Update Apps',
    PageNotFound: 'Page Not Found',
    Tractor: 'Tractor',
    Control: 'Control',
    DailyParts: 'Database',
    Projects: 'Projects',
    UnitOp: 'Unitary Op.',
    Configuration: 'Configuration',
    ServerError: 'Server Error',
    QualityControlModule: 'Quality',
    FilterByName: 'Filter by Name',
    Standby: 'Standby',
    Flow: 'Flow',
    OriginType: 'Origin Type',
    DestinationType: 'Destination Type',
    Version: 'Version',
    UpdateToVersion: 'Update To Version',
    UpdateTablets: 'Update Tablets',
    AndroidAppVersion: 'Android App Version Manager',
    TabletConfiguration: 'Tablet Configuration',
    PlatformConfiguration: 'Platform Configuration',
    Key: 'Key',
    CurrentVersion: 'Current Version',
    User: 'User',
    Users: 'Users',
    Level: 'Level',
    PlatformLevel: 'Platform Level',
    ReportsLevel: 'Reports Level',
    InvalidPassword: 'Passwords must contain at least 8 characters and be exactly the same',
    RockFillTab: 'Fillin',
    Batch: 'Batch',
    StopTime: 'Stop time',
    EnableEdit: 'Enable Edit',
    MassEdit: 'Mass Editing',
    NotChange: 'Without Changes',
    ResetPassword: 'Reset Password',
    ResetPasswordDisclaimer: 'Are you sure you want to reset the password?',
    Parent: 'Parent',
    IsDefault: 'Is Default Model',
    Upload: 'Upload',
    Process: 'Process',
    Review: 'Review',
    LayerType: 'Layer Type',
    LayerName: 'Layer Name',
    Modules: 'Modules',
    PlatformModules: 'Platform Modules',
    LoadAllocation: 'Load Allocation',
    ScissorLiftTab: 'Scissor Lift',
    OperationActivity: 'Operating Activity',
    TotalDimension: 'Total Dimension',
    OperationTime: 'Operating Time',
    Page: 'Page',
    Table: 'Table',
    UpdateTimestamp: 'Update Timestamp',
    ControlSync: 'Control Sync',
    MassInput: 'Bulk Insertion',
    Equipament: 'Equipament',
    Plate: 'Plate',
    WeighingTare: 'Weighing Tare',
    Workflow: 'Workflow',
    VelocityLimit: 'Velocity Limit',
    None: 'None',
    FailToLoadData: 'Fail to load data',
    ReminderByTimeMinutes: 'Reminder by time (min)',
    RequestByCode: 'Request By Code',
    CodesRawTab: 'Codes',
    DatetimeStart: 'Start Datetime',
    DatetimeEnd: 'End Datetime',
    CodeMaintenanceType: 'Maintenance',
    CodeOperationalStopType: 'Operational Stop',
    CodeEffectiveType: 'Effective',
    CodeInactiveType: 'Inactive',
    CodeIdleType: 'Idle',
    Railroad_associate_material: 'Mandatory to associate at least one material',
    CyclesNumber: 'Cycles Number',
    'Commit Changes': 'Commit Changes',
    'Discard Changes': 'Discard Changes',
    Edit: 'Edit',
    Import: 'Import',
    TotalLoad: 'Total Load',
    EquipmentAllocation: 'Equipment Allocation',
    IsPersistent: 'Definitive Record',
    CicleAdvance: 'Cicle Advance',
    AdvanceRegister: 'Advance Register',
    DistanceKm: 'Distance (km)',
    StepsPerformedByAutomation: 'Steps Performed by Automation',
    LAE: 'LAE',
    OperatorLoad: 'Operator who loaded',
    LS: 'LS',
    LE: 'LE',
    US: 'US',
    UE: 'UE',
    LocalAutomationEnable: 'Local Automation Enable',
    LoadStart: 'Load Start',
    LoadEnd: 'Load End',
    UnloadStart: 'Unload Start',
    UnloadEnd: 'Unload End',
    Automatic: 'Automatic',
    Manual: 'Manual',
    transport_cycle_empty: 'Empty Transit',
    transport_cycle_full: 'Full Transit',
    transport_cycle_load_queue: 'Load Queue',
    transport_cycle_load_maneuver: 'Load Maneuver',
    transport_cycle_load: 'Load',
    transport_cycle_unload_queue: 'Unload Queue',
    transport_cycle_unload_maneuver: 'Unload Maneuver',
    transport_cycle_unload: 'Unload',
    TransportCycleStopped: 'Stopped',
    TransportCycleOverload: 'Overload',
    TransportCycleInterrupted: 'Interrupted',
    TransportCycleOpen: 'Open',
    TransportCycleChecklist: 'Checklist',
    TransportCycleDefault: 'Default',
    TransportCycleEmptyStop: 'Empty Stop',
    TransportCycleReleasedEquipment: 'Released Equipment',
    TransportCycleWeighting: 'Weighting',
    TransportCycleSupply: 'Supply',
    TransportCycleDestinationSelection: 'Destination Selection',
    TransportCycleExcavatorSelection: 'Excavator Selection',
    TransportCycleReturn: 'Return',
    TransportCycleCut: 'Cut',
    TransportCycleStrandingScreening: 'Stranding/Screening',
    HoleID: 'Hole ID',
    ShowInactive: 'Show Inactives',
    ChatBeta: 'Chat (Beta)',
    MessageRegistration: 'Message Registration',
    Message: 'Message',
    MessageCategory: 'Message Category',
    NameMessageCategory: 'Name Message Category',
    JumboTab: 'Jumbo',
    Reason: 'Reason',
    JumboExplanation: 'Reasons for the two arms Jumbo to operate with one arm',
    InactivateAllSelectedItems: 'Inactivate All Selected Items',
    RemoveAllSelectedItems: 'Remove All Selected Items',
    ClearAllSelectedItems: 'Clear All Selected Items',
    ChooseEquipmentType: 'Choose an Equipment Type',
    Frequency: 'Frequency',
    Indicators: 'Indicators',
    CodeMigrationRules: 'Code Migration Rules',
    MaxTimeInOriginCode: 'Max Time In Origin Code',
    NewCurrentDuration: 'New Current Code Duration (min)',
    NewCodeDuration: 'Durantion of the New Code (min)',
    CodesMigrations: 'Exceeded Duration Codes',
    AleatoryDurationPercentage: 'Aleatory Duration (%)',
    AleatoryProbabilityPercentage: 'Draw Probability (%)',
    Closure: 'Closure',
    ClosureDate: 'Closure Date',
    ConfirmationDate: 'Confirmation Date',
    MovementAlreadyRegistered: 'Movement already registered.',
    ReplacedEquipment: 'Equipment Replaced',
    ShowOnlyReservedEquips: 'Filter only reserved equipments',
    RegistrationSteps: 'Registration Steps',
    CargoEquipment: 'Cargo Equipment',
    RockFill: 'Rock Fill',
    Wagon: 'Wagon',
    TypesCargo: 'Truck, cargo Equipment, rock fill, is wagon',
    DataUnavailable: 'Data Unavailable',
    LoadingEquipments: 'Loading equipment',
    NumberOfTrucksAllocated: 'Number of trucks allocated',
    MaxCapacityOfAllocations: 'Max capacity of allocations',
    MaxTimeLoadingQueue: 'Max time loading queue',
    AssessmentInterval: 'Assessment interval',
    SubOrigin: 'Sub Origin',
    Restriction: 'Restriction',
    NotAllowedFor: 'not allowed for equipment',
    CodeLocation: 'Location',
    ProgrammedOrigin: 'Prog. Origin',
    ProgrammedOriginPoint: 'Prog. Origin P.',
    ProgrammedMaterial: 'Prog. Material',
    ProgrammedDestinationPoint1st: '1st Prog. Destination P.',
    ProgrammedDestinationPoint2nd: '2nd Prog. Destination P.',
    Rows: 'Rows',
    EditField: 'Edit field',
    EditFields: 'Edit fields',
    NewValue: 'New Value',
    Visibility: 'Visibility',
    InvisibleForAll: 'Invisible to all',
    VisibleForAll: 'Visible to all',
    VisibleOperation: 'Visible operation',
    VisibleChecklist: 'Visible pre-checklist',
    SubElementType: 'Subelement Type',
    ScreensNumber: 'Screens number',
    SearchFor: 'Search for',
    EditHistory: 'Edit history',
    EditHistoryDatetime: 'Edit date/time',
    Editor: 'Editor',
    RouteHistory: 'Route',
    NoFilterMessage: 'No Equipment and/or Equipment Group filter',
    FilteredEquipment: 'Filtered Equipment',
    FilteredEquipmentGroups: 'Filtered Equipment Groups',
    UnlockPassword: 'Unlock Password',
    UnlockPasswordValidUntil: 'The unlock password is valid until',
    ShowPassword: 'Show password',
    Preview: 'Preview',
    CurrentlyInUse: 'Currently in use',
    Icon: 'Icon',
    CodeIcon: 'Code Icon',
    Dispatch: 'Dispatch',
    Chat: 'Chat',
    GotIn: 'got in',
    SentMessage: 'enviou mensagem',
    MessageGroupsBeta: 'Message Groups (Beta)',
    GroupsConfiguration: 'Groups Configuration',
    AddGroup: 'Add Group',
    MessageGroupName: 'Message Group Name',
    ConfirmActivateMessageGroup: 'Are you sure you want to ACTIVATE the message group',
    ConfirmDeactivateMessageGroup: 'Are you sure you want to DEACTIVATE the message group',
    MessageGroups: 'Message Groups',
    SendMessagesToGroup: 'Send messages to group',
    SendMessage: 'Send Message',
    FilterEquipment: 'Filter Equipment',
    SendToGroup: 'Send to group',
    discardChanges: 'Descartar alterações',
    DMT: 'Haul',
    LastTimestampUpdate: 'Last Update Timestamp',
    Standard: 'Standard',
    Updated: 'Updated',
    DuplicatedPlate: 'Plate already registered',
    SelectEquipmentType: 'Select equipment type',
    DistanceInEmptyTraffic: 'Distance in Empty Traffic',
    DistanceInFullTraffic: 'Distance in Heavy Traffic',
    FieldsForEditing: 'Fill in the fields you want to change (blank fields will not be modified):',
    BulkEdit: 'Bulk Edit',
    TotalOf: 'Total of',
    ChangedResults: 'results selected for change',
    OriginalPoint: 'Point of Origin',
    BulkUpdate: 'Confirm bulk edit',
    ConfirmContinue: 'Do you want to continue?',
    BulkUpdateInstructions: 'To edit more rows, navigate through the pages to load additional data. Interrupted and deleted cycles will not be considered.',
    InsertValue: 'Insert value',
    RowRangeToEdit: 'Choose the range of rows you want to change:',
    NumberOfLinesEdited: 'Number of lines to be edited:',
    FuelScreen: 'Fuel level screen',
    FuelLevel: 'Fuel level',
    ItMoves: 'Allowed in motion',
    Type: 'Type',
    Group: 'Group',
    NoAvailableData: 'There is no data available for the selected filters',
    QuantityEquipmentPerGroup: 'Quantity of equipment per group',
    DefaultValue: 'Deafult value',
    EquipmentSituation: 'Equipment Status',
    Situation: 'Situation',
    EnterText: 'Enter the text...',
    ValidUntil: 'Valid until',
    DateAndTime: 'Date and time',
    ProgrammingDuration: 'Programming duration',
    TypeAMessage: 'Type a message...',
    DynamicAllocationAbrev: 'Dynamic Alloc.',
    EnableAllDynamicAlloc: 'Enable all dynamic allocation',
    DisableAllDynamicAlloc: 'Disable all dynamic allocation',
    BulkConfigDynamicAlloc: 'Bulk configuration dynamic allocation',
    WorkfaceControl: 'Workface Control',
    CodeAndCodeDuration: 'Code and code duration',
    CodeDateAndTime: 'Code date and time',
    Highlight: 'Highlight',
    CyclesNumberKanban: 'Number of cycles',
    Legend: 'Legend',
    StartDateAndTime: 'Start date and time',
    Cycles: 'Cycles',
    NoColumnsAvailable: 'No columns available',
    Detonation: 'Detonation',
    Attention: 'Attention',
    Favorite: 'Favorite',
    ExpediteModule: 'Expedition',
    ExternalMaterialId: 'External Material ID',
    EntryDateAndTime: 'Entry Date/Time',
    ExitDateAndTime: 'Exit Date/Time',
    NetWeight: 'Net Weight',
    OriginLot: 'Origin Lot',
    TicketNumber: 'Ticket Number',
    HideDeletedOrders: 'Hide deleted orders',
    InOperation: 'In Operation',
    Company: 'Company',
    AttentionAlert: 'ATTENTION',
    ChangeWillBeSent: 'The change will be sent to the application.',
    OperatorWillReceiveMessageAlert: 'If this update is more recent than the one currently in the application, the operator will receive an alert notifying them of the status change.',
    DoYouWantToContinue: 'Do you want to continue?',
    InvisibleCodeAlert: 'This code is invisible on the tablet, so it will not be sent to it.',
    OnlyVisibleOnPlatform: 'It only reflects on the Platform.',
    ToSendTurnOnVisible: 'To send it to the tablet, make it visible and update the tablet structure.',
    EquipmentStatusAlertInvisibleCode: 'ATTENTION! The code is invisible to all. Do you want to continue?',
    Continue: 'Continue',
    Back: 'Back',
    Tube: 'Tube',
    GrindingWheel: 'Grinding Wheel',
    ShockAbsorber: 'Shock Absorber',
    Hammer: 'Hammer',
    Rod: 'Rod',
    BitHolder: 'Bit Holder',
    Breech: 'Breech',
    Handle: 'Handle',
  },
  ptbr: {
    AnalysisType: 'Tipo de Análise',
    Global: 'Global',
    Local: 'Parcial',
    Sieve: 'Peneira',
    TotalMassSample: 'Massa Total da Amostra',
    Granulometry: 'Granulometria',
    ParticleSieveOpenings: 'Aberturas de Peneira de Partículas',
    SieveOpening: 'Abertura da Peneira',
    CodeMigrations: 'Migração de Códigos',
    CodeMigrationsDynamic: 'Migração de Códigos (Dynamic)',
    UnavailableModule: 'Módulo Não Contratado',
    KnowMore: 'Saiba mais',
    Settings: 'Configurações',
    Logout: 'Sair',
    MiningControl: 'Mining Control',
    WelcomeTo: 'Bem-vindo à plataforma',
    Parameter: 'Parâmetro',
    EquipmentConfigurations: 'Configurações de Equipamentos',
    GeneralConfigurations: 'Configurações Gerais',
    CyclesAutomation: 'Automação de Ciclos',
    ControlType: 'Tipo de Controle',
    Front: 'Frente',
    Equipments: 'Equipamentos',
    ReserveEquipment: 'Equipamento Reserva',
    PerforatorSchedules: 'Programação Perfuração',
    EffectiveSchedules: 'Programação Efetivo',
    InactiveTurnPersistency: 'Persistência em Turno Inativo',
    RainMode: 'Modo Chuva',
    ToggleRainMode: 'Ativar Modo Chuva',
    SpeedLimit: 'Limite de Velocidade',
    Issue: 'Problema',
    Accept: 'Aceitar',
    ScreenCount: 'Quantidade de Telas',
    NumberOfArches: 'Número de Cavilhas',
    NumberOfLatticeGirders: 'Número de Chapas',
    NumberOfDowels: 'Número de Cavilhas',
    NumberOfSheets: 'Número de Chapas',
    CrusherTab: 'Britador',
    CrusherTime: 'Tempo de Britagem',
    CrusherStopTime: 'Tempo de Parada',
    Source: 'Fonte',
    FeatureInDevelopment: 'Teste a nova funcionalidade em desenvolvimento',
    LastServerConnection: 'Última Conexão com o Servidor',
    LastDataSent: 'Últimos Dados Enviados',
    DiconnectedTime: 'Tempo de Desconexão',
    DataToSend: 'Dados para Enviar',
    AddEditAllocation: 'Adicionar/Editar Alocação',
    EditEquipmentScheduling: 'Editar Programação de Equipamento',
    Class: 'Classe',
    Goals: 'Metas',
    GoalsBETA: 'Metas (BETA)',
    Planning: 'Planejamento',
    Short: 'Curto',
    Medium: 'Médio',
    Long: 'Longo',
    Production: 'Produção',
    State: 'Estado',
    GoalTypes: 'Tipos de Metas',
    Goal: 'Meta',
    Granularity: 'Granularidade',
    DefinitiveNote: 'Registro Definitivo',
    ValueType: 'Tipo de Valor',
    Number: 'Número',
    TotalTimeInCode: 'Tempo Total em Código',
    FullDistance: 'Distância Cheio',
    EmptyDistance: 'Distância Vazio',
    LoadLatitude: 'Latitude Carregamento',
    LoadLongitude: 'Longitude Carregamento',
    LoadAltitude: 'Altitude Carregamento',
    UnloadLatitude: 'Latitude Descarregamento',
    UnloadLongitude: 'Longitude Descarregamento',
    UnloadAltitude: 'Altitude  Descarregamento',
    LoadEquipmentNumber: 'Nº de Equip. de Carga',
    CycleStageTimes: 'Tempos das Etapas do Ciclo',
    StandardLoad: 'Carga padrão',
    Step: 'Etapa',
    railroad_cycle_time_port_exit: 'Manobra de Saída do Porto',
    railroad_cycle_time_empty: 'Circulação Trem Vazio',
    railroad_cycle_time_load_entry: 'Manobra de Entrada na Mina',
    railroad_cycle_time_load_queue: 'Fila de Carregamento',
    railroad_cycle_time_load: 'Carregamento',
    railroad_cycle_time_load_exit: 'Manobra de Saída da Mina',
    railroad_cycle_time_full: 'Circulação Trem Carregado',
    railroad_cycle_time_port_entry: 'Manobra de Entrada no Porto',
    railroad_cycle_time_unload_queue: 'Fila de Descarregamento',
    railroad_cycle_time_unload: 'Descarregamento',
    TotalInCode: 'tempo total em código',
    LoadingEquipment: 'Nº Equipamentos de carga',
    Finalize: 'Finalizar',
    ConfirmChanges: 'Confirmar alterações?',
    Text: 'Texto',
    ThereAreNoChanges: 'Não há alterações',
    AutoAllocationLogs: 'Logs Aloc. Dinamica',
    AllocationEdit: 'Edição de Alocação',
    DynamicAllocationExplanation: 'Determina se a funcionalidade de alocação dinâmica deve contemplar esta alocação',
    AllocationGroupExplanation: 'Define a qual grupo de alocação de cada equipamento de carga pertence',
    MinAllocationCapacityExplanation: 'Define uma capacidade mínima de equipamentos de transporte em uma escavadeira​',
    MaxAllocationCapacityExplanation: 'Define uma capacidade máxima de equipamentos de transporte permitidos em uma escavadeira e bloqueia novas alocações automáticas à escavadeira enquanto não haver um slot disponível​',
    MaxLoadQueueTimeExplanation: 'Tempo máximo de fila que o equipamento de carregamento pode ter, valores acima disso ativam a alocação dinâmica',
    TaskCodesAndAlerts: 'Atividades e Alertas',
    MeanQueueTimeRangeExplanation: 'Janela de tempo em minutos para calcular tempo de fila médio para uma escavadeira',
    MinPermanentAllocationCyclesExplanation: 'Quantidade mínima de ciclos que o caminhão deve ficar em sua alocação permanente, antes de ser alocado temporariamente',
    MaxTemporaryAllocationCyclesExplanation: 'Quantidade máxima de ciclos que o caminhão deve ficar em alocações temporárias, antes de ser obrigado a retornar para sua alocação permanente',
    MinAllocationCapacityExplanation: 'Define uma capacidade mínima de equipamentos de transporte em uma escavadeira',
    MinAllocationCapacity: 'Capacidade mín. de Alocações',
    DynamicAllocation: 'Alocação dinâmica',
    MaxAllocationCapacity: 'Capacidade max. de alocações',
    MaxLoadQueueTime: 'Tempo max. de fila de carregamento (min)',
    MeanQueueTimeRange: 'Intervalo de avaliação de fila (min)',
    MinimumPermanentAllocationCycles: 'Minimo de ciclos na alocação permanente',
    MaximumTemporaryAllocationCycles: 'Máximo de ciclos na alocação temporária',
    Resources: 'Recursos',
    Elevation: 'Elevação',
    FilterByElevation: 'Filtrar por elevação',
    DependentElements: 'Elementos dependentes',
    DependentSubElements: 'Sub-elementos dependentes',
    Precedences: 'Precedências',
    CalculatePrecedences: 'Calcular precedências',
    MineAvailability: 'Disponibilidade de lavra',
    AvailableMass: 'Massa disponível (t)',
    ScenarioInConfiguration: 'Cenário em configuração',
    Configure: 'Configurar',
    AppliedToAllocations: 'Aplicado às alocações',
    AllocationGroup: 'Grupo de alocação',
    MaxQueueTime: 'Tempo máximo de fila (min)',
    Elevations: 'Elevações',
    ElevationGroups: 'Grupos de elevação',
    ElevationGroup: 'Grupo de elevação',
    ElementLimits: 'Limites de Elementos',
    ElevationsAssociatedToTheElement: 'Elevações associadas ao elemento',
    InitialElevation: 'Elevação inicial',
    FinalElevation: 'Elevação final',
    Creation: 'Criação',
    Current: 'Atual',
    LoadScenarioToContinue: 'Carregue um cenário para continuar',
    Loaded: 'Carregado',
    LoadAction: 'Carregar',
    FilterByDate: 'Filtrar por data',
    ElementsAssociatedToTheScenario: 'Elementos associados ao cenário',
    SubelementsAssociatedToTheScenario: 'Subelementos associados ao cenário',
    LineupNewSchedule: 'Line-up: Nova programação',
    LineupPlanning: 'Line-up: Planejamento',
    Scenarios: 'Cenários',
    Empty: 'Vazio',
    Full: 'Cheio',
    Queue: 'Fila',
    Maneuver: 'Manobra',
    Dump: 'Basculamento',
    Stop: 'Parada',
    NotStarted: 'Não iniciada',
    Disapproved: 'Reprovada',
    Paused: 'Pausada',
    InProgress: 'Em andamento',
    OnApproval: 'Em aprovação',
    Finalized: 'Finalizada',
    DeleteSchedule: 'Apagar Programação',
    Time: 'Hora',
    MassT: 'Massa (t)',
    Closings: 'Fechamentos',
    ClosingsList: 'Lista de fechamentos',
    Condition: 'Condição',
    Entry: 'Entrada',
    LoginLogout: 'Login/Logout',
    StockClosings: 'Fechamentos de estoque',
    Velocity: 'Velocidade',
    AllocationMode: 'Modo de alocação',
    Permanent: 'Permanente',
    Standard: 'Padrão',
    Temporary: 'Temporário',
    AllocatedTo: 'Alocado para',
    CurrentElement: 'Elemento atual',
    CurrentElementPoint: 'Subelemento atual',
    CurrentCycleStep: 'Etapa do ciclo atual',
    OriginSubElement: 'Subelemento de origem',
    AllocateTo: 'Alocar para',
    LastModified: 'Última alteração',
    Origins: 'Origens',
    Destinations: 'Destinos',
    Category: 'Categoria',
    Input: 'Insumo',
    MaintenanceType: 'Tipo de Manutenção',
    MaintenanceGroup: 'Grupo de Manutenção',
    Maintenance: 'Manutenção',
    SelectAll: 'Selecionar todos',
    HideInterruptedOrDeletedCycles: 'Ocultar ciclos interrompidos ou excluídos',
    HideDeletedEvents: 'Esconder eventos deletados',
    FilterByEquipmentGroup: 'Filtrar por Grupo de Equipamento',
    FilterByMaterial: 'Filtrar por Material',
    ShiftGroupConnectedToUndergroundModule: 'Grupo de turno associado ao módulo Underground',
    ShiftGroupConnectedToOpenPitModule: 'Grupo de turno associado ao módulo Open Pit',
    FilterByShiftGroup: 'Filtrar Por Grupo de Turno',
    NumberOfIntervals: 'Número de Intervalos',
    RpmNoRotation: 'RPM Sem Rotação (início)',
    RpmSlowRunning: 'RPM Marcha Lenta (início)',
    RpmHighSpin: 'RPM Rotação Alta (início)',
    RpmOperation: 'RPM Operação (início)',
    Content: 'Teor',
    ContentVariables: 'Gerenciar Teores',
    Associations: 'Associações',
    AssociationsList: 'Listagem de Associações',
    ConnectSubElements: 'Associar sub-elementos',
    FilterByProjectGroup: 'Filtrar por grupo de projeto',
    FilterByElement: 'Filtrar por elemento',
    OriginSubElements: 'Sub-elementos de origem',
    OperationalControl: 'Controle Operacional',
    OperationalStop: 'Parada Operacional',
    Operation: 'Operando',
    AnomalyLogs: 'Registros de Anomalias',
    AnomalyType: 'Tipo de anomalia',
    Anomaly: 'Anomalias',
    AnomalousTable: 'Tabela anômala',
    Occurrences: 'Ocorrências',
    Registers: 'Registros',
    CodeTime: 'Tempo de Código',
    MonthlyAdvance: 'Avanço Mensal',
    MonthlyAdvanceMeters: 'Avanço Mensal (metros)',
    MaintenanceLogoutLimit: 'Maintenance Logout Limit',
    SelectMaintenanceLogoutLevel: 'Select the logout level for maintenance',
    ClearCache: 'Limpar cache',
    DisableCache: 'Desabilitar cache',
    AccessYourAccount: 'Acesse sua conta',
    AverageLoad: 'Carga Média',
    Load: 'Carregamento',
    LoadFactor: 'Fator de carga',
    Welcome: 'Seja bem-vindo à Plataforma Mining Control',
    RefuellingPerEquipment: 'Abastecimento por Equipamento',
    RemainingLitersAlarm: 'Alarme de Litros Restantes',
    ConnectCodes: 'Associar Códigos',
    GreenPercentage: 'Verde (%)',
    YellowPercentage: 'Amarelo (%)',
    RedPercentage: 'Vermelho (%)',
    PurplePercentage: 'Roxo (%)',
    FilterByEquipType: 'Filtrar por Tipo de Equip.',
    FilterByEquipGroup: 'Filtrar por grupo de equip.',
    TankCapacityLiters: 'Capacidade Tanque (litros)',
    LitersPerHourConsumption: 'Consumo (litros/hora)',
    MapElement: 'Mapear Elemento',
    MapMaterial: 'Mapear Material',
    OriginPlural: 'Origem(s)',
    DestinationPlural: 'Destino(s)',
    FilterOriginElements: 'Filtrar Elementos de Origem',
    FilterDestinationElements: 'Filtrar Elementos de Destino',
    FireID: 'ID Fogo',
    FireDescription: 'Descrição Fogo',
    HoleType: 'Tipo de Furo',
    HoleMeters: 'Haste',
    Fan: 'Leque',
    FanName: 'Nome do Leque',
    OriginElement: 'Elemento de Origem',
    SubOriginElement: 'Sub-Elemento de Origem',
    DestinationElement: 'Elemento de Destino',
    SubDestinationElement: 'Sub-Elemento de Destino',
    DMTMeters: 'DMT (metros)',
    EquipScheduling: 'Programação',
    EquipmentScheduling: 'Programação de Equipamento',
    PendenciesApproval: 'Aprovação de Pendências',
    Approve: 'Aprovar',
    Duration: 'Duração',
    DurationMatch: 'Duração Atual (min)',
    DurationPercentage: 'Duração (%)',
    Delay: 'Atraso',
    Observation: 'Observação',
    PreventiveType: 'Tipo de Preventiva',
    RefuelOperatorRegistration: 'Matrícula Operador Abastecimento',
    RefuelEquipmentGroup: 'Grupo Equipamento Abastecimento',
    RefuelEquipment: 'Equipamento Abastecimento',
    RefueledEquipmentType: 'Tipo Equipamento Abastecido',
    RefueledEquipmentGroup: 'Grupo Equipamento Abastecido',
    RefueledEquipment: 'Equipamento Abastecido',
    RefueledOperatorGroup: 'Grupo do Operador Abastecido',
    RefueledOperator: 'Operador Abastecido',
    RefuelInitialLatitude: 'Latitude Início Abastecimento',
    RefuelInitialLongitude: 'Longitude Início Abastecimento',
    RefuelInitialElement: 'Elemento Início Abastecimento',
    RefuelInitialSubElement: 'Sub-Elemento Início Abastecimento',
    RefuelFinalElement: 'Elemento Fim Abastecimento',
    RefuelFinalLatitude: 'Latitude Fim Abastecimento',
    RefuelFinalLongitude: 'Logitude Fim Abastecimento',
    RefuelFinalSubElement: 'Sub-Elemento Fim Abastecimento',
    RefueledHourmeterEquipment: 'Horímetro Equipamento Abastecido',
    RefueledEquipmentKilometer: 'Quilometragem Equipamento Abastecido',
    RefueledLiters: 'Litragem Abastecida',
    StopOperationTime: 'Tempo Em Código de Parada Operação / Manut',
    RefuelTime: 'Tempo Abastecimento',
    RefuelIntervalTime: 'Tempo Intervalo Abastecimento',
    RefuelIntervalDistance: 'Distância Intervalo Abastecimento',
    ReturnDate: 'Data de Retorno',
    ReturnTime: 'Hora de Retorno',
    ReturnLatitude: 'Latitude do Retorno',
    ReturnLongitude: 'Longitude do Retorno',
    ReturnAltitude: 'Altitude do Retorno',
    ReturnElement: 'Elemento do Retorno',
    ReturnSubElement: 'Sub-Elemento do Retorno',
    ReturnDistance: 'Distância do Retorno',
    ReturnDuration: 'Duração do Retorno',
    CutDate: 'Data de Corte',
    CutTime: 'Hora de Corte',
    CutLatitude: 'Latitude do Corte',
    CutLongitude: 'Longitude do Corte',
    CutAltitude: 'Altitude do Corte',
    CutElement: 'Elemento do Corte',
    CutSubElement: 'Sub-Elemento do Corte',
    CutDistance: 'Distância de Corte',
    CutDuration: 'Tempo de Corte',
    UnloadTime: 'Tempo de Basculamento',
    UnloadTimeAB: 'T. de Basculamento',
    LoadQueueTime: 'Tempo de Fila de Carr.',
    LoadQueueTimeAB: 'T. de Fila de Carr.',
    UnloadQueueTime: 'Tempo de Fila de Basculamento',
    UnloadQueueTimeAB: 'T. de Fila de Desc.',
    LoadManeuverTime: 'Tempo de Manobra de Carregamento',
    LoadManeuverTimeAB: 'T. de Man. de Carr.',
    UnloadManeuverTime: 'Tempo de Manobra de Basculamento',
    UnloadManeuverTimeAB: 'T. de Man. de Basc.',
    EmptyTrafficTime: 'Tempo de Trânsito Vazio',
    EmptyTrafficTimeAB: 'T. de Trâns. Vazio',
    FullTrafficTime: 'Tempo de Trânsito Cheio',
    FullTrafficTimeAB: 'T. de Trâns. Cheio',
    EmptyTrafficDistance: 'Distância de Deslocamento em Trânsito Vazio',
    EmptyTrafficDistanceAB: 'D. de Desloc. em Trâns. Vazio',
    FullTrafficDistance: 'Distância de Deslocamento em Trânsito Cheio',
    FullTrafficDistanceAB: 'D. de Desloc. em Trâns. Cheio',
    MaintenanceStopTime: 'Tempo de Paradas Operacionais / Manutenção',
    MaintenanceStopTimeAB: 'T. de Paradas Op. / Man.',
    LoadDefault: 'Carga Padrão',
    LoadDefaultAB: 'C. Padrão',
    LoadBalance: 'Carga Pesagem (Kg)',
    LoadBalanceAB: 'C. Pesagem (Kg)',
    DMTRangesRegister: 'Cadastro de faixas de DMT',
    RangeCostRegister: 'Cadastro de custo por faixa',
    ManageMoneyPerWorkedHour: 'Gerenciar R$/HT',
    EquipmentType: 'Tipo de Equipamento',
    EquipmentTypeAB: 'T. de Equipamento',
    EquipmentGroup: 'Grupo de Equipamento',
    EquipmentGroupMatch: 'Grupo de Equip.',
    EquipmentGroupAB: 'G. de Equipamento',
    RangeName: 'Nome Faixa',
    InitialM: 'Inicial (m)',
    FinalM: 'Final (m)',
    InitialRangeM: 'Faixa Inicial (metros)',
    FinalRangeM: 'Faixa Final (metros)',
    CostMoneyTime: 'Custo (R$/t)',
    ValueMoneyTime: 'Valor (R$/ht)',
    Checklist: 'Checklist',
    CheckListItem: 'Item de Checklist',
    ConnectChecklist: 'Associar Checklist',
    FilterByEquipmentType: 'Filtrar por tipo de equip.',
    ChecklistItems: 'Itens de Checklist',
    ObligatoryStop: 'Parada obrigatória',
    DurationMinutes: 'Duração (minutos)',
    MaintenanceData: 'Dados de manutenção',
    AllocatedTrucks: 'Caminhões alocados',
    ClearAllocations: 'Limpar alocações',
    AvailableEquipments: 'Equipamentos disponíveis',
    MaintenanceEquipments: 'Equipamentos em manutenção',
    NewAllocation: 'Nova alocação',
    TruckEquipments: 'Caminhões',
    TruckEquipmentGroups: 'Grupos de Caminhão',
    NoRegisteredAllocations: 'Nenhuma alocação cadastrada',
    DeleteAllocation: 'Excluir alocação',
    Allocation: 'Alocação',
    LoadManager: 'Volume de Material',
    ApplyFilterToFetchData: 'Aplique filtros para buscar dados',
    Mapping: 'Mapeamento',
    Filter: 'Filtrar',
    Filters: 'Filtros',
    LoadSchedules: 'Programação Carga',
    ShowAll: 'Exibir tudo',
    ShiftGroupConnectedToMaintenanceModule: 'Grupo de turno associado ao módulo Manutenção',
    NoOptions: 'Nenhuma opção',
    DestinationSubElement: 'Sub-Elemento de Destino',
    LoadEquipment: 'Equipamento de Carga',
    LoadEquipmentGroup: 'Grupo de Equip. de Carga',
    TruckEquipment: 'Caminhão',
    TruckEquipmentGroup: 'Grupo de Caminhão',
    RodNumber: 'Número de Hastes',
    RodPosition: 'Posição da Haste',
    HolePosition: 'Posição do Furo',
    Rod: 'Haste',
    NewSchedule: 'Nova Programação',
    RpmRanges: 'Faixas RPM',
    HourmeterLimits: 'Limítes de Horímetro',
    HourmeterStart: 'Horímetro Inicial',
    HourmeterMax: 'Horímetro Máximo',
    EquipmentStatus: 'Situação de Equipamento',
    EquipmentStatusAbbreviated: 'Situação Equip.',
    EquipmentStatusAbbreviatedV2: 'Status de Equipamento',
    AverageAdvance: 'Avanço Médio',
    InputRework: 'Retrabalho',
    InputEffective: 'Efetivo',
    ConnectItems: 'Associar Itens de Sistema',
    CodeTab: 'Códigos',
    HourmeterTab: 'Horímetro',
    LoadTab: 'Carga',
    PerforatorTab: 'Perfuratriz',
    RefuelerTab: 'Abastecimento',
    TransportTab: 'Transporte',
    Transport: 'Transporte',
    TractorTab: 'Trator',
    LoaderTab: 'Carregadeira',
    InfrastructureTab: 'Infraestrutura',
    ShaftTab: 'Shaft',
    Active: 'Ativo',
    InpUnit: 'Un. de Insumo',
    InputUnit: 'Unidade de Insumo',
    Unit: 'Unidade',
    Until: 'Até',
    DailyPartsModule: 'Partes Diárias',
    ManagementModule: 'Gerenciamento',
    FuelModule: 'Combustível',
    ContractsModule: 'Contratos',
    UndergroundModule: 'Underground',
    OpenPitModule: 'Open Pit',
    DynamicModule: 'Dynamic',
    MaintenanceModule: 'Manutenção',
    DispatchModule: 'Despacho',
    TelemetryModule: 'Telemetria',
    LineupModule: 'Line-Up',
    ReportModule: 'Relatórios',
    DateAndTurn: 'Data e Turno',
    No: 'Não',
    Yes: 'Sim',
    Start: 'Início',
    Finish: 'Fim',
    All: 'Todos',
    Add: 'Adicionar',
    Year: 'Ano',
    Month: 'Mês',
    Days: 'Dias',
    Day: 'Dia',
    DaysQuantity: 'Quantidade de Dias',
    Register: 'Cadastrar',
    Enter: 'Entrar',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    NoName: 'Sem nome',
    NoEntries: 'Sem registros',
    Select: 'Selecionar...',
    Understood: 'Entendi',
    Origin: 'Origem',
    Destination: 'Destino',
    DestinationPoint: 'Ponto de Destino',
    DestinationPointAB: 'P. de Destino',
    OriginPoint: 'Ponto de Origem',
    OriginPointAB: 'P. de Origem',
    Name: 'Nome',
    Password: 'Senha',
    MaxVariation: 'Variação Máxima',
    PasswordRedefiniton: 'Redefinição de senha',
    ConfirmPassword: 'Confirmação de senha',
    Description: 'Descrição',
    Codes: 'Códigos',
    Code: 'Código',
    OriginCode: 'Código de Origem',
    OriginCodeMatch: 'Código Atual',
    DestinationCode: 'Código de Destino',
    DestinationCodeMatch: 'Código Adicionado',
    CodeReportTable: 'Registro de Estados',
    CloudPointReportTable: 'Histórico de Pontos',
    CodeGroup: 'Grupo de Código',
    OriginCodeGroup: 'Grupo de Código de Origem',
    DestinationCodeGroup: 'Grupo de Código de Destino',
    CodeGroups: 'Grupos de Código',
    CodeType: 'Tipo de Código',
    OriginCodeType: 'Tipo de Código de Origem',
    DestinationCodeType: 'Tipo de Código de Destino',
    CodeTypes: 'Tipos de Código',
    Visible: 'Visível',
    Equipment: 'Equipamento',
    EquipmentMach: 'Equip.',
    Range: 'Faixa',
    Material: 'Material',
    UpperSieveOpening: 'Abertura de Peneira Superior',
    UpperLimitPercentage: 'Percentual Limite Superior',
    LowerSieveOpening: 'Abertura de Peneira Inferior',
    LowerLimitPercentage: 'Percentual Limite Inferior',
    ControlSieves: 'Peneiras de Controle',
    MaterialSpecifications: 'Especificações do Material',
    ControlParams: 'Parâmetros de Controle',
    AssociationRegistry: 'Cadastro de Associação',
    MaterialsGroup: 'Grupo de Materiais',
    MaterialGroup: 'Grupo do Material',
    Materials: 'Materiais',
    NumOfBoons: 'Nº de Braços',
    BitDiameter: 'Diâmetro Bit',
    BitDiameterSecond: 'Diâmetro Bit 2',
    BitDiameterName: 'Nome Diâmetro Bit',
    BitDiameterNameSecond: 'Nome Diâmetro Bit 2',
    Footage: 'Metragem',
    RodFootage: 'Metragem da Haste',
    Diameter: 'Diâmetro',
    Element: 'Elemento',
    Elements: 'Elementos',
    SubElement: 'Sub-Elemento',
    SubElements: 'Sub-Elementos',
    Polygon: 'Polígono',
    Polygons: 'Polígonos',
    Type: 'Tipo',
    Group: 'Grupo',
    Warning: 'Aviso',
    Success: 'Sucesso',
    Error: 'Erro',
    NetworkError: 'Erro de Rede',
    NoConnection: 'FALHA DE CONEXÃO COM A INTERNET',
    DiscardChanges: 'Descartar Alterações',
    End: 'Finalizar',
    InsertNewEntries: 'Inserir Novos Registros',
    ImportSheet: 'Importar Planilha',
    EditEntries: 'Editar Registros',
    EditRecordsInBatches: 'Editar Registros em Lotes',
    ExportEntries: 'Exportar Registros',
    EntryType: 'Tipo de Registro',
    Movement: 'Movimentação',
    MovementType: 'Tipo de Movimentação',
    ProjectGroup: 'Grupo de Projeto',
    Order: 'Ordem',
    Priority: 'Prioridade',
    Priorities: 'Prioridades',
    UnitOperation: 'Operação Unitária',
    UnitOperationGroup: 'Grupo de Operação Unitária',
    UnitOpGroup: 'Grupo de Op. Unitária',
    UnitOperationTime: 'Tempo de Operação Unitária',
    SaveData: 'Salvar Dados',
    Save: 'Salvar',
    Cycle: 'Ciclo',
    Cycles: 'Ciclos',
    Discard: 'Descartar',
    CycleId: 'ID do Ciclo',
    CycleTime: 'Tempo de Ciclo',
    CycleDuration: 'Duração do Ciclo',
    CycleType: 'Tipo de Ciclo',
    CycleInitialTime: 'Hora do Início do Ciclo',
    CycleFinalTime: 'Hora do Fim do Ciclo',
    CycleInitialDate: 'Data do Início do Ciclo',
    CycleFinalDate: 'Data do Fim de Ciclo',
    SaveDataAndStartNewCycle: 'Salvar Dados e Iniciar Novo Ciclo',
    Comment: 'Comentário',
    ClearFilters: 'Limpar filtros',
    FilterBy: 'Filtrar Por',
    NoElement: 'Sem elemento',
    NotConnected: 'Não associado',
    Productivity: 'Produtividade',
    OperationType: 'Tipo de Operação',
    Value: 'Valor',
    Operator: 'Operador',
    OperatorGroup: 'Grupo de Operador',
    OperatorGroupAB: 'G. de Operador',
    OperatorTeam: 'Turma do Operador',
    Registration: 'Matrícula',
    Team: 'Turma',
    Teams: 'Turmas',
    TeamGroup: 'Grupo de Turma',
    TeamGroups: 'Grupos de Turma',
    TeamsGroup: 'Grupo de Turmas',
    TeamsListing: 'Listagem de Turmas',
    RailRoadTab: 'Locomotiva',
    Pause: 'Pausa',
    AddPause: 'Adicionar Pausa',
    Period: 'Período',
    Shift: 'Turno',
    ShiftsGroup: 'Grupo de Turnos',
    ShiftGroup: 'Grupo de Turno',
    ShiftRegistration: 'Cadastro de Turno',
    ShiftSchedule: 'Escala de Turno',
    ConnectShift: 'Associar Turno',
    Color: 'Cor',
    InitialDate: 'Data Inicial',
    StartDate: 'Data Início',
    FinalDate: 'Data Final',
    StartDateTime: 'Data e hora inicial',
    EndDateTime: 'Data e hora final',
    EndDate: 'Data Fim',
    EndTime: 'Hora Fim',
    Date: 'Data',
    DateMatch: 'Data/Hora Inicial',
    EndDateMatch: 'Data/Hora Final',
    Hour: 'Hora',
    InitialHour: 'Hora Inicial',
    FinalHour: 'Hora Final',
    InitialTime: 'Hora Início',
    FinalTime: 'Hora Fim',
    AddEditPause: 'Adicionar/Editar Pausa',
    DayOff: 'Folga',
    Interval: 'Intervalo',
    Inactive: 'Inativo',
    Weighing: 'Pesagem',
    Advances: 'Avanços',
    Advance: 'Avanço',
    EstimatedAdvance: 'Avanço Estimado',
    MeasuredAdvance: 'Avanço Medido',
    Search: 'Pesquisar',
    Find: 'Buscar',
    ResultsFor: 'Resultados para',
    Pointer: 'Apontador',
    SeeMore: 'Ver Mais',
    Export: 'Exportar',
    EntyType: 'Tipo de Registro',
    Latitude: 'Latitude',
    Longitude: 'Longitude',
    Altitude: 'Altitude',
    InitialHourmeter: 'Horímetro Inicial',
    FinalHourmeter: 'Horímetro Final',
    Hourmeter: 'Horímetro',
    Initial: 'Inicial',
    Final: 'Final',
    NamesVisibility: 'Nomes/Visibilidade',
    InitialHourmeterDiesel: 'Horímetro Motor Díesel Inicial',
    FinalHourmeterDiesel: 'Horímetro Motor Díesel Final',
    InitialHourmeterElectric: 'Horímetro Motor Elétrico Inicial',
    FinalHourmeterElectric: 'Horímetro Motor Elétrico Final',
    InitialKilometer: 'Quilometragem Inicial',
    FinalKilometer: 'Quilometragem Final',
    HourMachine: 'Hora-Máquina',
    HourMachineTab: 'Hora-Máquina',
    BulkUpdateTransportReportTab: 'Edição em Massa',
    MaterialWeight: 'Peso do Material',
    MaterialAndOrigin: 'Material e Origem',
    LoadTime: 'Tempo de Carregamento',
    LoadTimeAB: 'T. de Carreg.',
    IdleTime: 'Tempo Ocioso',
    Drilling: 'Perfuração',
    DrillingStartTime: 'Hora de Início da Perfuração',
    DrillingStartDate: 'Data de Início da Perfuração',
    DrillingType: 'Tipo do Furo',
    DrillingID: 'Identificador do Furo',
    DrillingCount: 'Número de Furos',
    DrillingCountSecond: 'Número de Furos 2',
    DrillingDepth: 'Profundidade do Furo',
    DrillingDepthSecond: 'Profundidade do Furo 2',
    DrillingDuration: 'Tempo de Perfuração',
    DrillingInformation: 'Informações de Perfuração',
    DrillingEquipment: 'Equipamento de Perfuração',
    Bulldozer: 'Escavadeira',
    SleepLevel: 'Nível de Sono',
    SleepLevelAB: 'N. de Sono',
    TaskCodes: 'Atividades',
    Task: 'Atividade',
    TaskCodeGroup: 'Grupo de Atividade',
    TaskCodeType: 'Tipo de Atividade',
    TaskCodeItem: 'Item da Atividade',
    MandatoryStop: 'Parada Obrigatória',
    System: 'Sistema',
    SystemItems: 'Itens de Sistema',
    FailureModes: 'Modos de Falha',
    ConnectFailureModes: 'Associar Modos de Falha',
    FilterSystem: 'Filtrar Sistema',
    FilterSystemItem: 'Filtrar Item de Sistema',
    UpdateApps: 'Atualizar aplicativos',
    PageNotFound: 'Página Não Encontrada',
    Tractor: 'Trator',
    Control: 'Controle',
    DailyParts: 'P. Diárias',
    Projects: 'Projetos',
    UnitOp: 'Op. Unitária',
    Configuration: 'Configuração',
    ServerError: 'Erro no Servidor',
    QualityControlModule: 'Qualidade',
    FilterByName: 'Filtrar por Nome',
    Standby: 'Modo de Espera',
    Flow: 'Fluxo',
    OriginType: 'Tipo de Origem',
    DestinationType: 'Tipo de Destino',
    Version: 'Versão',
    UpdateToVersion: 'Atualizar para versão',
    UpdateTablets: 'Atualizar Tablets',
    AndroidAppVersion: 'Gerenciador de versão do app android',
    TabletConfiguration: 'Configuração do Tablet',
    PlatformConfiguration: 'Configuração da Plataforma',
    CurrentVersion: 'Versão atual',
    Key: 'Chave',
    User: 'Usuário',
    Users: 'Usuários',
    Level: 'Nível',
    PlatformLevel: 'Nível na Plataforma',
    ReportsLevel: 'Nível nos Relatórios',
    InvalidPassword: 'As senhas devem conter pelo menos 8 caracteres e serem exatamente iguais',
    RockFillTab: 'Preenchimento',
    Batch: 'Batelada',
    StopTime: 'Tempo parado',
    EnableEdit: 'Habilitar Edição',
    MassEdit: 'edição em massa',
    NotChange: 'Sem Alterações',
    ResetPassword: 'Redefinir Senha',
    ResetPasswordDisclaimer: 'Tem certeza que deseja redefinir a senha?',
    Parent: 'Pai',
    IsDefault: 'Modelo Padrão',
    Upload: 'Enviar',
    Process: 'Processar',
    Review: 'Revisar',
    LayerType: 'Tipo de Camada',
    LayerName: 'Nome da Camada',
    Modules: 'Módulos',
    PlatformModules: 'Módulos na Plataforma',
    LoadAllocation: 'Alocação de carga',
    ScissorLiftTab: 'Plataforma Elevatória',
    OperationActivity: 'Atividade de Operação',
    TotalDimension: 'Dimensão Total',
    OperationTime: 'Tempo Operando',
    Page: 'Página',
    Table: 'Tabela',
    UpdateTimestamp: 'Timestamp da ultima atualização',
    ControlSync: 'Control Sync',
    MassInput: 'Inserção em Massa',
    Equipament: 'Equipamento',
    Plate: 'Placa',
    WeighingTare: 'Tara',
    Workflow: 'Fluxo de Trabalho',
    VelocityLimit: 'Limite de Velocidade',
    None: 'Nenhum',
    FailToLoadData: 'Falha ao carregar dados',
    ReminderByTimeMinutes: 'Lembrete por tempo (min)',
    RequestByCode: 'Solicitação por código',
    CodesRawTab: 'Códigos',
    DatetimeStart: 'Data/Hora Início',
    DatetimeEnd: 'Data/Hora Final',
    CodeMaintenanceType: 'Manutenção',
    CodeOperationalStopType: 'Parada Operacional',
    CodeEffectiveType: 'Efetivo',
    CodeInactiveType: 'Inativo',
    CodeIdleType: 'Ocioso',
    Railroad_associate_material: 'Obrigatório associar pelo menos um material',
    CyclesNumber: 'N° de Viagens',
    'Commit Changes': 'Salvar Alterações',
    'Discard Changes': 'Descartar Alterações',
    Edit: 'Editar',
    Import: 'Importar',
    TotalLoad: 'Carga Total',
    EquipmentAllocation: 'Alocação de Equipamento',
    CicleAdvance: 'Avanço de ciclo',
    AdvanceRegister: 'Cadastro de Avanços',
    DistanceKm: 'Quilometragem',
    StepsPerformedByAutomation: 'Etapas Executadas Pela Automação',
    LAE: 'ALL',
    OperatorLoad: 'Operador que carregou',
    LS: 'IC',
    LE: 'FC',
    US: 'IB',
    UE: 'FB',
    LocalAutomationEnable: 'Automação Local Ligada',
    LoadStart: 'Início do Carregamento',
    LoadEnd: 'Fim do Carregamento',
    UnloadStart: 'Início do Basculamento',
    UnloadEnd: 'Fim do Basculamento',
    Automatic: 'Automático',
    Manual: 'Manual',
    transport_cycle_empty: 'Trânsito Vazio',
    transport_cycle_full: 'Trânsito Cheio',
    transport_cycle_load_queue: 'Fila de Carregamento',
    transport_cycle_load_maneuver: 'Manobra de Carregamento',
    transport_cycle_load: 'Carregamento',
    transport_cycle_unload_queue: 'Fila de Basculamento',
    transport_cycle_unload_maneuver: 'Manobra de Basculamento',
    transport_cycle_unload: 'Basculamento',
    TransportCycleStopped: 'Parado',
    TransportCycleOverload: 'Sobrecarga',
    TransportCycleInterrupted: 'Interrompido',
    TransportCycleOpen: 'Aberto',
    TransportCycleChecklist: 'Checklist',
    TransportCycleDefault: 'Ciclo Normal',
    TransportCycleEmptyStop: 'Parada Vazio',
    TransportCycleReleasedEquipment: 'Equipamento Liberado',
    TransportCycleWeighting: 'Pesagem',
    TransportCycleSupply: 'Abastecimiento',
    TransportCycleDestinationSelection: 'Seleção de Destino',
    TransportCycleExcavatorSelection: 'Seleção de Excavadora',
    TransportCycleReturn: 'Retorno',
    TransportCycleCut: 'Corte',
    TransportCycleStrandingScreening: 'Atirantamento e Telamento',
    HoleID: 'ID do Furo',
    ShowInactive: 'Mostrar Inativos',
    ChatBeta: 'Chat (Beta)',
    MessageRegistration: 'Cadastro de Mensagens',
    Message: 'Mensagem',
    MessageCategory: 'Categoria da Mensagem',
    NameMessageCategory: 'Nome Categoria da Mensagem',
    JumboTab: 'Jumbo',
    Reason: 'Motivo',
    JumboExplanation: 'Motivos para o Jumbo de dois braços operar com apenas um braço',
    InactivateAllSelectedItems: 'Inativar todos os itens selecionados',
    RemoveAllSelectedItems: 'Remover todos os itens selecionados',
    ClearAllSelectedItems: 'Limpar todos os itens selecionados',
    ChooseEquipmentType: 'Escolha o tipo de equipamento',
    Frequency: 'Frequência',
    Indicators: 'Indicadores',
    CodeMigrationRules: 'Regras de Migração de Código',
    MaxTimeInOriginCode: 'Tempo Máximo no Código de Origem',
    NewCurrentDuration: 'Nova Duração do Código Atual (min)',
    NewCodeDuration: 'Duração do Código Adicionado (min)',
    CodesMigrations: 'Códigos com Duração Excedida',
    AleatoryDurationPercentage: 'Duração Período Aleatório (%)',
    AleatoryProbabilityPercentage: 'Probabilidade de Sorteio (%)',
    Closure: 'Fechamento',
    ClosureDate: 'Data de Fechamento',
    ConfirmationDate: 'Data de Confirmação',
    MovementAlreadyRegistered: 'Movimento já registrado.',
    ReplacedEquipment: 'Equipamento Substituído',
    ShowOnlyReservedEquips: 'Filtrar apenas os equipamentos de reserva',
    RegistrationSteps: 'Passos de Cadastro',
    CargoEquipment: 'Equipamento de Carga',
    RockFill: 'Rock Fill',
    Wagon: 'Vagão',
    TypesCargo: 'Caminhão, equipamento de carga, rock fill, e vagão',
    DataUnavailable: 'Dados Indisponíveis',
    LoadingEquipments: 'Equipamento de carga',
    NumberOfTrucksAllocated: 'Número de caminhões alocados',
    MaxCapacityOfAllocations: 'Capacidade máx. de alocação',
    MaxTimeLoadingQueue: 'Tempo máx. na fila de carregamento',
    AssessmentInterval: 'Intervalo de avaliação',
    SubOrigin: 'Sub Origem',
    Restriction: 'Restrição',
    NotAllowedFor: 'não é permitido para o equipamento',
    CodeLocation: 'Localização',
    ProgrammedOrigin: 'Origem Prog.',
    ProgrammedOriginPoint: 'P. de Origem Prog.',
    ProgrammedMaterial: 'Material Prog.',
    ProgrammedDestinationPoint1st: '1º P. de Destino Prog.',
    ProgrammedDestinationPoint2nd: '2º P. de Destino Prog.',
    Rows: 'Linhas',
    EditField: 'Campo de edição',
    EditFields: 'Campos de edição',
    NewValue: 'Novo valor',
    Visibility: 'Visibilidade',
    InvisibleForAll: 'Invisível para todos',
    VisibleForAll: 'Visível para todos',
    VisibleOperation: 'Visível operação',
    VisibleChecklist: 'Visível pré checklist',
    SubElementType: 'Tipo de Subelemento',
    ScreensNumber: 'Número de telas',
    SearchFor: 'Buscar por',
    EditHistory: 'Hist. edição',
    EditHistoryDatetime: 'Data/hora da edição.',
    Editor: 'Editor',
    RouteHistory: 'Rota',
    NoFilterMessage: 'Sem filtro de Equipamento e/ou Grupo de Equipamento',
    FilteredEquipment: 'Equipamentos filtrados',
    FilteredEquipmentGroups: 'Grupo de Equipamentos filtrados',
    UnlockPassword: 'Senha de Desbloqueio',
    UnlockPasswordValidUntil: 'A senha de desbloqueio é valida até às',
    ShowPassword: 'Mostrar a senha',
    Preview: 'Pré-visualizar',
    CurrentlyInUse: 'Em uso atualmente',
    Icon: 'Icone',
    CodeIcon: 'Ícone do Código',
    Dispatch: 'Despacho',
    Chat: 'Chat',
    GotIn: 'entrou em',
    SentMessage: 'enviou mensagem',
    MessageGroupsBeta: 'Grupo de Mensagens (Beta)',
    GroupsConfiguration: 'Configuração de Grupos',
    AddGroup: 'Adicionar grupo',
    MessageGroupName: 'Nome do Grupo de Mensagem',
    ConfirmActivateMessageGroup: 'Tem certeza que deseja ATIVAR o grupo de mensagem',
    ConfirmDeactivateMessageGroup: 'Tem certeza que deseja INATIVAR o grupo de mensagem',
    MessageGroups: 'Grupo de Mensagens',
    SendMessagesToGroup: 'Enviar mensagens para grupo',
    SendMessage: 'Enviar mensagem',
    FilterEquipment: 'Filtrar Equipamento',
    SendToGroup: 'Enviar para grupo',
    IsPersistent: 'Registro Definitivo',
    discardChanges: 'Descartar alterações',
    DMT: 'DMT',
    LastTimestampUpdate: 'Último Timestamp de Atualização',
    Standard: 'Padrão',
    Updated: 'Atualizado',
    DuplicatedPlate: 'Placa já cadastrada.',
    SelectEquipmentType: 'Selecione o tipo de equipamento',
    DistanceInEmptyTraffic: 'Distância em Trânsito Vazio',
    DistanceInFullTraffic: 'Distância em Trânsito Cheio',
    FieldsForEditing: 'Preencha os campos que deseja alterar (campos em branco não serão modificados):',
    BulkEdit: 'Edição em massa',
    TotalOf: 'Total de',
    ChangedResults: 'resultados selecionados para alteração',
    OriginalPoint: 'Ponto de Origem',
    BulkUpdate: 'Confirmar edição em massa',
    ConfirmContinue: 'Deseja continuar?',
    BulkUpdateInstructions: 'Para editar mais linhas, navegue pelas páginas para carregar os dados adicionais. Ciclos interrompidos e excluídos não serão considerados.',
    InsertValue: 'Inserir valor',
    RowRangeToEdit: 'Escolha o intervalo de linhas que deseja alterar:',
    NumberOfLinesEdited: 'Quantidade de linhas que serão editadas:',
    FuelScreen: 'Tela de nível de combustível',
    FuelLevel: 'Nível de combustível',
    ItMoves: 'Permite movimento',
    Type: 'Tipo',
    Group: 'Grupo',
    NoAvailableData: 'Não existem dados disponíveis para os filtros selecionados',
    QuantityEquipmentPerGroup: 'Quantidade de equipamentos por grupo',
    DefaultValue: 'Valor padrão',
    EquipmentSituation: 'Situação do Equipamento',
    Situation: 'Situação',
    EnterText: 'Digite o texto...',
    ValidUntil: 'Válida até',
    DateAndTime: 'Data e hora',
    ProgrammingDuration: 'Duração da programação',
    TypeAMessage: 'Digite uma mensagem...',
    DynamicAllocationAbrev: 'Aloc. Dinâmica',
    EnableAllDynamicAlloc: 'Habilitar todas aloc. dinâmica',
    DisableAllDynamicAlloc: 'Desabilitar todas aloc. dinâmica',
    BulkConfigDynamicAlloc: 'Configuração em massa aloc. dinâmica',
    WorkfaceControl: 'Controle Frentes',
    CodeAndCodeDuration: 'Código e duração de código',
    CodeDateAndTime: 'Data e hora início do código',
    Highlight: 'Destaque',
    CyclesNumberKanban: 'Número de ciclos',
    Legend: 'Legenda',
    StartDateAndTime: 'Data e hora início',
    NoColumnsAvailable: 'Nenhuma coluna disponível',
    Detonation: 'Detonação',
    Attention: 'Atenção',
    Favorite: 'Favorito',
    ExpediteModule: 'Expedição',
    ExternalMaterialId: 'ID do Material Externo',
    EntryDateAndTime: 'Data/hora de entrada',
    ExitDateAndTime: 'Data/hora de saída',
    NetWeight: 'Peso Líquido',
    OriginLot: 'Lote de Origem',
    TicketNumber: 'Número do Ticket',
    HideDeletedOrders: 'Ocultar ordens excluídas',
    InOperation: 'Em Operação',
    Company: 'Empresa',
    AttentionAlert: 'ATENÇÃO',
    ChangeWillBeSent: 'A alteração será enviada para o aplicativo.',
    OperatorWillReceiveMessageAlert: 'Se este apontamento for mais recente que o existente no aplicativo, o operador receberá uma mensagem de alerta com a modificação do seu status.',
    DoYouWantToContinue: 'Deseja continuar?',
    InvisibleCodeAlert: 'Esse código está invisível no tablet, portanto não será enviado para ele.',
    OnlyVisibleOnPlatform: 'Ele apenas reflete na Plataforma.',
    ToSendTurnOnVisible: 'Para enviá-lo ao tablet, torne-o visível e atualize a estrutura do tablet.',
    Continue: 'Continuar',
    Back: 'Voltar',
    Tube: 'Tubo',
    GrindingWheel: 'Rebolo',
    ShockAbsorber: 'Anti-choque',
    Hammer: 'Martelo',
    Rod: 'Haste',
    BitHolder: 'Porta Bit',
    Breech: 'Culatra',
    Handle: 'Punho',
  },
  es: {
    AnalysisType: 'Tipo de Análisis',
    Global: 'Global',
    Local: 'Parcial',
    Sieve: 'Tamiz',
    TotalMassSample: 'Masa Total de la Muestra',
    Granulometry: 'Granulometría',
    ParticleSieveOpenings: 'Abertura de Tamiz de Partículas',
    SieveOpening: 'Abertura de Tela',
    CodeMigrations: 'Migraciones de Códigos',
    CodeMigrationsDynamic: 'Migraciones de Códigos (Dynamic)',
    UnavailableModule: 'Módulo no disponible',
    KnowMore: 'Saber más',
    Settings: 'Configuraciones',
    Logout: 'Cerrar sesión',
    MiningControl: 'Mining Control',
    WelcomeTo: 'Bienvenido a',
    Parameter: 'Parámetro',
    EquipmentConfigurations: 'Configuraciones de Equipos',
    GeneralConfigurations: 'Configuraciones Generales',
    CyclesAutomation: 'Automati. de Ciclos',
    ControlType: 'Tipo de Control',
    Front: 'Frente',
    Equipments: 'Equipos',
    ReserveEquipment: 'Equipo de reserva',
    PerforatorSchedules: 'Programación Perforadora',
    EffectiveSchedules: 'Programación Efectiva',
    InactiveTurnPersistency: 'Persistencia de Turno Inactivo',
    RainMode: 'Modo Lluvia',
    ToggleRainMode: 'Activar Modo Lluvia',
    SpeedLimit: 'Límite de Velocidad',
    Issue: 'Problema',
    Accept: 'Aceptar',
    ScreenCount: 'Cantidad de Pantallas',
    NumberOfArches: 'Marcos ligeros',
    NumberOfLatticeGirders: 'Número de cerchas',
    NumberOfDowels: 'Marcos ligeros',
    NumberOfSheets: 'Número de cerchas',
    CrusherTab: 'Molino',
    CrusherTime: 'Tiempo de Molino',
    CrusherStopTime: 'Tiempo de Parada de Molino',
    Source: 'Fuente',
    FeatureInDevelopment: 'Funcionalidad en desarrollo',
    LastServerConnection: 'Última Conexión al Servidor',
    LastDataSent: 'Últimos Datos Enviados',
    DiconnectedTime: 'Tiempo Desconectado',
    DataToSend: 'Datos a Enviar',
    AddEditAllocation: 'Agregar/Editar Asignación',
    EditEquipmentScheduling: 'Editar Programación de Equipamientos',
    GoalTypes: 'Tipos de Metas',
    Goal: 'Meta',
    GoalsBETA: 'Metas (BETA)',
    Planning: 'Planificación',
    Short: 'Corto',
    Medium: 'Medio',
    Long: 'Largo',
    Granularity: 'Granularidad',
    DefinitiveNote: 'Registro Definitivo',
    ValueType: 'Tipo de Valor',
    Number: 'Número',
    Discard: 'Desechar',
    discardChanges: 'Descartar los cambios',
    TotalTimeInCode: 'Tiempo total en código',
    FullDistance: 'Distância completa',
    EmptyDistance: 'Distância vacía',
    LoadLatitude: 'Carga de latitud',
    LoadLongitude: 'Longitud de carga',
    LoadAltitude: 'Carga de altitud',
    UnloadLatitude: 'Descargar Latitud',
    UnloadLongitude: 'Longitud de descarga',
    UnloadAltitude: 'Descarga en altitud',
    LoadEquipmentNumber: 'Número de equipamiento de carga',
    CycleStageTimes: 'Tiempos de etapa del ciclo',
    Step: 'Etapa',
    railroad_cycle_time_port_exit: 'Maniobra de salida de puerto',
    railroad_cycle_time_empty: 'Circulación de trenes vacíos',
    railroad_cycle_time_load_entry: 'Maniobra de entrada a la mina',
    railroad_cycle_time_load_queue: 'Cola de carga',
    railroad_cycle_time_load: 'Cargando',
    railroad_cycle_time_load_exit: 'Maniobra de salida de mina',
    railroad_cycle_time_full: 'Circulación de trenes cargados',
    railroad_cycle_time_port_entry: 'Maniobra de Entrada a Puerto',
    railroad_cycle_time_unload_queue: 'Cola de descarga',
    railroad_cycle_time_unload: 'Descarga',
    TotalInCode: 'Tiempo total en Código',
    StandardLoad: 'Carga estándar',
    LoadingEquipment: 'Nº Equipamiento de Carga',
    Finalize: 'Finalizar',
    ConfirmChanges: 'Confirmar cambios?',
    TaskCodesAndAlerts: 'Actividades y Alertas',
    Text: 'Texto',
    ThereAreNoChanges: 'No hay cambios',
    Resources: 'Recursos',
    Elevation: 'Elevación',
    ScenarioInConfiguration: 'Escenario en la configuración',
    Configure: 'Configurar',
    AppliedToAllocations: 'Aplicado a asignaciones',
    AllocationGroup: 'Grupo de asignación',
    MaxQueueTime: 'Tiempo máximo de cola (min)',
    Elevations: 'Elevación',
    ElevationGroups: 'Grupos de elevación',
    ElevationGroup: 'Grupo de elevación',
    ElementLimits: 'Límites de Elementos',
    ElevationsAssociatedToTheElement: 'Alzados asociados al elemento',
    InitialElevation: 'Elevación inicial',
    FinalElevation: 'Elevación final',
    Creation: 'Creación',
    Current: 'Actual',
    LoadScenarioToContinue: 'Sube un escenario para continuar',
    Loaded: 'Cargado',
    LoadAction: 'Cargar',
    FilterByDate: 'Filtrar por fecha',
    ElementsAssociatedToTheScenario: 'Elementos asociados al escenario',
    SubelementsAssociatedToTheScenario: 'Subelementos asociados al escenario',
    LineupNewSchedule: 'Line-up: Nuevo horario',
    LineupPlanning: 'Line-up: Planificación',
    Scenarios: 'Guión',
    Empty: 'Vacío',
    Full: 'Lleno',
    Queue: 'Cola',
    Maneuver: 'Aculatamiento',
    Dump: 'Descarga',
    Stop: 'Parada',
    NotStarted: 'No empezado',
    Disapproved: 'Desaprobada',
    Paused: 'Pausado',
    InProgress: 'En curso',
    OnApproval: 'A prueba',
    Finalized: 'Finalizada',
    DeleteSchedule: 'Eliminar Programación',
    Time: 'Hora',
    MassT: 'Masa (t)',
    Closings: 'Cierres',
    ClosingsList: 'Lista de cierres',
    Condition: 'Condición',
    Entry: 'Entrada',
    LoginLogout: 'Login/Logout',
    StockClosings: 'Cierres de stock',
    Velocity: 'Velocidad',
    AllocationMode: 'Modo de asignación',
    Permanent: 'Permanente',
    Standard: 'Estándar',
    Temporary: 'Temporal',
    AllocatedTo: 'Asignado a',
    CurrentElement: 'Elemento actual',
    CurrentElementPoint: 'Subelemento actual',
    CurrentCycleStep: 'Paso del ciclo actual',
    OriginSubElement: 'Subelemento de origen',
    AllocateTo: 'Asignar a',
    LastModified: 'Ultimo cambio',
    Origins: 'Orígenes',
    Destinations: 'Destinos',
    Category: 'Categoría',
    Input: 'Insumo',
    MaintenanceType: 'Tipo de Manutenção',
    MaintenanceGroup: 'Grupo de Manutenção',
    Maintenance: 'Mantenimiento',
    SelectAll: 'Seleccionar todos',
    HideInterruptedOrDeletedCycles: 'Ocultar ciclos interrumpidos o eliminados',
    HideDeletedEvents: 'Esconder eventos deletados',
    FilterByEquipmentGroup: 'Filtrar por Grupo de Equipamiento',
    FilterByMaterial: 'Filtrar por Material',
    ShiftGroupConnectedToUndergroundModule: 'Grupo de turno associado ao módulo Underground',
    ShiftGroupConnectedToOpenPitModule: 'Grupo de turno associado ao módulo Open Pit',
    FilterByShiftGroup: 'Filtrar Por Grupo de Turno',
    NumberOfIntervals: 'Número de Intervalos',
    RpmNoRotation: 'RPM sin rotación (inicio)',
    RpmSlowRunning: 'RPM marcha lenta (inicio)',
    RpmHighSpin: 'RPM rotación alta (inicio)',
    RpmOperation: 'RPM operación (inicio)',
    ContentVariables: 'Gerenciar Teores',
    AssociationsList: 'Listagem de Associações',
    ConnectSubElements: 'Associar sub-elementos',
    FilterByProjectGroup: 'Filtrar por grupo de projeto',
    FilterByElement: 'Filtrar por elemento',
    OriginSubElements: 'Sub-elementos de origen',
    OperationalControl: 'Controle Operacional',
    OperationalStop: 'Parada Operativa',
    Operation: 'Operación',
    AnomalyLogs: 'Registros de Anomalías',
    AnomalyType: 'Tipo de Anomalía',
    Anomaly: 'Anomalías',
    AnomalousTable: 'Tabla anómala',
    Occurrences: 'Ocorrencias',
    Registers: 'Registros',
    MonthlyAdvance: 'Avanço Mensal',
    MonthlyAdvanceMeters: 'Avanço Mensal (metros)',
    MaintenanceLogoutLimit: 'Maintenance Logout Limit',
    SelectMaintenanceLogoutLevel: 'Select the logout level for maintenance',
    ClearCache: 'Limpar Cache',
    DisableCache: 'Desabilitar Cache',
    AccessYourAccount: 'Accede a tu cuenta',
    LoadFactor: 'Fator de carga',
    Welcome: 'Seja bem-vindo à Plataforma Mining Control',
    RefuellingPerEquipment: 'Abastecimento por Equipamento',
    RemainingLitersAlarm: 'Alarma de Litros Restantes',
    ConnectCodes: 'Associar Códigos',
    GreenPercentage: 'Verde (%)',
    YellowPercentage: 'Amarillo (%)',
    RedPercentage: 'Rojo (%)',
    PurplePercentage: 'Púrpura (%)',
    FilterByEquipType: 'Filtrar por Tipo de Equip.',
    FilterByEquipGroup: 'Filtrar por grupo de equip.',
    TankCapacityLiters: 'Capacidade Tanque (litros)',
    LitersPerHourConsumption: 'Consumo (litros/hora)',
    MapElement: 'Mapear Elemento',
    MapMaterial: 'Mapear Material',
    OriginPlural: 'Orígenes',
    DestinationPlural: 'Destino(s)',
    FilterOriginElements: 'Filtrar Elementos de Origen',
    FilterDestinationElements: 'Filtrar Elementos de Destino',
    HoleMeters: 'Haste',
    OriginElement: 'Elemento de Origen',
    SubOriginElement: 'Sub-Elemento de Origen',
    SubDestinationElement: 'Sub-Elemento de Destino',
    DMTMeters: 'DMT (metros)',
    EquipmentScheduling: 'Programação de Equipamento',
    PendenciesApproval: 'Aprobación de Pendientes',
    Approve: 'Aprobar',
    Delay: 'Atraso',
    Observation: 'Observación',
    PreventiveType: 'Tipo de Preventiva',
    RefuelOperatorRegistration: 'Matrícula Operador Abastecimento',
    RefuelEquipmentGroup: 'Grupo Equipamento Abastecimento',
    RefuelEquipment: 'Equipamento Abastecimento',
    RefueledEquipmentType: 'Tipo Equipamento Abastecido',
    RefueledEquipmentGroup: 'Grupo Equipamento Abastecido',
    RefueledEquipment: 'Equipamento Abastecido',
    RefueledOperatorGroup: 'Grupo do Operador Abastecido',
    RefueledOperator: 'Operador Abastecido',
    RefuelInitialLatitude: 'Latitude Início Abastecimento',
    RefuelInitialLongitude: 'Longitude Início Abastecimento',
    RefuelInitialElement: 'Elemento Início Abastecimento',
    RefuelInitialSubElement: 'Sub-Elemento Início Abastecimento',
    RefuelFinalElement: 'Elemento Fim Abastecimento',
    RefuelFinalLatitude: 'Latitude Fim Abastecimento',
    RefuelFinalLongitude: 'Logitude Fim Abastecimento',
    RefuelFinalSubElement: 'Sub-Elemento Fim Abastecimento',
    RefueledHourmeterEquipment: 'Horímetro Equipamento Abastecido',
    RefueledEquipmentKilometer: 'Quilometragem Equipamento Abastecido',
    RefueledLiters: 'Litragem Abastecida',
    StopOperationTime: 'Tiempo en código de parada por operación/mantenimiento',
    RefuelTime: 'Tiempo de carga',
    RefuelIntervalTime: 'Tiempo del intervalo de carga',
    RefuelIntervalDistance: 'Distancia del intervalo de carga',
    ReturnDate: 'Fecha de retorno',
    ReturnTime: 'Hora de retorno',
    ReturnLatitude: 'Latitud del retorno',
    ReturnLongitude: 'Longitud del retorno',
    ReturnAltitude: 'Altitud del retorno',
    ReturnElement: 'Elemento del retorno',
    ReturnSubElement: 'Subelemento del retorno',
    ReturnDistance: 'Distancia del retorno',
    ReturnDuration: 'Duración del retorno',
    CutDate: 'Fecha de Corte',
    CutTime: 'Hora de Corte',
    CutLatitude: 'Latitud del corte',
    CutLongitude: 'Longitud del corte',
    CutAltitude: 'Altitud del corte',
    CutElement: 'Elemento do Corte',
    CutSubElement: 'Subelemento del corte',
    CutDistance: 'Distancia del corte',
    CutDuration: 'Duración del corte',
    UnloadTime: 'Tiempo de descarga',
    UnloadTimeAB: 'T. de Basculamento',
    LoadQueueTime: 'Tiempo de fila de carga',
    LoadQueueTimeAB: 'T. de Fila de Carr.',
    UnloadQueueTime: 'Tiempo de fila de descarga',
    UnloadQueueTimeAB: 'T. de Fila de Desc.',
    LoadManeuverTime: 'Tiempo de maniobra de carga',
    LoadManeuverTimeAB: 'T. de Man. de Carr.',
    UnloadManeuverTime: 'Tiempo de maniobra de descarga',
    UnloadManeuverTimeAB: 'T. de Man. de Basc.',
    EmptyTrafficTime: 'Tiempo de tránsito vacío',
    EmptyTrafficTimeAB: 'T. tránsito vacío',
    FullTrafficTime: 'Tiempo de tránsito lleno',
    FullTrafficTimeAB: 'T. tránsito lleno',
    EmptyTrafficDistance: 'Distancia en tránsito vacío',
    EmptyTrafficDistanceAB: 'D. en tránsito vacío',
    FullTrafficDistance: 'Distancia en tránsito lleno',
    FullTrafficDistanceAB: 'D. en tránsito lleno',
    MaintenanceStopTime: 'Tiempo de paradas por mantenimiento',
    MaintenanceStopTimeAB: 'T. de Paradas Op. / Man.',
    LoadDefault: 'Carga estándar',
    LoadDefaultAB: 'C. Estandard',
    LoadBalanceAB: 'C. pesaje (Kg)',
    DMTRangesRegister: 'Registro de rangos de DMT',
    RangeCostRegister: 'Registro de costo por rango',
    ManageMoneyPerWorkedHour: 'Gerenciar R$/HT',
    RangeName: 'Nombre de la pista',
    InitialM: 'Inicial (m)',
    FinalM: 'Final (m)',
    InitialRangeM: 'Faixa Inicial (metros)',
    FinalRangeM: 'Faixa Final (metros)',
    CostMoneyTime: 'Custo (R$/t)',
    ValueMoneyTime: 'Valor (R$/ht)',
    Checklist: 'Checklist',
    CheckListItem: 'Item de Checklist',
    ConnectChecklist: 'Associar Checklist',
    FilterByEquipmentType: 'Filtrar por tipo de equip.',
    ChecklistItems: 'Itens de Checklist',
    ObligatoryStop: 'Parada obrigatória',
    DurationMinutes: 'Duração (minutos)',
    MaintenanceData: 'Dados de manutenção',
    CodeTab: 'Códigos',
    TractorTab: 'Trator',
    NumOfBoons: 'Nº de Lanças',
    BitDiameterName: 'Nome Diâmetro Bit',
    BitDiameterNameSecond: 'Nome Diâmetro Bit 2',
    EntryType: 'Tipo de Registro',
    Cycle: 'Ciclo',
    EndTime: 'Hora Fim',
    Initial: 'Inicial',
    Final: 'Final',
    NamesVisibility: 'Nomes/Visibilidade',
    InitialHourmeterDiesel: 'Horímetro Motor Díesel Inicial',
    FinalHourmeterDiesel: 'Horímetro Motor Díesel Final',
    InitialHourmeterElectric: 'Horímetro Motor Elétrico Inicial',
    FinalHourmeterElectric: 'Horímetro Motor Elétrico Final',


    DispatchModule: 'Envío',
    AllocatedTrucks: 'Camiones seleccionados',
    ClearAllocations: 'Limpiar selecciones',
    AvailableEquipments: 'Equipamientos disponibles',
    MaintenanceEquipments: 'Equipamientos en mantenimiento',
    NewAllocation: 'Nueva selección',
    TruckEquipments: 'Camiones',
    TruckEquipmentGroups: 'Grupos de camión',
    NoRegisteredAllocations: 'Ninguna selección registrada',
    DeleteAllocation: 'Eliminar selección',
    Allocation: 'Selección',
    LoadManager: 'Volumen de material',
    ApplyFilterToFetchData: 'Aplique filtros para buscar datos',
    Mapping: 'Mapeo',
    Filter: 'Filtrar',
    Filters: 'Filtros',
    LoadSchedules: 'Programación de carga',
    ShowAll: 'Mostrar todo',
    ShiftGroupConnectedToMaintenanceModule: 'Grupo de turno asociado al módulo mantenimiento',
    NoOptions: 'Ninguna opción',
    DestinationElement: 'Elemento de destino',
    DestinationSubElement: 'Subelemento de destino',
    LoadEquipment: 'Equipamiento de Carguío',
    LoadEquipmentGroup: 'Grupo de equipamiento de Carguío',
    TruckEquipment: 'Camión',
    TruckEquipmentGroup: 'Grupo de camión',
    RodNumber: 'Número de varillas',
    RodPosition: 'Posición de la varilla',
    FireDescription: 'Descripción Fuego',
    HoleType: 'Tipo de hueco',
    HolePosition: 'Posición del hueco',
    Rod: 'Varilla',
    Fan: 'Corte',
    FanName: 'Nombre del Corte',
    NewSchedule: 'Nueva programación',
    RpmRanges: 'Rangos RPM',
    HourmeterLimits: 'Limites de Horómetro',
    HourmeterStart: 'Horómetro Inicial',
    HourmeterMax: 'Horómetro Máximo',
    EquipmentStatus: 'Estado del equipamiento',
    EquipmentStatusAbbreviated: 'Estado Equip.',
    EquipmentStatusAbbreviatedV2: 'Estado del Equipo',
    AverageAdvance: 'Avance promedio',
    InputRework: 'Retrabajo',
    InputEffective: 'Efectivo',
    ConnectItems: 'Asociar elementos de sistema',
    Codes: 'Códigos',
    HourmeterTab: 'Horómetro',
    LoadTab: 'Carga',
    PerforatorTab: 'Perforadora',
    RefuelerTab: 'Abastecimiento',
    TransportTab: 'Transporte',
    Transport: 'Transporte',
    Tractor: 'Tractor',
    LoaderTab: 'Cargador',
    InfrastructureTab: 'Infraestructura',
    ShaftTab: 'Shaft',
    Active: 'Activo',
    InpUnit: 'Un. de insumo',
    InputUnit: 'Unidad de insumo',
    Unit: 'Unidad',
    Until: 'Hasta',
    DailyPartsModule: 'Partes diarias',
    ManagementModule: 'Gestión',
    FuelModule: 'Combustible',
    ContractsModule: 'Contratos',
    UndergroundModule: 'Underground',
    OpenPitModule: 'Open Pit',
    DynamicModule: 'Dynamic',
    MaintenanceModule: 'Mantenimiento',
    TelemetryModule: 'Telemetría',
    LineupModule: 'Line-Up',
    DateAndTurn: 'Fecha y turno',
    No: 'No',
    Yes: 'Sí',
    Start: 'Inicio',
    Finish: 'Fin',
    All: 'Todos',
    Add: 'Agregar',
    Year: 'Año',
    Month: 'Mes',
    Days: 'Días',
    Day: 'Día',
    DaysQuantity: 'Cantidad de días',
    Register: 'Registrar',
    Enter: 'Entrar',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    NoName: 'Sin nombre',
    NoEntries: 'Sin registros',
    Select: 'Seleccione...',
    Understood: 'Entendí',
    Origin: 'Origen',
    Destination: 'Destino',
    DestinationPoint: 'Punto de destino',
    DestinationPointAB: 'P. de destino',
    OriginPoint: 'Punto de origen',
    OriginPointAB: 'P. de origen',
    Name: 'Nombre',
    Password: 'Contraseña',
    MaxVariation: 'Variación Máxima',
    PasswordRedefiniton: 'Restablecimiento de contraseña',
    ConfirmPassword: 'Confirmación de contraseña',
    Description: 'Descripción',
    Code: 'Código',
    OriginCode: 'Código de Origen',
    OriginCodeMatch: 'Código Atual',
    DestinationCode: 'Código de Destino',
    DestinationCodeMatch: 'Código Agregado',
    CodeReportTable: 'Registro de Estados',
    CloudPointReportTable: 'Histórico de Pontos',
    CodeGroup: 'Grupo de código',
    OriginCodeGroup: 'Grupo de código de origen',
    DestinationCodeGroup: 'Grupo de código de destino',
    CodeGroups: 'Grupos de código',
    CodeType: 'Tipo de código',
    OriginCodeType: 'Tipo de Código de origen',
    DestinationCodeType: 'Tipo de Código de destino',
    CodeTypes: 'Tipos de código',
    CodeTime: 'Tiempo de código',
    Visible: 'Visible',
    Equipment: 'Equipamiento',
    EquipmentMach: 'Equip.',
    EquipmentType: 'Tipo de equipamiento',
    EquipmentTypeAB: 'T. de equipamiento',
    EquipmentGroup: 'Grupo de equipamiento',
    EquipmentGroupMatch: 'Grupo de equip.',
    EquipmentGroupAB: 'G. de equipamiento',
    Range: 'Rango',
    Material: 'Material',
    UpperSieveOpening: 'Apertura de Tamiz Superior',
    UpperLimitPercentage: 'Porcentaje Límite Superior',
    LowerSieveOpening: 'Apertura de Tamiz Inferior',
    LowerLimitPercentage: 'Porcentaje Límite Inferior',
    ControlSieves: 'Tamices de Control',
    MaterialSpecifications: 'Especificaciones del Material',
    ControlParams: 'Parámetros de Control',
    AssociationRegistry: 'Registro de Asociación',
    MaterialsGroup: 'Grupo de materiales',
    MaterialGroup: 'Grupo del material',
    Materials: 'Materiales',
    BitDiameter: 'Diámetro Broca',
    BitDiameterSecond: 'Diámetro Broca 2',
    Footage: 'Metraje',
    RodFootage: 'Metraje de la varilla',
    Diameter: 'Diámetro',
    Element: 'Elemento',
    Elements: 'Elementos',
    SubElement: 'Subelemento',
    SubElements: 'Subelementos',
    Polygon: 'Polígono',
    RailRoadTab: 'Locomotora',
    Polygons: 'Polígonos',
    Type: 'Tipo',
    Group: 'Grupo',
    Warning: 'Aviso',
    Success: 'Éxito',
    Error: 'Error',
    NetworkError: 'Error de red',
    NoConnection: 'FALLO DE CONEXIÓN A INTERNET',
    DiscardChanges: 'Descartar modificaciones',
    End: 'Finalizar',
    InsertNewEntries: 'Insertar nuevos registros',
    ImportSheet: 'Importar planilla',
    EditEntries: 'Editar registros',
    EditRecordsInBatches: 'Editar registros en lotes',
    ExportEntries: 'Exportar Registros',
    EntyType: 'Tipo de registro',
    Movement: 'Movimiento',
    MovementType: 'Tipo de movimiento',
    ProjectGroup: 'Grupo de proyecto',
    Order: 'Orden',
    Priority: 'Prioridad',
    Priorities: 'Prioridades',
    UnitOperation: 'Operación Unitaria',
    UnitOperationGroup: 'Grupo de operación unitaria',
    UnitOperationTime: 'Tiempo de operación unitaria',
    SaveData: 'Guardar datos',
    Save: 'Guardar',
    Cycles: 'Ciclos',
    CycleId: 'ID del ciclo',
    CycleTime: 'Tiempo de ciclo',
    CycleDuration: 'Duración del ciclo',
    CycleType: 'Tipo de ciclo',
    CycleInitialTime: 'Hora del inicio del ciclo',
    CycleFinalTime: 'Hora de la finalización del ciclo',
    CycleInitialDate: 'Fecha del inicio del ciclo',
    CycleFinalDate: 'Fecha de la finalización del ciclo',
    SaveDataAndStartNewCycle: 'Guardar datos e iniciar un nuevo ciclo',
    Comment: 'Comentario',
    ClearFilters: 'Limpiar filtros',
    FilterBy: 'Filtrar por',
    NoElement: 'Sin elemento',
    NotConnected: 'No asociado',
    Productivity: 'Productividad',
    OperationType: 'Tipo de operación',
    Value: 'Valor',
    Operator: 'Operador',
    OperatorGroup: 'Grupo de operadores',
    OperatorGroupAB: 'G. de operadores',
    OperatorTeam: 'Equipo del operador',
    Registration: 'Matrícula',
    Team: 'Equipo',
    Teams: 'Equipos',
    TeamGroup: 'Grupo de equipo',
    TeamGroups: 'Grupos de equipo',
    TeamsGroup: 'Grupo de equipo',
    TeamsListing: 'Listado de equipos',
    Associations: 'Asociaciones',
    Pause: 'Pausa',
    AddPause: 'Agregar pausa',
    Period: 'Período',
    Shift: 'Turno',
    ShiftsGroup: 'Grupo de turnos',
    ShiftGroup: 'Grupo de turno',
    ShiftRegistration: 'Registro de turno',
    ShiftSchedule: 'Escala de turno',
    ConnectShift: 'Asociar turno ',
    Color: 'Color',
    InitialDate: 'Fecha inicial',
    StartDate: 'Fecha inicio',
    FinalDate: 'Fecha final',
    StartDateTime: 'Fecha y hora inicio',
    EndDateTime: 'Fecha y hora final',
    EndDate: 'Fecha fin',
    FinalTime: 'Hora fin',
    Date: 'Fecha',
    DateMatch: 'Fecha/Hora de inicio',
    EndDateMatch: 'Fecha/Hora de fin',
    Hour: 'Hora',
    InitialHour: 'Hora inicial',
    FinalHour: 'Hora final',
    InitialTime: 'Hora inicio',
    AddEditPause: 'Agregar/Editar pausa',
    DayOff: 'Día libre',
    Interval: 'Descanso',
    Inactive: 'Inactivo',
    Weighing: 'Peso',
    Advances: 'Avances',
    Advance: 'Avance',
    EstimatedAdvance: 'Avance estimado',
    MeasuredAdvance: 'Avance medido',
    Search: 'Buscar',
    Find: 'Buscar',
    ResultsFor: 'Resultados para',
    Pointer: 'Usuario Web',
    SeeMore: 'Ver más',
    Export: 'Exportar',
    Duration: 'Duración',
    DurationMatch: 'Duración Actual (min)',
    DurationPercentage: 'Duración (%)',
    Latitude: 'Latitud',
    Longitude: 'Longitud',
    Altitude: 'Altitud',
    InitialHourmeter: 'Horómetro inicial',
    FinalHourmeter: 'Horómetro final',
    Hourmeter: 'Horómetro',
    InitialKilometer: 'Kilometraje inicial',
    FinalKilometer: 'Kilometraje final',
    HourMachine: 'Hora Máquina',
    HourMachineTab: 'Hora Máquina',
    BulkUpdateTransportReportTab: 'Edición masiva',
    MaterialWeight: 'Peso del material',
    MaterialAndOrigin: 'Material y Origen',
    LoadTime: 'Tiempo de carga',
    LoadTimeAB: 'T. de carga',
    IdleTime: 'Tiempo Ocioso',
    Drilling: 'Perforación',
    DrillingStartTime: 'Hora de inicio de la perforación',
    DrillingStartDate: 'Fecha de inicio de la perforación',
    DrillingType: 'Tipo de hueco',
    DrillingID: 'Identificador del hueco',
    DrillingCount: 'Número de huecos',
    DrillingCountSecond: 'Número de huecos 2',
    DrillingDepth: 'Profundidad del hueco',
    DrillingDepthSecond: 'Profundidad del hueco 2',
    DrillingDuration: 'Tiempo de perforación',
    DrillingInformation: 'Información de perforación',
    DrillingEquipment: 'Equipo de perforación',
    Bulldozer: 'Excavadora',
    SleepLevel: 'Nivel de sueño',
    SleepLevelAB: 'N. de sueño',
    TaskCodes: 'Actividades',
    Task: 'Actividad',
    TaskCodeGroup: 'Grupo de actividad',
    TaskCodeType: 'Tipo de actividad',
    TaskCodeItem: 'Elemento de actividad',
    MandatoryStop: 'Parada obligatoria',
    System: 'Sistema',
    SystemItems: 'Elementos del sistema',
    FailureModes: 'Modos de falla',
    ConnectFailureModes: 'Asociar modos de falla ',
    FilterSystem: 'Filtrar Sistema',
    FilterSystemItem: 'Filtrar elemento de Sistema',
    UpdateApps: 'Actualizar aplicaciones',
    PageNotFound: 'Página no encontrada',
    Control: 'Control',
    DailyParts: 'P. diarias',
    Projects: 'Proyectos',
    UnitOp: 'Op. Unitaria',
    Configuration: 'Configuración',
    AverageLoad: 'Carga media',
    Load: 'Carguío',
    ServerError: 'Error del Servidor',
    EquipScheduling: 'Programación',
    QualityControlModule: 'Calidad',
    Content: 'Contenido',
    FireID: 'ID fuego',
    Flow: 'Fluxo',
    OriginType: 'Tipo de Origen',
    DestinationType: 'Tipo de Destino ',
    Version: 'Versión',
    UpdateToVersion: 'Actualizar a la versión',
    UpdateTablets: 'Actualizar tabletas',
    AndroidAppVersion: 'Administrador de versiones de aplicaciones de Android',
    TabletConfiguration: 'Configuración de tablets',
    PlatformConfiguration: 'Configuración de la plataforma',
    CurrentVersion: 'Versión actual',
    Key: 'Clave',
    User: 'Usuario',
    Users: 'Usuarios',
    Level: 'Nivel',
    PlatformLevel: 'Nivel en la Plataforma',
    ReportsLevel: 'Nivel en los Informes',
    InvalidPassword: 'Las contraseñas deben contener al menos 8 caracteres y ser exactamente iguales',
    RockFillTab: 'llenar',
    Batch: 'lote',
    StopTime: 'falta de tiempo',
    EnableEdit: 'habilitar Editar',
    MassEdit: 'edición masiva',
    NotChange: 'sin alteraciones',
    ResetPassword: 'redefinir contraseña',
    ResetPasswordDisclaimer: '¿Estás seguro de que deseas restablecer la contraseña?',
    Parent: 'Padre',
    IsDefault: 'Modelo Predeterminado',
    Upload: 'Subir',
    Process: 'Procesar',
    Review: 'Revisar',
    LayerType: 'Tipo de capa',
    LayerName: 'Nombre de capa',
    Modules: 'Módulos',
    PlatformModules: 'Módulos en la Plataforma',
    LoadAllocation: 'asignación de carga',
    ScissorLiftTab: 'Plataforma Elevadora',
    OperationActivity: 'Actividad Operativa',
    TotalDimension: 'Dimensiones Totales',
    OperationTime: 'Tiempo de Funcionamiento',
    Page: 'Página',
    Table: 'Tabla',
    UpdateTimestamp: 'Marca de tiempo de la última actualización',
    ControlSync: 'Control Sync',
    MassInput: 'Inserción a granel',
    Equipament: 'Equipamiento',
    Plate: 'Matrícula',
    WeighingTare: 'Tara',
    Workflow: 'Flujo de Trabajo',
    VelocityLimit: 'Límite de Velocidad',
    None: 'Ninguno',
    FailToLoadData: 'Error al cargar datos',
    ReminderByTimeMinutes: 'Recordatorio por tiempo (min)',
    RequestByCode: 'Solicitud por código',
    Railroad_associate_material: 'Obligatorio asociar al menos un material',
    CyclesNumber: 'Número de Ciclos',
    'Commit Changes': 'Cometer cambios',
    'Discard Changes': 'Descartar los cambios',
    Edit: 'Editar',
    Import: 'importar',
    TotalLoad: 'Carga Total',
    EquipmentAllocation: 'Asignación de equipamientos',
    CodeMaintenanceType: 'Mantenimiento',
    CodeOperationalStopType: 'Parada Operacional',
    CodeEffectiveType: 'Efectivo',
    CodeInactiveType: 'Inactivo',
    CodeIdleType: 'Omisión',
    IsPersistent: 'Registro Definitivo',
    CicleAdvance: 'Avance de ciclo',
    AdvanceRegister: 'Registro de Avance',
    DistanceKm: 'Kilometraje',
    StepsPerformedByAutomation: 'Pasos realizados por la automatización',
    LAE: 'HAL',
    OperatorLoad: 'Operador que cargó',
    LS: 'IC',
    LE: 'FC',
    US: 'ID',
    UE: 'FD',
    LocalAutomationEnable: 'Habilitación de automatización local',
    LoadStart: 'Inicio de carga',
    LoadEnd: 'Fin de carga',
    UnloadStart: 'Inicio de Descargar',
    UnloadEnd: 'Fin de Descargar',
    Automatic: 'Automático',
    Manual: 'Manual',
    transport_cycle_empty: 'Trafico Vacio',
    transport_cycle_full: 'Trafico Completo',
    transport_cycle_load_queue: 'Cola de Carga',
    transport_cycle_load_maneuver: 'Manobra de Descarga',
    transport_cycle_load: 'Carga',
    transport_cycle_unload_queue: 'Cola de Descarga',
    transport_cycle_unload_maneuver: 'Manobra de Descarga',
    transport_cycle_unload: 'Descarga',
    TransportCycleStopped: 'Parado',
    TransportCycleOverload: 'Sobrecarga',
    TransportCycleInterrupted: 'Interrumpido',
    TransportCycleOpen: 'Abierto',
    TransportCycleChecklist: 'Checklist',
    TransportCycleDefault: 'Padrón',
    TransportCycleEmptyStop: 'Parada de Vacio',
    TransportCycleReleasedEquipment: 'Equipamiento Liberado',
    TransportCycleWeighting: 'Pesaje',
    TransportCycleSupply: 'Abastecimiento',
    TransportCycleDestinationSelection: 'Selección de Destino',
    TransportCycleExcavatorSelection: 'Selección de Excavadora',
    TransportCycleReturn: 'Retorno',
    TransportCycleCut: 'Corte',
    TransportCycleStrandingScreening: 'Relaves y Cribado',
    HoleID: 'ID del Agujero',
    ShowInactive: 'Mostrar Inactivos',
    ChatBeta: 'Chat (Beta)',
    MessageRegistration: 'Registro de Mensajes',
    MessageCategory: 'Categoría de Mensajes',
    NameMessageCategory: 'Nombre de la Categoría de Mensajes',
    Message: 'Mensaje',
    JumboTab: 'Jumbo',
    Reason: 'Razón',
    JumboExplanation: 'Razones para que el Jumbo de dos brazos opere con un brazo',
    InactivateAllSelectedItems: 'Desactivar todos los elementos seleccionados',
    RemoveAllSelectedItems: 'Eliminar todos los elementos seleccionados',
    ClearAllSelectedItems: 'Borrar todos los elementos seleccionados',
    ChooseEquipmentType: 'Elija el tipo de equipamiento',
    Frequency: 'Frecuencia',
    Indicators: 'Indicadores',
    CodeMigrationRules: 'Reglas de migración de código',
    MaxTimeInOriginCode: 'Tiempo máximo en código de origen',
    NewCurrentDuration: 'Duración del nuevo código actual (min)',
    NewCodeDuration: 'Duración del código actual agregado (min)',
    CodesMigrations: 'Códigos de duración excedidos',
    AleatoryDurationPercentage: 'Duración Período aleatorio (%)',
    AleatoryProbabilityPercentage: 'Probabilidad aleatoria (%)',
    Closure: 'Cierre',
    ClosureDate: 'Fecha de Cierre',
    ConfirmationDate: 'Fecha de Confirmación',
    MovementAlreadyRegistered: 'Movimiento ya registrado.',
    ReplacedEquipment: 'Equipo Reemplazado',
    ShowOnlyReservedEquips: 'Filtrar solo el equipo reservado',
    RegistrationSteps: 'Pasos de Registro',
    CargoEquipment: 'Equipamiento de Carga',
    RockFill: 'Rock Fill',
    Wagon: 'vagón',
    TypesCargo: 'Camion, equipamiento de carga, rock fill, y vagón',
    DataUnavailable: 'Datos no disponibles',
    AllocationEdit: 'Edición de Asignación',
    LoadingEquipments: 'Equipamiento de carga',
    SubOrigin: 'Sub Origen',
    Restriction: 'Restricción',
    NotAllowedFor: 'no está permitido para el equipo',
    CodeLocation: 'Ubicación',
    ProgrammedOrigin: 'Origen Prog.',
    ProgrammedOriginPoint: 'P. de Origen Prog.',
    ProgrammedMaterial: 'Material Prog.',
    ProgrammedDestinationPoint1st: '1º P. de Destino Prog.',
    ProgrammedDestinationPoint2nd: '2º P. de Destino Prog.',
    Rows: 'Filas',
    EditField: 'editar campo',
    EditFields: 'Editar campos',
    NewValue: 'Nuevo valor',
    Visibility: 'Visibilidad',
    InvisibleForAll: 'Invisible para todos',
    VisibleForAll: 'Visible para todos',
    VisibleOperation: 'Visible operación',
    VisibleChecklist: 'Visible pre-checklist',
    SubElementType: 'Tipo de Subelemento',
    ScreensNumber: 'Número de pantallas',
    SearchFor: 'Buscar por',
    EditHistory: 'Hist. edición',
    EditHistoryDatetime: 'Editar fecha/hora.',
    Editor: 'Editor',
    RouteHistory: 'Ruta',
    NoFilterMessage: 'Sin filtro de Equipo y/o Grupo de Equipos',
    FilteredEquipment: 'Equipos filtrados',
    FilteredEquipmentGroups: 'Grupos de Equipos filtrados',
    UnlockPassword: 'Contraseña de Desbloqueo',
    UnlockPasswordValidUntil: 'La contraseña de desbloqueo es válida hasta las',
    ShowPassword: 'Mostrar contraseña',
    Preview: 'Vista previa',
    CurrentlyInUse: 'Actualmente en uso',
    Icon: 'Icono',
    CodeIcon: 'Ícono de Código',
    Dispatch: 'Envio',
    Chat: 'Chat',
    GotIn: 'entró en',
    SentMessage: 'envió mensaje',
    MessageGroupsBeta: 'Grupos de Mensajes (Beta)',
    GroupsConfiguration: 'Configuración de Grupos',
    AddGroup: 'Agregar grupo',
    MessageGroupName: 'Nombre del Grupo de Mensajes',
    ConfirmActivateMessageGroup: '¿Está seguro de que desea ACTIVAR el grupo de mensajes?',
    ConfirmDeactivateMessageGroup: '¿Está seguro de que desea DESACTIVAR el grupo de mensajes?',
    MessageGroups: 'Grupos de Mensajes',
    SendMessagesToGroup: 'Enviar mensajes al grupo',
    SendMessage: 'Enviar mensaje',
    FilterEquipment: 'Filtrar Equipamiento',
    SendToGroup: 'Enviar al grupo',
    AllocationGroupExplanation: 'Define a qué grupo de asignación pertenece cada equipo de carga',
    AssessmentInterval: 'Intervalo de evaluación',
    AutoAllocationLogs: 'Asignación de registros dinámicos',
    AvailableMass: 'Masa disponible (t)',
    CalculatePrecedences: 'Calcular precedencias',
    Class: 'Clase',
    CodesRawTab: 'Códigos',
    DatetimeEnd: 'Fecha/hora de finalización',
    DatetimeStart: 'Fecha/hora de inicio',
    DependentElements: 'Elementos dependientes',
    DependentSubElements: 'Subelementos dependientes',
    DynamicAllocation: 'Asignación dinámica',
    DynamicAllocationExplanation: 'Determina si la funcionalidad de asignación dinámica debe admitir esta asignación',
    FilterByElevation: 'Filtrar por elevación',
    FilterByName: 'Filtrar por nombre',
    Goals: 'Objetivos',
    MaxAllocationCapacity: 'Máx. capacidad de asignación',
    MinAllocationCapacityExplanation: 'Define una capacidad mínima de transporte para una excavadora',
    MaxAllocationCapacityExplanation: 'Establece una capacidad máxima de equipo de transporte permitido en una excavadora y bloquea nuevas asignaciones automáticas a la excavadora hasta que haya un espacio disponible.',
    MaxCapacityOfAllocations: 'Máx. capacidad de asignación',
    MaxLoadQueueTime: 'Tiempo máximo de cola de carga (min)',
    MaxLoadQueueTimeExplanation: 'Tiempo máximo de cola que puede tener el equipo de carga, valores superiores a este activan la asignación dinámica',
    MaxTemporaryAllocationCyclesExplanation: 'Número máximo de ciclos que el camión debe permanecer en asignaciones temporales, antes de verse obligado a regresar a su asignación permanente',
    MaxTimeLoadingQueue: 'Tiempo máximo en cola de carga',
    MaximumTemporaryAllocationCycles: 'Ciclos máximos en asignación temporal',
    MeanQueueTimeRange: 'Intervalo de evaluación de cola (min)',
    MeanQueueTimeRangeExplanation: 'Ventana de tiempo en minutos para calcular el tiempo promedio de espera de una excavadora',
    MinPermanentAllocationCyclesExplanation: 'Número mínimo de ciclos que el camión debe permanecer en su asignación permanente, antes de ser asignado temporalmente',
    MinAllocationCapacityExplanation: 'Cantidad máxima de ciclos que el camión debe permanecer en asignaciones temporales, antes de estar obligado a volver a su asignación permanente',
    MinAllocationCapacity: 'Cantidad máxima de ciclos que el camión debe permanecer en asignaciones temporales, antes de estar obligado a volver a su asignación permanente',
    MineAvailability: 'Disponibilidad minera',
    MinimumPermanentAllocationCycles: 'Número mínimo de ciclos en asignación permanente',
    Precedences: 'Precedencias',
    Production: 'Producción',
    ReportModule: 'Informes',
    Standby: 'Modo de espera',
    State: 'Estado',
    UnitOpGroup: 'Grupo de Operaciones Unitarias',
    DMT: 'DMT',
    LastTimestampUpdate: 'Última actualización de marca de tiempo',
    Standard: 'Estándar',
    Updated: 'Actualizado',
    DuplicatedPlate: 'Matrícula ya registrada',
    SelectEquipmentType: 'Seleccionar tipo de equipo',
    DistanceInEmptyTraffic: 'Distancia en tráfico vacío',
    DistanceInFullTraffic: 'Distancia en tráfico pesado',
    FieldsForEditing: 'Llene los campos que desea modificar (los campos en blanco no se modificarán):',
    BulkEdit: 'Edición masiva',
    TotalOf: 'Total de',
    ChangedResults: 'resultados seleccionados para el cambio',
    OriginalPoint: 'Punto de Origen',
    BulkUpdate: 'Confirmar edición masiva',
    ConfirmContinue: '¿Quieres continuar?',
    BulkUpdateInstructions: 'Para editar más filas, navegue por las páginas para cargar datos adicionales. No se considerarán los ciclos interrumpidos o eliminados.',
    InsertValue: 'Insertar valor',
    RowRangeToEdit: 'Elija el rango de filas que desea cambiar:',
    NumberOfLinesEdited: 'Número de líneas a editar:',
    FuelScreen: 'Pantalla de nivel de combustible',
    FuelLevel: 'Nivel de combustible',
    ItMoves: 'Permite movimiento',
    Type: 'Tipo',
    Group: 'Grupo',
    Equipments: 'Equipo',
    NoAvailableData: 'No hay datos disponibles para los filtros seleccionados',
    QuantityEquipmentPerGroup: 'Cantidad de equipos por grupo',
    DefaultValue: 'Valor predeterminado',
    EquipmentSituation: 'Estado del equipo',
    Situation: 'Situación',
    EnterText: 'Introduce el texto...',
    ValidUntil: 'Válido hasta',
    DateAndTime: 'Fecha y hora',
    ProgrammingDuration: 'Duración de la programación',
    TypeAMessage: 'Escribe un mensaje...',
    DynamicAllocationAbrev: 'Asig. Dinámica.',
    EnableAllDynamicAlloc: 'Habilitar toda asignación dinámica',
    DisableAllDynamicAlloc: 'Deshabilitar toda asignación dinámica',
    BulkConfigDynamicAlloc: 'Asignación dinámica de configuración masiva',
    WorkfaceControl: 'Control Frentes',
    CodeAndCodeDuration: 'Código y duración del código',
    CodeDateAndTime: 'Fecha y hora del código',
    Highlight: 'Destacado',
    CyclesNumberKanban: 'Número de ciclos',
    Legend: 'Leyenda',
    StartDateAndTime: 'Fecha y hora de inicio',
    NoColumnsAvailable: 'No hay columnas disponibles',
    Detonation: 'Detonación',
    Attention: 'Atención',
    Favorite: 'Favorito',
    ExpediteModule: 'Expedición',
    ExternalMaterialId: 'ID del Material Externo',
    EntryDateAndTime: 'Fecha/Hora de Entrada',
    ExitDateAndTime: 'Fecha/Hora de Salida',
    NetWeight: 'Peso Neto',
    OriginLot: 'Lote de Origen',
    TicketNumber: 'Número de Ticket',
    HideDeletedOrders: 'Ocultar órdenes eliminadas',
    InOperation: 'En Operación',
    Company: 'Empresa',
    AttentionAlert: 'ATENCIÓN',
    ChangeWillBeSent: 'El cambio se enviará a la aplicación.',
    OperatorWillReceiveMessageAlert: 'Si este registro es más reciente que el existente en la aplicación, el operador recibirá un mensaje de alerta informándole sobre el cambio de su estado.',
    DoYouWantToContinue: '¿Desea continuar?',
    InvisibleCodeAlert: 'Este código está invisible en la tablet, por lo tanto no se enviará a ella.',
    OnlyVisibleOnPlatform: 'Solo se refleja en la Plataforma.',
    ToSendTurnOnVisible: 'Para enviarlo a la tablet, hágalo visible y actualice la estructura de la tablet',
    Continue: 'Continuar',
    Back: 'Volver',
    Tube: 'Tubo',
    GrindingWheel: 'Muela',
    ShockAbsorber: 'Amortiguador',
    Hammer: 'Martillo',
    Rod: 'Cuerda',
    BitHolder: 'Porta Bit',
    Breech: 'Culatra',
    Handle: 'Punho',
  },
  esmx: {
    AnalysisType: 'Tipo de análisis',
    Global: 'Global',
    Local: 'Parcial',
    Sieve: 'Malla',
    TotalMassSample: 'Masa Total de la Muestra',
    Granulometry: 'Granulometría',
    ParticleSieveOpenings: 'Aberturas de malla de partículas',
    SieveOpening: 'Abertura de malla',
    CodeMigrations: 'Migraciones de Códigos',
    CodeMigrationsDynamic: 'Migraciones de Códigos (Dynamic)',
    UnavailableModule: 'Módulo no disponible',
    KnowMore: 'Conocer más', // 🇲🇽 changed from "Saber más"
    Settings: 'Configuración', // 🇲🇽 changed from "Configuraciones"
    Logout: 'Cerrar sesión',
    MiningControl: 'Mining Control', // 🇲🇽 changed from "Mining Control"
    WelcomeTo: 'Bienvenido a',
    Parameter: 'Parámetro',
    EquipmentConfigurations: 'Configuración de Equipos', // 🇲🇽 changed
    GeneralConfigurations: 'Configuración General', // 🇲🇽 changed
    CyclesAutomation: 'Automatización de Ciclos', // 🇲🇽 changed from "Automati. de Ciclos"
    ControlType: 'Tipo de Control',
    Front: 'Frente',
    Equipments: 'Equipos',
    ReserveEquipment: 'Equipo de reserva',
    PerforatorSchedules: 'Programación de Perforadora', // 🇲🇽 changed from "Programación Perforadora"
    EffectiveSchedules: 'Programación Efectiva',
    InactiveTurnPersistency: 'Persistencia de Turno Inactivo',
    RainMode: 'Modo Lluvia',
    ToggleRainMode: 'Activar/Desactivar Modo Lluvia', // 🇲🇽 changed
    SpeedLimit: 'Límite de Velocidad',
    Issue: 'Problema',
    Accept: 'Aceptar',
    ScreenCount: 'Cantidad de Mallas',
    NumberOfArches: 'Marcos ligeros',
    NumberOfLatticeGirders: 'Número de cerchas', // 🇲🇽 changed from "Trelicias"
    NumberOfDowels: 'Marcos ligeros',
    NumberOfSheets: 'Número de cerchas', // 🇲🇽 changed from "Chapas"
    CrusherTab: 'Trituradora', // 🇲🇽 changed from "Molino"
    CrusherTime: 'Tiempo de Trituración', // 🇲🇽 changed
    CrusherStopTime: 'Tiempo de Paro de Trituradora', // 🇲🇽 changed
    Source: 'Fuente',
    FeatureInDevelopment: 'Funcionalidad en desarrollo',
    LastServerConnection: 'Última Conexión al Servidor',
    LastDataSent: 'Últimos Datos Enviados',
    DiconnectedTime: 'Tiempo Desconectado',
    DataToSend: 'Datos por Enviar', // 🇲🇽 changed from "Datos a Enviar"
    AddEditAllocation: 'Agregar/Editar Asignación',
    EditEquipmentScheduling: 'Editar Programación de Equipos', // 🇲🇽 changed
    GoalTypes: 'Tipos de Objetivos', // 🇲🇽 changed from "Metas"
    Goal: 'Objetivo', // 🇲🇽 changed
    GoalsBETA: 'Objetivos (BETA)', // 🇲🇽 changed
    Planning: 'Planificación',
    Short: 'Corto',
    Medium: 'Medio',
    Long: 'Largo',
    Granularity: 'Granularidad',
    DefinitiveNote: 'Registro Definitivo',
    ValueType: 'Tipo de Valor',
    Number: 'Número',
    Discard: 'Descartar',
    discardChanges: 'Descartar cambios', // 🇲🇽 changed from "los cambios"
    TotalTimeInCode: 'Tiempo total en código',
    FullDistance: 'Distancia llena', // 🇲🇽 changed from "completa"
    EmptyDistance: 'Distancia vacía',
    LoadLatitude: 'Latitud de carga',
    LoadLongitude: 'Longitud de carga',
    LoadAltitude: 'Altitud de carga',
    UnloadLatitude: 'Latitud de descarga', // 🇲🇽 changed from "Descargar"
    UnloadLongitude: 'Longitud de descarga',
    UnloadAltitude: 'Altitud de descarga',
    LoadEquipmentNumber: 'Número de equipo de carga', // 🇲🇽 changed
    CycleStageTimes: 'Tiempos de etapa del ciclo',
    Step: 'Etapa',
    railroad_cycle_time_port_exit: 'Maniobra de salida del puerto', // 🇲🇽 changed from "de puerto"
    railroad_cycle_time_empty: 'Tránsito de trenes vacíos', // 🇲🇽 changed from "Circulación"
    railroad_cycle_time_load_entry: 'Maniobra de entrada a la mina',
    railroad_cycle_time_load_queue: 'Fila de carga', // 🇲🇽 changed from "Cola de carga"
    railroad_cycle_time_load: 'Cargando',
    railroad_cycle_time_load_exit: 'Maniobra de salida de mina',
    railroad_cycle_time_full: 'Tránsito de trenes cargados', // 🇲🇽 changed from "Circulación"
    railroad_cycle_time_port_entry: 'Maniobra de entrada al puerto', // 🇲🇽 changed from "a Puerto"
    railroad_cycle_time_unload_queue: 'Fila de descarga', // 🇲🇽 changed from "Cola"
    railroad_cycle_time_unload: 'Descarga',
    TotalInCode: 'Tiempo total en código',
    StandardLoad: 'Carga estándar',
    LoadingEquipment: 'N.º de equipo de carga', // 🇲🇽 changed from "Nº Equipamiento de Carga"
    Finalize: 'Finalizar',
    ConfirmChanges: '¿Confirmar cambios?', // 🇲🇽 changed punctuation
    TaskCodesAndAlerts: 'Actividades y Alertas',
    Text: 'Texto',
    ThereAreNoChanges: 'No hay cambios',
    Resources: 'Recursos',
    Elevation: 'Elevación',
    ScenarioInConfiguration: 'Escenario en configuración', // 🇲🇽 changed from "la configuración"
    Configure: 'Configurar',
    AppliedToAllocations: 'Aplicado a asignaciones',
    AllocationGroup: 'Grupo de asignación',
    MaxQueueTime: 'Tiempo máximo de fila (min)', // 🇲🇽 changed from "cola"
    Elevations: 'Elevaciones', // 🇲🇽 changed from singular
    ElevationGroups: 'Grupos de elevaciones',
    ElevationGroup: 'Grupo de elevación',
    ElementLimits: 'Límites de Elementos',
    ElevationsAssociatedToTheElement: 'Elevaciones asociadas al elemento', // 🇲🇽 changed from "Alzados"
    InitialElevation: 'Elevación inicial',
    FinalElevation: 'Elevación final',
    Creation: 'Creación',
    Current: 'Actual',
    LoadScenarioToContinue: 'Carga un escenario para continuar', // 🇲🇽 changed from "Sube"
    Loaded: 'Cargado',
    LoadAction: 'Cargar',
    FilterByDate: 'Filtrar por fecha',
    ElementsAssociatedToTheScenario: 'Elementos asociados al escenario',
    SubelementsAssociatedToTheScenario: 'Subelementos asociados al escenario', // 🇲🇽 normalized to one word
    LineupNewSchedule: 'Line-up: Nueva programación',
    LineupPlanning: 'Line-up: Planificación',
    Scenarios: 'Escenarios', // 🇲🇽 changed from "Guión"
    Empty: 'Vacío',
    Full: 'Lleno',
    Queue: 'Fila', // 🇲🇽 changed from "Cola"
    Maneuver: 'Maniobra', // 🇲🇽 changed from "Aculatamiento"
    Dump: 'Descarga',
    Stop: 'Parada',
    NotStarted: 'No iniciado', // 🇲🇽 changed from "empezado"
    Disapproved: 'Rechazado', // 🇲🇽 changed from "Desaprobada"
    Paused: 'Pausado',
    InProgress: 'En progreso',
    OnApproval: 'En revisión', // 🇲🇽 changed from "A prueba"
    Finalized: 'Finalizado', // 🇲🇽 changed from feminine
    DeleteSchedule: 'Eliminar programación',
    Time: 'Hora',
    MassT: 'Masa (t)',
    Closings: 'Cierres',
    ClosingsList: 'Lista de cierres',
    Condition: 'Condición',
    Entry: 'Entrada',
    LoginLogout: 'Inicio/Cierre de sesión', // 🇲🇽 changed from "Login/Logout"
    StockClosings: 'Cierres de inventario', // 🇲🇽 changed from "stock"
    Velocity: 'Velocidad',
    AllocationMode: 'Modo de asignación',
    Permanent: 'Permanente',
    Standard: 'Estándar',
    Temporary: 'Temporal',
    AllocatedTo: 'Asignado a',
    CurrentElement: 'Elemento actual',
    CurrentElementPoint: 'Subelemento actual',
    CurrentCycleStep: 'Paso del ciclo actual',
    OriginSubElement: 'Subelemento de origen',
    AllocateTo: 'Asignar a',
    LastModified: 'Última modificación', // 🇲🇽 changed from "Ultimo cambio"
    Origins: 'Orígenes',
    Destinations: 'Destinos',
    Category: 'Categoría',
    Input: 'Insumo',
    MaintenanceType: 'Tipo de Mantenimiento', // 🇲🇽 fixed accent and spelling
    MaintenanceGroup: 'Grupo de Mantenimiento',
    Maintenance: 'Mantenimiento',
    SelectAll: 'Seleccionar todo', // 🇲🇽 plural removed
    HideInterruptedOrDeletedCycles: 'Ocultar ciclos interrumpidos o eliminados',
    HideDeletedEvents: 'Ocultar eventos eliminados', // 🇲🇽 changed from "Esconder"
    FilterByEquipmentGroup: 'Filtrar por grupo de equipo',
    FilterByMaterial: 'Filtrar por material',
    ShiftGroupConnectedToUndergroundModule: 'Grupo de turno vinculado al módulo Subterráneo', // 🇲🇽 changed from "associado"
    ShiftGroupConnectedToOpenPitModule: 'Grupo de turno vinculado al módulo Tajo Abierto',
    FilterByShiftGroup: 'Filtrar por grupo de turno',
    NumberOfIntervals: 'Número de intervalos',
    RpmNoRotation: 'RPM sin rotación (inicio)', // 🇲🇽 changed from "Sem Rotação"
    RpmSlowRunning: 'RPM marcha lenta (inicio)',
    RpmHighSpin: 'RPM rotación alta (inicio)',
    RpmOperation: 'RPM operación (inicio)',
    ContentVariables: 'Gestionar leyes minerales', // 🇲🇽 changed from "Gerenciar Teores"
    AssociationsList: 'Listado de asociaciones', // 🇲🇽 changed from "Listagem"
    ConnectSubElements: 'Asociar subelementos', // 🇲🇽 simplified spelling
    FilterByProjectGroup: 'Filtrar por grupo de proyecto',
    FilterByElement: 'Filtrar por elemento',
    OriginSubElements: 'Subelementos de origen',
    OperationalControl: 'Control Operativo', // 🇲🇽 changed from "Controle Operacional"
    OperationalStop: 'Parada Operativa', // 🇲🇽 changed
    Operation: 'Operación',
    AnomalyLogs: 'Registros de Anomalías',
    AnomalyType: 'Tipo de Anomalía',
    Anomaly: 'Anomalías',
    AnomalousTable: 'Tabla anómala',
    Occurrences: 'Ocurrencias', // 🇲🇽 fixed spelling
    Registers: 'Registros',
    MonthlyAdvance: 'Avance Mensual',
    MonthlyAdvanceMeters: 'Avance Mensual (metros)',
    MaintenanceLogoutLimit: 'Límite de cierre de sesión por mantenimiento', // 🇲🇽 changed from "Maintenance Logout Limit"
    SelectMaintenanceLogoutLevel: 'Selecciona el nivel de cierre por mantenimiento', // 🇲🇽 changed
    ClearCache: 'Limpiar caché',
    DisableCache: 'Deshabilitar caché',
    AccessYourAccount: 'Accede a tu cuenta',
    LoadFactor: 'Factor de carga', // 🇲🇽 fixed from "Fator"
    Welcome: 'Bienvenido a la Plataforma de Control de Minería', // 🇲🇽 changed from pt-br
    RefuellingPerEquipment: 'Repostaje por equipo', // 🇲🇽 changed from "Abastecimento"
    RemainingLitersAlarm: 'Alarma de litros restantes',
    ConnectCodes: 'Asociar códigos',
    GreenPercentage: 'Verde (%)',
    YellowPercentage: 'Amarillo (%)',
    RedPercentage: 'Rojo (%)',
    PurplePercentage: 'Púrpura (%)',
    FilterByEquipType: 'Filtrar por tipo de equipo', // 🇲🇽 changed
    FilterByEquipGroup: 'Filtrar por grupo de equipo',
    TankCapacityLiters: 'Capacidad del tanque (litros)', // 🇲🇽 changed from "Capacidade"
    LitersPerHourConsumption: 'Consumo (litros/hora)',
    MapElement: 'Mapear elemento',
    MapMaterial: 'Mapear material',
    OriginPlural: 'Orígenes',
    DestinationPlural: 'Destinos',
    FilterOriginElements: 'Filtrar elementos de origen',
    FilterDestinationElements: 'Filtrar elementos de destino',
    HoleMeters: 'Metros de perforación', // 🇲🇽 changed from "Haste"
    OriginElement: 'Elemento de origen',
    SubOriginElement: 'Subelemento de origen',
    SubDestinationElement: 'Subelemento de destino',
    DMTMeters: 'DMT (metros)',
    EquipmentScheduling: 'Programación de equipo', // 🇲🇽 changed from "Programação"
    PendenciesApproval: 'Aprobación de pendientes',
    Approve: 'Aprobar',
    Delay: 'Retraso', // 🇲🇽 changed from "Atraso"
    Observation: 'Observación',
    PreventiveType: 'Tipo de mantenimiento preventivo', // 🇲🇽 changed
    RefuelOperatorRegistration: 'Registro del operador de repostaje', // 🇲🇽 changed from "Matrícula"
    RefuelEquipmentGroup: 'Grupo de equipo de carga',
    RefuelEquipment: 'Equipo de carga',
    RefueledEquipmentType: 'Tipo de equipo de carga',
    RefueledEquipmentGroup: 'Grupo de equipo de carga',
    RefueledEquipment: 'Equipo de cargado',
    RefueledOperatorGroup: 'Grupo del operador de cargado',
    RefueledOperator: 'Operador cargado',
    RefuelInitialLatitude: 'Latitud inicio de carga',
    RefuelInitialLongitude: 'Longitud inicio de carga',
    RefuelInitialElement: 'Elemento inicio de carga',
    RefuelInitialSubElement: 'Subelemento inicio de carga',
    RefuelFinalElement: 'Elemento fin de carga',
    RefuelFinalLatitude: 'Latitud fin de carga',
    RefuelFinalLongitude: 'Longitud fin de carga',
    RefuelFinalSubElement: 'Subelemento fin de carga',
    RefueledHourmeterEquipment: 'Horómetro del equipo cargado',
    RefueledEquipmentKilometer: 'Kilometraje del equipo cargado',
    RefueledLiters: 'Litros cargados', // 🇲🇽 changed from "Litragem"
    StopOperationTime: 'Tiempo en código de parada por operación/mantenimiento',
    RefuelTime: 'Tiempo de carga',
    RefuelIntervalTime: 'Tiempo del intervalo de carga',
    RefuelIntervalDistance: 'Distancia del intervalo de carga',
    ReturnDate: 'Fecha de retorno',
    ReturnTime: 'Hora de retorno',
    ReturnLatitude: 'Latitud del retorno',
    ReturnLongitude: 'Longitud del retorno',
    ReturnAltitude: 'Altitud del retorno',
    ReturnElement: 'Elemento del retorno',
    ReturnSubElement: 'Subelemento del retorno',
    ReturnDistance: 'Distancia del retorno',
    ReturnDuration: 'Duración del retorno',
    CutDate: 'Fecha de corte',
    CutTime: 'Hora de corte',
    CutLatitude: 'Latitud del corte',
    CutLongitude: 'Longitud del corte',
    CutAltitude: 'Altitud del corte',
    CutElement: 'Elemento del corte',
    CutSubElement: 'Subelemento del corte',
    CutDistance: 'Distancia del corte',
    CutDuration: 'Duración del corte',
    UnloadTime: 'Tiempo de descarga',
    UnloadTimeAB: 'T. de descarga',
    LoadQueueTime: 'Tiempo de fila de carga',
    LoadQueueTimeAB: 'T. de fila de carga',
    UnloadQueueTime: 'Tiempo de fila de descarga',
    UnloadQueueTimeAB: 'T. de fila de descarga',
    LoadManeuverTime: 'Tiempo de maniobra de carga',
    LoadManeuverTimeAB: 'T. de maniobra de carga',
    UnloadManeuverTime: 'Tiempo de maniobra de descarga',
    UnloadManeuverTimeAB: 'T. de maniobra de descarga',
    EmptyTrafficTime: 'Tiempo de tránsito vacío',
    EmptyTrafficTimeAB: 'T. tránsito vacío',
    FullTrafficTime: 'Tiempo de tránsito lleno',
    FullTrafficTimeAB: 'T. tránsito lleno',
    EmptyTrafficDistance: 'Distancia en tránsito vacío',
    EmptyTrafficDistanceAB: 'D. en tránsito vacío',
    FullTrafficDistance: 'Distancia en tránsito lleno',
    FullTrafficDistanceAB: 'D. en tránsito lleno',
    MaintenanceStopTime: 'Tiempo de paradas por mantenimiento',
    MaintenanceStopTimeAB: 'T. paradas mant.',
    LoadDefault: 'Carga predeterminada',
    LoadDefaultAB: 'C. predeterminada',
    LoadBalance: 'Pesaje de carga (Kg)',
    LoadBalanceAB: 'C. pesaje (Kg)',
    DMTRangesRegister: 'Registro de rangos de DMT',
    RangeCostRegister: 'Registro de costo por rango',
    ManageMoneyPerWorkedHour: 'Gestionar MXN/HT', // 🇲🇽 currency
    RangeName: 'Nombre del rango', // 🇲🇽 changed from "pista"
    InitialM: 'Inicial (m)',
    FinalM: 'Final (m)',
    InitialRangeM: 'Rango inicial (metros)',
    FinalRangeM: 'Rango final (metros)',
    CostMoneyTime: 'Costo (MXN/t)', // 🇲🇽 changed from "R$"
    ValueMoneyTime: 'Valor (MXN/ht)', // 🇲🇽 changed
    Checklist: 'Lista de verificación', // 🇲🇽 changed from English
    CheckListItem: 'Elemento de verificación',
    ConnectChecklist: 'Asociar lista de verificación',
    FilterByEquipmentType: 'Filtrar por tipo de equipo',
    ChecklistItems: 'Elementos de la lista de verificación',
    ObligatoryStop: 'Parada obligatoria',
    DurationMinutes: 'Duración (minutos)',
    MaintenanceData: 'Datos de mantenimiento',
    CodeTab: 'Códigos',
    TractorTab: 'Tractor',
    NumOfBoons: 'N.º de brazos', // 🇲🇽 changed from "Lanças"
    BitDiameterName: 'Nombre del diámetro de la broca', // 🇲🇽 changed
    BitDiameterNameSecond: 'Nombre del segundo diámetro de la broca', // 🇲🇽 changed
    EntryType: 'Tipo de registro',
    Cycle: 'Ciclo',
    EndTime: 'Hora de fin',
    Initial: 'Inicial',
    Final: 'Final',
    NamesVisibility: 'Nombres / Visibilidad',
    InitialHourmeterDiesel: 'Horómetro motor diésel inicial',
    FinalHourmeterDiesel: 'Horómetro motor diésel final',
    InitialHourmeterElectric: 'Horómetro motor eléctrico inicial',
    FinalHourmeterElectric: 'Horómetro motor eléctrico final',

    DispatchModule: 'Módulo de despacho', // 🇲🇽 changed from "Envío"
    AllocatedTrucks: 'Camiones asignados', // 🇲🇽 changed from "seleccionados"
    ClearAllocations: 'Limpiar asignaciones', // 🇲🇽 changed
    AvailableEquipments: 'Equipos disponibles', // 🇲🇽 changed from "Equipamientos"
    MaintenanceEquipments: 'Equipos en mantenimiento',
    NewAllocation: 'Nueva asignación', // 🇲🇽 changed from "selección"
    TruckEquipments: 'Camiones',
    TruckEquipmentGroups: 'Grupos de camiones',
    NoRegisteredAllocations: 'No hay asignaciones registradas', // 🇲🇽 changed
    DeleteAllocation: 'Eliminar asignación',
    Allocation: 'Asignación',
    LoadManager: 'Gestión de carga', // 🇲🇽 changed from "Volumen de material"
    ApplyFilterToFetchData: 'Aplica filtros para obtener datos',
    Mapping: 'Mapeo',
    Filter: 'Filtrar',
    Filters: 'Filtros',
    LoadSchedules: 'Programaciones de carga',
    ShowAll: 'Mostrar todo',
    ShiftGroupConnectedToMaintenanceModule: 'Grupo de turno vinculado al módulo de mantenimiento', // 🇲🇽 changed
    NoOptions: 'Sin opciones',
    DestinationElement: 'Elemento de destino',
    DestinationSubElement: 'Subelemento de destino',
    LoadEquipment: 'Equipo de carga', // 🇲🇽 changed from "Equipamiento"
    LoadEquipmentGroup: 'Grupo de equipo de carga',
    TruckEquipment: 'Camión',
    TruckEquipmentGroup: 'Grupo de camiones',
    RodNumber: 'Número de barras',
    RodPosition: 'Posición de la barra',
    FireDescription: 'Descripción del disparo', // 🇲🇽 changed from "Fuego"
    HoleType: 'Tipo de perforación', // 🇲🇽 changed from "hueco"
    HolePosition: 'Posición de barreno', // 🇲🇽 changed
    Rod: 'Barra',
    Fan: 'Linea de sección', // 🇲🇽 changed from "Corte" — context dependent
    FanName: 'Nombre de la linea de sección',
    NewSchedule: 'Nueva programación',
    RpmRanges: 'Rangos de RPM',
    HourmeterLimits: 'Límites de horómetro',
    HourmeterStart: 'Horómetro inicial',
    HourmeterMax: 'Horómetro máximo',
    EquipmentStatus: 'Estado del equipo',
    EquipmentStatusAbbreviated: 'Estado del eq.',
    EquipmentStatusAbbreviatedV2: 'Estado del Equipo',
    AverageAdvance: 'Avance promedio',
    InputRework: 'Retrabajo',
    InputEffective: 'Efectivo',
    ConnectItems: 'Asociar elementos del sistema',
    Codes: 'Códigos',
    HourmeterTab: 'Horómetro',
    LoadTab: 'Carga',
    PerforatorTab: 'Perforadora',
    RefuelerTab: 'Abastecimiento', // 🇲🇽 changed from "Abastecimento"
    TransportTab: 'Transporte',
    Transport: 'Transporte',
    Tractor: 'Tractor',
    LoaderTab: 'Cargador',
    InfrastructureTab: 'Infraestructura',
    ShaftTab: 'Pozo vertical', // 🇲🇽 changed from "Shaft"
    Active: 'Activo',
    InpUnit: 'Unidad de insumo',
    InputUnit: 'Unidad de insumo',
    Unit: 'Unidad',
    Until: 'Hasta',
    DailyPartsModule: 'Partes diarias', // 🇲🇽 changed from "diarias"
    ManagementModule: 'Gestión',
    FuelModule: 'Combustible',
    ContractsModule: 'Contratos',
    UndergroundModule: 'Subterráneo', // 🇲🇽 translated
    OpenPitModule: 'Tajo Abierto', // 🇲🇽 translated
    DynamicModule: 'Dinámico', // 🇲🇽 translated
    MaintenanceModule: 'Mantenimiento',
    TelemetryModule: 'Telemetría',
    LineupModule: 'Line-Up',
    DateAndTurn: 'Fecha y turno',
    No: 'No',
    Yes: 'Sí',
    Start: 'Inicio',
    Finish: 'Fin',
    All: 'Todos',
    Add: 'Agregar',
    Year: 'Año',
    Month: 'Mes',
    Days: 'Días',
    Day: 'Día',
    DaysQuantity: 'Cantidad de días',
    Register: 'Guardar', // 🇲🇽 changed from "Registrar"
    Enter: 'Iniciar sesión', // 🇲🇽 changed from "Entrar"
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    NoName: 'Sin nombre',
    NoEntries: 'No hay registros', // 🇲🇽 changed from "Sin registros"
    Select: 'Seleccione...',
    Understood: 'Entendido', // 🇲🇽 changed from "Entendí"
    Origin: 'Origen',
    Destination: 'Destino',
    DestinationPoint: 'Punto de destino',
    DestinationPointAB: 'P. de destino',
    OriginPoint: 'Punto de origen',
    OriginPointAB: 'P. de origen',
    Name: 'Nombre',
    Password: 'Contraseña',
    MaxVariation: 'Variación máxima',
    PasswordRedefiniton: 'Redefinir de contraseña', // 🇲🇽 changed from "Redefinir"
    ConfirmPassword: 'Confirmación de contraseña',
    Description: 'Descripción',
    Code: 'Código',
    OriginCode: 'Código de origen',
    OriginCodeMatch: 'Código actual',
    DestinationCode: 'Código de destino',
    DestinationCodeMatch: 'Código agregado',
    CodeReportTable: 'Registro de estados',
    CloudPointReportTable: 'Historial de puntos', // 🇲🇽 changed from "Histórico"
    CodeGroup: 'Grupo de código',
    OriginCodeGroup: 'Grupo de código de origen',
    DestinationCodeGroup: 'Grupo de código de destino',
    CodeGroups: 'Grupos de código',
    CodeType: 'Tipo de código',
    OriginCodeType: 'Tipo de código de origen',
    DestinationCodeType: 'Tipo de código de destino',
    CodeTypes: 'Tipos de código',
    CodeTime: 'Tiempo de código',
    Visible: 'Visible',
    Equipment: 'Equipo',
    EquipmentMach: 'Eq.',
    EquipmentType: 'Tipo de equipo',
    EquipmentTypeAB: 'T. de equipo',
    EquipmentGroup: 'Grupo de equipo',
    EquipmentGroupMatch: 'Grupo del eq.',
    EquipmentGroupAB: 'G. de equipo',
    Range: 'Rango',
    Material: 'Material',
    UpperSieveOpening: 'Abertura de malla superior',
    UpperLimitPercentage: 'Porcentaje límite superior',
    LowerSieveOpening: 'Abertura de malla inferior',
    LowerLimitPercentage: 'Porcentaje límite inferior',
    ControlSieves: 'Mallas de control',
    MaterialSpecifications: 'Especificaciones del material',
    ControlParams: 'Parámetros de control',
    AssociationRegistry: 'Registro de asociación',
    MaterialsGroup: 'Grupo de materiales',
    MaterialGroup: 'Grupo del material',
    Materials: 'Materiales',
    BitDiameter: 'Diámetro de broca',
    BitDiameterSecond: 'Diámetro de broca 2',
    Footage: 'Metraje',
    RodFootage: 'Metraje de varilla',
    Diameter: 'Diámetro',
    Element: 'Elemento',
    Elements: 'Elementos',
    SubElement: 'Subelemento',
    SubElements: 'Subelementos',
    Polygon: 'Polígono',
    RailRoadTab: 'Locomotora',
    Polygons: 'Polígonos',
    Type: 'Tipo',
    Group: 'Grupo',
    Warning: 'Aviso',
    Success: 'Éxito',
    Error: 'Error',
    NetworkError: 'Error de red',
    NoConnection: 'SIN CONEXIÓN A INTERNET', // 🇲🇽 changed tone
    DiscardChanges: 'Descartar cambios', // 🇲🇽 simplified
    End: 'Finalizar',
    InsertNewEntries: 'Insertar nuevos registros',
    ImportSheet: 'Importar hoja de cálculo', // 🇲🇽 changed from "planilla"
    EditEntries: 'Editar registros',
    EditRecordsInBatches: 'Editar registros en lotes',
    ExportEntries: 'Exportar registros',
    EntyType: 'Tipo de registro',
    Movement: 'Movimiento',
    MovementType: 'Tipo de movimiento',
    ProjectGroup: 'Grupo de proyecto',
    Order: 'Orden',
    Priority: 'Prioridad',
    Priorities: 'Prioridades',
    UnitOperation: 'Operación unitaria',
    UnitOperationGroup: 'Grupo de operación unitaria',
    UnitOperationTime: 'Tiempo de operación unitaria',
    SaveData: 'Guardar datos',
    Save: 'Guardar',
    Cycles: 'Ciclos',
    CycleId: 'ID del ciclo',
    CycleTime: 'Tiempo del ciclo',
    CycleDuration: 'Duración del ciclo',
    CycleType: 'Tipo de ciclo',
    CycleInitialTime: 'Hora de inicio del ciclo',
    CycleFinalTime: 'Hora de finalización del ciclo',
    CycleInitialDate: 'Fecha de inicio del ciclo',
    CycleFinalDate: 'Fecha de finalización del ciclo',
    SaveDataAndStartNewCycle: 'Guardar datos e iniciar un nuevo ciclo',
    Comment: 'Comentario',
    ClearFilters: 'Limpiar filtros',
    FilterBy: 'Filtrar por',
    NoElement: 'Sin elemento',
    NotConnected: 'No asociado',
    Productivity: 'Productividad',
    OperationType: 'Tipo de operación',
    Value: 'Valor',
    Operator: 'Operador',
    OperatorGroup: 'Grupo de operadores',
    OperatorGroupAB: 'G. de operadores',
    OperatorTeam: 'Equipo del operador',
    Registration: 'Registro', // 🇲🇽 changed from "Matrícula"
    Team: 'Equipo',
    Teams: 'Equipos',
    TeamGroup: 'Grupo de equipo',
    TeamGroups: 'Grupos de equipo',
    TeamsGroup: 'Grupo de equipos',
    TeamsListing: 'Listado de equipos',
    Associations: 'Asociaciones',
    Pause: 'Pausa',
    AddPause: 'Agregar pausa',
    Period: 'Período',
    Shift: 'Turno',
    ShiftsGroup: 'Grupo de turnos',
    ShiftGroup: 'Grupo de turno',
    ShiftRegistration: 'Registro de turno',
    ShiftSchedule: 'Horario de turno', // 🇲🇽 changed from "Escala"
    ConnectShift: 'Asociar turno',
    Color: 'Color',
    InitialDate: 'Fecha inicial',
    StartDate: 'Fecha de inicio',
    FinalDate: 'Fecha final',
    StartDateTime: 'Fecha y hora inicio',
    EndDateTime: 'Fecha y hora final',
    EndDate: 'Fecha de finalización',
    FinalTime: 'Hora de finalización',
    Date: 'Fecha',
    DateMatch: 'Fecha/Hora de inicio',
    EndDateMatch: 'Fecha/Hora de finalización',
    Hour: 'Hora',
    InitialHour: 'Hora inicial',
    FinalHour: 'Hora final',
    InitialTime: 'Hora de inicio',
    AddEditPause: 'Agregar/Editar pausa',
    DayOff: 'Día libre',
    Interval: 'Descanso',
    Inactive: 'Inactivo',
    Weighing: 'Pesaje',
    Advances: 'Avances',
    Advance: 'Avance',
    EstimatedAdvance: 'Avance estimado',
    MeasuredAdvance: 'Avance medido',
    Search: 'Buscar',
    Find: 'Buscar',
    ResultsFor: 'Resultados para',
    Pointer: 'Usuario web', // 🇲🇽 lowercased "Web"
    SeeMore: 'Ver más',
    Export: 'Exportar',
    Duration: 'Duración',
    DurationMatch: 'Duración actual (min)', // 🇲🇽 changed from "Actual"
    DurationPercentage: 'Duración (%)',
    Latitude: 'Latitud',
    Longitude: 'Longitud',
    Altitude: 'Altitud',
    InitialHourmeter: 'Horómetro inicial',
    FinalHourmeter: 'Horómetro final',
    Hourmeter: 'Horómetro',
    InitialKilometer: 'Kilometraje inicial',
    FinalKilometer: 'Kilometraje final',
    HourMachine: 'Hora máquina',
    HourMachineTab: 'Hora máquina',
    BulkUpdateTransportReportTab: 'Edición masiva',
    MaterialWeight: 'Peso del material',
    MaterialAndOrigin: 'Material y origen',
    LoadTime: 'Tiempo de carga',
    LoadTimeAB: 'T. de carga',
    IdleTime: 'Tiempo inactivo', // 🇲🇽 changed from "Ocioso"
    Drilling: 'Perforación',
    DrillingStartTime: 'Hora de inicio de perforación',
    DrillingStartDate: 'Fecha de inicio de perforación',
    DrillingType: 'Tipo de perforación', // 🇲🇽 changed from "hueco"
    DrillingID: 'ID de perforación', // 🇲🇽 changed
    DrillingCount: 'Número de perforaciones', // 🇲🇽 changed from "huecos"
    DrillingCountSecond: 'Número de perforaciones 2',
    DrillingDepth: 'Profundidad de perforación',
    DrillingDepthSecond: 'Profundidad de perforación 2',
    DrillingDuration: 'Duración de perforación',
    DrillingInformation: 'Información de perforación',
    DrillingEquipment: 'Equipo de perforación',
    Bulldozer: 'Excavadora',
    SleepLevel: 'Nivel de sueño',
    SleepLevelAB: 'N. de sueño',
    TaskCodes: 'Actividades',
    Task: 'Actividad',
    TaskCodeGroup: 'Grupo de actividad',
    TaskCodeType: 'Tipo de actividad',
    TaskCodeItem: 'Elemento de actividad',
    MandatoryStop: 'Parada obligatoria',
    System: 'Sistema',
    SystemItems: 'Elementos del sistema',
    FailureModes: 'Modos de falla',
    ConnectFailureModes: 'Asociar modos de falla',
    FilterSystem: 'Filtrar sistema',
    FilterSystemItem: 'Filtrar elemento del sistema',
    UpdateApps: 'Actualizar aplicaciones',
    PageNotFound: 'Página no encontrada',
    Control: 'Control',
    DailyParts: 'Partes diarios',
    Projects: 'Proyectos',
    UnitOp: 'Op. Unitaria',
    Configuration: 'Configuración',
    AverageLoad: 'Carga promedio',
    Load: 'Carga',
    ServerError: 'Error del servidor',
    EquipScheduling: 'Programación',
    QualityControlModule: 'Calidad',
    Content: 'Contenido',
    FireID: 'ID disparo', // 🇲🇽 changed from "fuego"
    Flow: 'Flujo', // 🇲🇽 corrected from "Fluxo"
    OriginType: 'Tipo de origen',
    DestinationType: 'Tipo de destino',
    Version: 'Versión',
    UpdateToVersion: 'Actualizar a la versión',
    UpdateTablets: 'Actualizar tabletas',
    AndroidAppVersion: 'Gestor de versiones de apps Android',
    TabletConfiguration: 'Configuración de tabletas',
    PlatformConfiguration: 'Configuración de la plataforma',
    CurrentVersion: 'Versión actual',
    Key: 'Clave',
    User: 'Usuario',
    Users: 'Usuarios',
    Level: 'Nivel',
    PlatformLevel: 'Nivel en la plataforma',
    ReportsLevel: 'Nivel en los informes',
    InvalidPassword: 'La contraseña debe tener al menos 8 caracteres y coincidir exactamente', // 🇲🇽 changed
    RockFillTab: 'Relleno de roca',
    Batch: 'Lote',
    StopTime: 'Tiempo de parada',
    EnableEdit: 'Habilitar edición',
    MassEdit: 'Edición masiva',
    NotChange: 'Sin cambios',
    ResetPassword: 'Redefinir de contraseña',
    ResetPasswordDisclaimer: '¿Estás seguro de que deseas restablecer la contraseña?',
    Parent: 'Padre',
    IsDefault: 'Modelo predeterminado',
    Upload: 'Cargar',
    Process: 'Procesar',
    Review: 'Revisar',
    LayerType: 'Tipo de capa',
    LayerName: 'Nombre de la capa',
    Modules: 'Módulos',
    PlatformModules: 'Módulos en la plataforma',
    LoadAllocation: 'Asignación de carga',
    ScissorLiftTab: 'Plataforma elevadora',
    OperationActivity: 'Actividad operativa',
    TotalDimension: 'Dimensiones totales',
    OperationTime: 'Tiempo de operación',
    Page: 'Página',
    Table: 'Tabla',
    UpdateTimestamp: 'Marca de tiempo de la última actualización',
    ControlSync: 'Sincronización de control', // 🇲🇽 clarified
    MassInput: 'Ingreso masivo',
    Equipament: 'Equipo', // 🇲🇽 changed from pt-br "Equipamento"
    Plate: 'Placa',
    WeighingTare: 'Tara',
    Workflow: 'Flujo de trabajo',
    VelocityLimit: 'Límite de velocidad',
    None: 'Ninguno',
    FailToLoadData: 'Error al cargar los datos',
    ReminderByTimeMinutes: 'Recordatorio por tiempo (min)',
    RequestByCode: 'Solicitud por código',
    Railroad_associate_material: 'Es obligatorio asociar al menos un material',
    CyclesNumber: 'Número de ciclos',
    'Commit Changes': 'Confirmar cambios',
    'Discard Changes': 'Descartar cambios',
    Edit: 'Editar',
    Import: 'Importar',
    TotalLoad: 'Carga total',
    EquipmentAllocation: 'Asignación de equipo',
    CodeMaintenanceType: 'Mantenimiento',
    CodeOperationalStopType: 'Parada operativa',
    CodeEffectiveType: 'Efectivo',
    CodeInactiveType: 'Inactivo',
    CodeIdleType: 'Sin operar', // 🇲🇽 changed from "Omisión"
    IsPersistent: 'Registro definitivo',
    CicleAdvance: 'Avance del ciclo',
    AdvanceRegister: 'Registro del avance',
    DistanceKm: 'Kilómetros',
    StepsPerformedByAutomation: 'Pasos realizados por la automatización',
    LAE: 'HAL',
    OperatorLoad: 'Operador que realizó la carga',
    LS: 'IC',
    LE: 'FC',
    US: 'ID',
    UE: 'FD',
    LocalAutomationEnable: 'Habilitar automatización local',
    LoadStart: 'Inicio de carga',
    LoadEnd: 'Fin de carga',
    UnloadStart: 'Inicio de descarga',
    UnloadEnd: 'Fin de descarga',
    Automatic: 'Automático',
    Manual: 'Manual',
    transport_cycle_empty: 'Transporte vacío',
    transport_cycle_full: 'Transporte lleno',
    transport_cycle_load_queue: 'Fila de carga',
    transport_cycle_load_maneuver: 'Maniobra de carga',
    transport_cycle_load: 'Carga',
    transport_cycle_unload_queue: 'Fila de descarga',
    transport_cycle_unload_maneuver: 'Maniobra de descarga',
    transport_cycle_unload: 'Descarga',
    TransportCycleStopped: 'Detenido',
    TransportCycleOverload: 'Sobrecarga',
    TransportCycleInterrupted: 'Interrumpido',
    TransportCycleOpen: 'Abierto',
    TransportCycleChecklist: 'Lista de verificación',
    TransportCycleDefault: 'Predeterminado',
    TransportCycleEmptyStop: 'Parada vacío',
    TransportCycleReleasedEquipment: 'Equipo liberado',
    TransportCycleWeighting: 'Pesaje',
    TransportCycleSupply: 'Suministro',
    TransportCycleDestinationSelection: 'Selección de destino',
    TransportCycleExcavatorSelection: 'Selección de excavadora',
    TransportCycleReturn: 'Retorno',
    TransportCycleCut: 'Corte',
    TransportCycleStrandingScreening: 'Relaves y cribado', // 🇲🇽 changed from "Cribado" = screening
    HoleID: 'ID del agujero', // 🇲🇽 changed from "Hueco"
    ShowInactive: 'Mostrar inactivos',
    ChatBeta: 'Chat (Beta)',
    JumboTab: 'Jumbo',
    Reason: 'Razón',
    JumboExplanation: 'Razones por las que el Jumbo de dos brazos opera con uno solo', // 🇲🇽 clarified
    InactivateAllSelectedItems: 'Desactivar todos los elementos seleccionados',
    RemoveAllSelectedItems: 'Eliminar todos los elementos seleccionados',
    ClearAllSelectedItems: 'Borrar todos los elementos seleccionados',
    ChooseEquipmentType: 'Elige el tipo de equipo', // 🇲🇽 informal command
    Frequency: 'Frecuencia',
    Indicators: 'Indicadores',
    CodeMigrationRules: 'Reglas de migración de códigos',
    MaxTimeInOriginCode: 'Tiempo máximo en código de origen',
    NewCurrentDuration: 'Duración del nuevo código actual (min)',
    NewCodeDuration: 'Duración del nuevo código agregado (min)',
    CodesMigrations: 'Códigos con duración excedida', // 🇲🇽 clearer phrasing
    AleatoryDurationPercentage: 'Porcentaje de duración aleatoria (%)',
    AleatoryProbabilityPercentage: 'Porcentaje de probabilidad aleatoria (%)',
    Closure: 'Cierre',
    ClosureDate: 'Fecha de cierre',
    ConfirmationDate: 'Fecha de confirmación',
    MovementAlreadyRegistered: 'Movimiento ya registrado.',
    ReplacedEquipment: 'Equipo reemplazado',
    ShowOnlyReservedEquips: 'Mostrar solo equipos reservados',
    RegistrationSteps: 'Pasos de registro',
    CargoEquipment: 'Equipo de carga',
    RockFill: 'Relleno de roca',
    Wagon: 'Vagón',
    TypesCargo: 'Camión, equipo de carga, relleno de roca y vagón', // 🇲🇽 translated
    DataUnavailable: 'Datos no disponibles',
    AllocationEdit: 'Edición de asignación',
    LoadingEquipments: 'Equipos de carga',
    SubOrigin: 'Suborigen', // 🇲🇽 normalized
    Restriction: 'Restricción',
    NotAllowedFor: 'no está permitido para el equipo',
    CodeLocation: 'Ubicación',
    ProgrammedOrigin: 'Origen prog.',
    ProgrammedOriginPoint: 'P. de origen prog.',
    ProgrammedMaterial: 'Material prog.',
    ProgrammedDestinationPoint1st: '1.º P. de destino prog.',
    ProgrammedDestinationPoint2nd: '2.º P. de destino prog.',
    Rows: 'Filas',
    EditField: 'Editar campo',
    EditFields: 'Editar campos',
    NewValue: 'Nuevo valor',
    Visibility: 'Visibilidad',
    InvisibleForAll: 'Invisible para todos',
    VisibleForAll: 'Visible para todos',
    VisibleOperation: 'Visible en operación',
    VisibleChecklist: 'Visible en checklist', // 🇲🇽 clearer context
    SubElementType: 'Tipo de Subelemento',
    ScreensNumber: 'Número de pantallas',
    SearchFor: 'Buscar por',
    EditHistory: 'Hist. de edición',
    EditHistoryDatetime: 'Editar fecha/hora.',
    Editor: 'Editor',
    RouteHistory: 'Ruta',
    NoFilterMessage: 'Sin filtro de Equipo y/o Grupo de Equipos',
    FilteredEquipment: 'Equipos filtrados',
    FilteredEquipmentGroups: 'Grupos de Equipos filtrados',
    UnlockPassword: 'Contraseña de Desbloqueo',
    UnlockPasswordValidUntil: 'La contraseña de desbloqueo es válida hasta las',
    ShowPassword: 'Mostrar contraseña',
    Preview: 'Vista previa',
    CurrentlyInUse: 'Actualmente en uso',
    Icon: 'Icono',
    CodeIcon: 'Ícono de Código',
    Dispatch: 'Despacho',
    Chat: 'Chat',
    GotIn: 'ingresó a',
    SentMessage: 'envió un mensaje',
    MessageGroupsBeta: 'Grupos de Mensajes (Beta)',
    GroupsConfiguration: 'Configuración de Grupos',
    AddGroup: 'Agregar grupo',
    MessageGroupName: 'Nombre del Grupo de Mensajes',
    ConfirmActivateMessageGroup: '¿Estás seguro de que deseas ACTIVAR el grupo de mensajes?', // 🇲🇽 informal tone
    ConfirmDeactivateMessageGroup: '¿Estás seguro de que deseas DESACTIVAR el grupo de mensajes?', // 🇲🇽 informal tone
    MessageGroups: 'Grupos de Mensajes',
    SendMessagesToGroup: 'Enviar mensajes al grupo',
    SendMessage: 'Enviar mensaje',
    FilterEquipment: 'Filtrar Equipo',
    SendToGroup: 'Enviar al grupo',
    AllocationGroupExplanation: 'Define a qué grupo de asignación pertenece cada equipo de carga',
    AssessmentInterval: 'Intervalo de evaluación',
    AutoAllocationLogs: 'Asignación de registros dinámicos',
    AvailableMass: 'Masa disponible (t)',
    CalculatePrecedences: 'Calcular precedencias',
    Class: 'Clase',
    CodesRawTab: 'Códigos',
    DatetimeEnd: 'Fecha/hora de finalización',
    DatetimeStart: 'Fecha/hora de inicio',
    DependentElements: 'Elementos dependientes',
    DependentSubElements: 'Subelementos dependientes',
    DynamicAllocation: 'Asignación dinámica',
    DynamicAllocationExplanation: 'Determina si la funcionalidad de asignación dinámica debe admitir esta asignación',
    FilterByElevation: 'Filtrar por elevación',
    FilterByName: 'Filtrar por nombre',
    Goals: 'Objetivos',
    MaxAllocationCapacity: 'Máx. capacidad de asignación',
    MinAllocationCapacityExplanation: 'Define una capacidad mínima de transporte para una excavadora',
    MaxAllocationCapacityExplanation: 'Establece una capacidad máxima de equipo de transporte permitido en una excavadora y bloquea nuevas asignaciones automáticas a la excavadora hasta que haya un espacio disponible.',
    MaxCapacityOfAllocations: 'Máx. capacidad de asignación',
    MaxLoadQueueTime: 'Tiempo máximo de cola de carga (min)',
    MaxLoadQueueTimeExplanation: 'Tiempo máximo de cola que puede tener el equipo de carga, valores superiores a este activan la asignación dinámica',
    MaxTemporaryAllocationCyclesExplanation: 'Número máximo de ciclos que el camión debe permanecer en asignaciones temporales, antes de verse obligado a regresar a su asignación permanente​',
    MaxTimeLoadingQueue: 'Tiempo máximo en cola de carga',
    MaximumTemporaryAllocationCycles: 'Ciclos máximos en asignación temporal',
    MeanQueueTimeRange: 'Intervalo de evaluación de cola (min)',
    MeanQueueTimeRangeExplanation: 'Ventana de tiempo en minutos para calcular el tiempo promedio de espera de una excavadora',
    MinPermanentAllocationCyclesExplanation: 'Número mínimo de ciclos que el camión debe permanecer en su asignación permanente, antes de ser asignado temporalmente',
    MinAllocationCapacityExplanation: 'Cantidad máxima de ciclos que el camión debe permanecer en asignaciones temporales, antes de estar obligado a regresar a su asignación permanente',
    MinAllocationCapacity: 'Capacidad Mín. de Asignaciones',
    MineAvailability: 'Disponibilidad minera',
    MinimumPermanentAllocationCycles: 'Número mínimo de ciclos en asignación permanente',
    Precedences: 'Precedencias',
    Production: 'Producción',
    ReportModule: 'Informes',
    Standby: 'Modo de espera',
    State: 'Estado',
    UnitOpGroup: 'Grupo de Operaciones Unitarias',
    Message: 'Mensaje',
    MessageCategory: 'Categoría de Mensajes',
    MessageRegistration: 'Registro de Mensajes',
    NameMessageCategory: 'Nombre de la Categoría de Mensajes',
    NumberOfTrucksAllocated: 'Número de camiones asignados',
    DMT: 'DMT',
    LastTimestampUpdate: 'Última actualización de marca de tiempo',
    InStandard: 'Estándar',
    Updated: 'Actualizado',
    DuplicatedPlate: 'Matrícula ya registrada',
    SelectEquipmentType: 'Seleccionar tipo de equipo',
    DistanceInEmptyTraffic: 'Distancia en tráfico vacío',
    DistanceInFullTraffic: 'Distancia en tráfico pesado',
    FieldsForEditing: 'Llene los campos que desea modificar (los campos en blanco no se modificarán):',
    BulkEdit: 'Edición masiva',
    TotalOf: 'Total de',
    ChangedResults: 'resultados seleccionados para el cambio',
    OriginalPoint: 'Punto de Origen',
    BulkUpdate: 'Confirmar edición masiva',
    ConfirmContinue: '¿Quieres continuar?',
    BulkUpdateInstructions: 'Para editar más filas, navegue por las páginas para cargar datos adicionales. No se considerarán los ciclos interrumpidos o eliminados.',
    InsertValue: 'Insertar valor',
    RowRangeToEdit: 'Elija el rango de filas que desea cambiar:',
    NumberOfLinesEdited: 'Número de líneas a editar:',
    FuelScreen: 'Pantalla de nivel de combustible',
    FuelLevel: 'Nivel de combustible',
    ItMoves: 'Permite movimiento',
    Type: 'Tipo',
    Group: 'Grupo',
    NoAvailableData: 'No hay datos disponibles para los filtros seleccionados',
    QuantityEquipmentPerGroup: 'Cantidad de equipos por grupo',
    DefaultValue: 'Valor predeterminado',
    EquipmentSituation: 'Estado del equipo',
    Situation: 'Situación',
    EnterText: 'Introduce el texto...',
    ValidUntil: 'Válido hasta',
    DateAndTime: 'Fecha y hora',
    ProgrammingDuration: 'Duración de la programación',
    TypeAMessage: 'Escribe un mensaje...',
    DynamicAllocationAbrev: 'Asig. Dinámica.',
    EnableAllDynamicAlloc: 'Habilitar toda asignación dinámica',
    DisableAllDynamicAlloc: 'Deshabilitar toda asignación dinámica',
    BulkConfigDynamicAlloc: 'Asignación dinámica de configuración masiva',
    WorkfaceControl: 'Control Frentes',
    CodeAndCodeDuration: 'Código y duración del código',
    CodeDateAndTime: 'Fecha y hora del código',
    Highlight: 'Destacado',
    CyclesNumberKanban: 'Número de ciclos',
    Legend: 'Leyenda',
    StartDateAndTime: 'Fecha y hora de inicio',
    NoColumnsAvailable: 'No hay columnas disponibles',
    Detonation: 'Detonación',
    Attention: 'Atención',
    Favorite: 'Favorito',
    ExpediteModule: 'Expedición',
    ExternalMaterialId: 'ID del Material Externo',
    EntryDateAndTime: 'Fecha/Hora de Entrada',
    ExitDateAndTime: 'Fecha/Hora de Salida',
    NetWeight: 'Peso Neto',
    OriginLot: 'Lote de Origen',
    TicketNumber: 'Número de Ticket',
    HideDeletedOrders: 'Ocultar órdenes eliminadas',
    InOperation: 'En Operación',
    Company: 'Empresa',
    AttentionAlert: 'ATENCIÓN',
    ChangeWillBeSent: 'El cambio se enviará a la aplicación.',
    OperatorWillReceiveMessageAlert: 'Si este registro es más reciente que el existente en la aplicación, el operador recibirá un mensaje de alerta informándole sobre el cambio de su estado.',
    DoYouWantToContinue: '¿Desea continuar?',
    InvisibleCodeAlert: 'Este código está invisible en la tablet, por lo tanto no se enviará a ella.',
    OnlyVisibleOnPlatform: 'Solo se refleja en la Plataforma.',
    ToSendTurnOnVisible: 'Para enviarlo a la tablet, hágalo visible y actualice la estructura de la tablet',
    Continue: 'Continuar',
    Back: 'Volver',
    Tube: 'Tubo',
    GrindingWheel: 'Muela',
    ShockAbsorber: 'Amortiguador',
    Hammer: 'Martillo',
    Rod: 'Cuerda',
    BitHolder: 'Porta Bit',
    Breech: 'Culatra',
    Handle: 'Punho',
  },
  escl: {
    AnalysisType: 'Tipo de análisis',
    Global: 'Global',
    Local: 'Parcial',
    Sieve: 'Malla',
    TotalMassSample: 'Masa total de la muestra',
    Granulometry: 'Granulometría',
    ParticleSieveOpenings: 'Aberturas de malla de partículas',
    SieveOpenings: 'Aberturas de malla',
    CodeMigrations: 'Cambios de Códigos',
    CodeMigrationsDynamic: 'Cambios de Códigos (Dinámico)',
    UnavailableModule: 'Módulo no disponible',
    KnowMore: 'Saber más',
    Settings: 'Ajustes',
    Logout: 'Salir',
    MiningControl: 'MiningControl',
    WelcomeTo: 'Bienvenido a',
    Parameter: 'Parámetro',
    EquipmentConfigurations: 'Configuración de Equipos',
    GeneralConfigurations: 'Configuración General',
    CyclesAutomation: 'Automatización de Ciclos',
    ControlType: 'Tipo de Control',
    Front: 'Frente',
    Equipments: 'Maquinaria',
    ReserveEquipment: 'Equipo de respaldo',
    PerforatorSchedules: 'Horarios de Perforadora',
    EffectiveSchedules: 'Programación Efectiva',
    InactiveTurnPersistency: 'Persistencia de Turno Inactivo',
    RainMode: 'Modo Lluvia',
    ToggleRainMode: 'Activar Modo Lluvia',
    SpeedLimit: 'Límite de Velocidad',
    Issue: 'Problema',
    Accept: 'Aceptar',
    ScreenCount: 'Número de Pantallas',
    NumberOfArches: 'Número de arcos',
    NumberOfLatticeGirders: 'Número de vigas',
    NumberOfDowels: 'Número de pernos',
    NumberOfSheets: 'Número de hojas',
    CrusherTab: 'Chancador',
    CrusherTime: 'Tiempo de Chancado',
    CrusherStopTime: 'Tiempo de Parada de Chancado',
    Source: 'Fuente',
    FeatureInDevelopment: 'Función en desarrollo',
    LastServerConnection: 'Última Conexión al Servidor',
    LastDataSent: 'Últimos Datos Enviados',
    DiconnectedTime: 'Tiempo Desconectado',
    DataToSend: 'Datos por Enviar',
    AddEditAllocation: 'Agregar/Editar Asignación',
    EditEquipmentScheduling: 'Editar Programación de Equipos',
    GoalTypes: 'Tipos de Metas',
    Goal: 'Meta',
    GoalsBETA: 'Metas (BETA)',
    Planning: 'Planificación',
    Short: 'Corto',
    Medium: 'Medio',
    Long: 'Largo',
    Granularity: 'Detalle',
    DefinitiveNote: 'Registro Definitivo',
    ValueType: 'Tipo de Valor',
    Number: 'Número',
    Discard: 'Descartar',
    discardChanges: 'Descartar cambios',
    TotalTimeInCode: 'Tiempo total en código',
    FullDistance: 'Distancia cargado',
    EmptyDistance: 'Distancia vacío',
    LoadLatitude: 'Latitud de carga',
    LoadLongitude: 'Longitud de carga',
    LoadAltitude: 'Elevación de carga',
    UnloadLatitude: 'Latitud de descarga',
    UnloadLongitude: 'Longitud de descarga',
    UnloadAltitude: 'Elevación de descarga',
    LoadEquipmentNumber: 'Número de equipo de carga',
    CycleStageTimes: 'Tiempos de etapa del ciclo',
    Step: 'Paso',
    railroad_cycle_time_port_exit: 'Maniobra salida puerto',
    railroad_cycle_time_empty: 'Circulación trenes vacíos',
    railroad_cycle_time_load_entry: 'Maniobra entrada mina',
    railroad_cycle_time_load_queue: 'Cola de carga',
    railroad_cycle_time_load: 'Cargando',
    railroad_cycle_time_load_exit: 'Maniobra salida mina',
    railroad_cycle_time_full: 'Circulación trenes cargados',
    railroad_cycle_time_port_entry: 'Maniobra Entrada Puerto',
    railroad_cycle_time_unload_queue: 'Cola de descarga',
    railroad_cycle_time_unload: 'Descargando',
    TotalInCode: 'Tiempo total en Código',
    StandardLoad: 'Carga estándar',
    LoadingEquipment: 'Nº Equipo de Carga',
    Finalize: 'Finalizar',
    ConfirmChanges: '¿Confirmar cambios?',
    TaskCodesAndAlerts: 'Actividades y Alertas',
    Text: 'Texto',
    ThereAreNoChanges: 'No hay cambios',
    Resources: 'Recursos',
    Elevation: 'Elevación',
    ScenarioInConfiguration: 'Escenario en configuración',
    Configure: 'Configurar',
    AppliedToAllocations: 'Aplicado a asignaciones',
    AllocationGroup: 'Grupo de asignación',
    MaxQueueTime: 'Tiempo máximo de cola (min)',
    Elevations: 'Elevaciones',
    ElevationGroups: 'Grupos de elevación',
    ElevationGroup: 'Grupo de elevación',
    ElementLimits: 'Límites de Elementos',
    ElevationsAssociatedToTheElement: 'Elevaciones asociadas al elemento',
    InitialElevation: 'Elevación inicial',
    FinalElevation: 'Elevación final',
    Creation: 'Creación',
    Current: 'Actual',
    LoadScenarioToContinue: 'Carga un escenario para continuar',
    Loaded: 'Cargado',
    LoadAction: 'Cargar',
    FilterByDate: 'Filtrar por fecha',
    ElementsAssociatedToTheScenario: 'Elementos del escenario',
    SubelementsAssociatedToTheScenario: 'Subelementos del escenario',
    LineupNewSchedule: 'Line-up: Nuevo horario',
    LineupPlanning: 'Line-up: Planificación',
    Scenarios: 'Escenarios',
    Empty: 'Vacío',
    Full: 'Cargado',
    Queue: 'Cola',
    Maneuver: 'Maniobra',
    Dump: 'Descarga',
    Stop: 'Parada',
    NotStarted: 'No iniciado',
    Disapproved: 'Rechazado',
    Paused: 'Pausado',
    InProgress: 'En progreso',
    OnApproval: 'En prueba',
    Finalized: 'Finalizado',
    DeleteSchedule: 'Eliminar Programación',
    Time: 'Hora',
    MassT: 'Tonelaje (t)',
    Closings: 'Cierres',
    ClosingsList: 'Lista de cierres',
    Condition: 'Condición',
    Entry: 'Entrada',
    LoginLogout: 'Entrada/Salida',
    StockClosings: 'Cierres de stock',
    Velocity: 'Velocidad',
    AllocationMode: 'Modo de asignación',
    Permanent: 'Permanente',
    Standard: 'Estándar',
    Temporary: 'Temporal',
    AllocatedTo: 'Asignado a',
    CurrentElement: 'Elemento actual',
    CurrentElementPoint: 'Subelemento actual',
    CurrentCycleStep: 'Paso actual del ciclo',
    OriginSubElement: 'Subelemento de origen',
    AllocateTo: 'Asignar a',
    LastModified: 'Última modificación',
    Origins: 'Orígenes',
    Destinations: 'Destinos',
    Category: 'Categoría',
    Input: 'Insumo',
    MaintenanceType: 'Tipo de Mantenimiento',
    MaintenanceGroup: 'Grupo de Mantenimiento',
    Maintenance: 'Mantenimiento',
    SelectAll: 'Seleccionar todo',
    HideInterruptedOrDeletedCycles: 'Ocultar ciclos interrumpidos o eliminados',
    HideDeletedEvents: 'Ocultar eventos eliminados',
    FilterByEquipmentGroup: 'Filtrar por Grupo de Equipo',
    FilterByMaterial: 'Filtrar por Material',
    ShiftGroupConnectedToUndergroundModule: 'Grupo de turno asociado al módulo Underground',
    ShiftGroupConnectedToOpenPitModule: 'Grupo de turno asociado al módulo Open Pit',
    FilterByShiftGroup: 'Filtrar Por Grupo de Turno',
    NumberOfIntervals: 'Número de Intervalos',
    RpmNoRotation: 'RPM sin rotación (inicio)',
    RpmSlowRunning: 'RPM mínimo (inicio)',
    RpmHighSpin: 'RPM alto (inicio)',
    RpmOperation: 'RPM operación (inicio)',
    ContentVariables: 'Gestionar Contenidos',
    AssociationsList: 'Lista de Asociaciones',
    ConnectSubElements: 'Asociar sub-elementos',
    FilterByProjectGroup: 'Filtrar por grupo de proyecto',
    FilterByElement: 'Filtrar por elemento',
    OriginSubElements: 'Sub-elementos de origen',
    OperationalControl: 'Control Operacional',
    OperationalStop: 'Parada Operativa',
    Operation: 'Operación',
    AnomalyLogs: 'Registros de Anomalías',
    AnomalyType: 'Tipo de Anomalía',
    Anomaly: 'Anomalías',
    AnomalousTable: 'Tabla anómala',
    Occurrences: 'Ocurrencias',
    Registers: 'Registros',
    MonthlyAdvance: 'Avance Mensual',
    MonthlyAdvanceMeters: 'Avance Mensual (metros)',
    MaintenanceLogoutLimit: 'Límite de Salida por Mantenimiento',
    SelectMaintenanceLogoutLevel: 'Seleccionar nivel de salida para mantenimiento',
    ClearCache: 'Limpiar Cache',
    DisableCache: 'Deshabilitar Cache',
    AccessYourAccount: 'Accede a tu cuenta',
    LoadFactor: 'Factor de carga',
    Welcome: 'Bienvenido a la Plataforma Mining Control',
    RefuellingPerEquipment: 'Abastecimiento por Equipo',
    RemainingLitersAlarm: 'Alarma de Litros Restantes',
    ConnectCodes: 'Asociar Códigos',
    GreenPercentage: 'Verde (%)',
    YellowPercentage: 'Amarillo (%)',
    RedPercentage: 'Rojo (%)',
    PurplePercentage: 'Morado (%)',
    FilterByEquipType: 'Filtrar por Tipo de Equipo',
    FilterByEquipGroup: 'Filtrar por grupo de equipo',
    TankCapacityLiters: 'Capacidad Tanque (litros)',
    LitersPerHourConsumption: 'Consumo (litros/hora)',
    MapElement: 'Mapear Elemento',
    MapMaterial: 'Mapear Material',
    OriginPlural: 'Orígenes',
    DestinationPlural: 'Destinos',
    FilterOriginElements: 'Filtrar Elementos de Origen',
    FilterDestinationElements: 'Filtrar Elementos de Destino',
    HoleMeters: 'Barreno',
    OriginElement: 'Elemento de Origen',
    SubOriginElement: 'Sub-Elemento de Origen',
    SubDestinationElement: 'Sub-Elemento de Destino',
    DMTMeters: 'DMT (metros)',
    EquipmentScheduling: 'Programación de Equipo',
    PendenciesApproval: 'Aprobación de Pendientes',
    Approve: 'Aprobar',
    Delay: 'Retraso',
    Observation: 'Observación',
    PreventiveType: 'Tipo de Preventivo',
    RefuelOperatorRegistration: 'Matrícula Operador Abastecimiento',
    RefuelEquipmentGroup: 'Grupo Equipo Abastecimiento',
    RefuelEquipment: 'Equipo Abastecimiento',
    RefueledEquipmentType: 'Tipo Equipo Abastecido',
    RefueledEquipmentGroup: 'Grupo Equipo Abastecido',
    RefueledEquipment: 'Equipo Abastecido',
    RefueledOperatorGroup: 'Grupo del Operador Abastecido',
    RefueledOperator: 'Operador Abastecido',
    RefuelInitialLatitude: 'Latitud Inicio Abastecimiento',
    RefuelInitialLongitude: 'Longitud Inicio Abastecimiento',
    RefuelInitialElement: 'Elemento Inicio Abastecimiento',
    RefuelInitialSubElement: 'Sub-Elemento Inicio Abastecimiento',
    RefuelFinalElement: 'Elemento Fin Abastecimiento',
    RefuelFinalLatitude: 'Latitud Fin Abastecimiento',
    RefuelFinalLongitude: 'Longitud Fin Abastecimiento',
    RefuelFinalSubElement: 'Sub-Elemento Fin Abastecimiento',
    RefueledHourmeterEquipment: 'Horómetro Equipo Abastecido',
    RefueledEquipmentKilometer: 'Kilometraje Equipo Abastecido',
    RefueledLiters: 'Litros Abastecidos',
    StopOperationTime: 'Tiempo en parada por operación/mantenimiento',
    RefuelTime: 'Tiempo de carga',
    RefuelIntervalTime: 'Tiempo del intervalo de carga',
    RefuelIntervalDistance: 'Distancia del intervalo de carga',
    ReturnDate: 'Fecha de retorno',
    ReturnTime: 'Hora de retorno',
    ReturnLatitude: 'Latitud del retorno',
    ReturnLongitude: 'Longitud del retorno',
    ReturnAltitude: 'Altitud del retorno',
    ReturnElement: 'Elemento del retorno',
    ReturnSubElement: 'Subelemento del retorno',
    ReturnDistance: 'Distancia del retorno',
    ReturnDuration: 'Duración del retorno',
    CutDate: 'Fecha de Corte',
    CutTime: 'Hora de Corte',
    CutLatitude: 'Latitud del corte',
    CutLongitude: 'Longitud del corte',
    CutAltitude: 'Altitud del corte',
    CutElement: 'Elemento del Corte',
    CutSubElement: 'Subelemento del corte',
    CutDistance: 'Distancia del corte',
    CutDuration: 'Duración del corte',
    UnloadTime: 'Tiempo de descarga',
    UnloadTimeAB: 'T. de Descarga',
    LoadQueueTime: 'Tiempo de fila de carga',
    LoadQueueTimeAB: 'T. de Fila de Carga',
    UnloadQueueTime: 'Tiempo de fila de descarga',
    UnloadQueueTimeAB: 'T. de Fila de Desc.',
    LoadManeuverTime: 'Tiempo de maniobra de carga',
    LoadManeuverTimeAB: 'T. de Man. de Carga',
    UnloadManeuverTime: 'Tiempo de maniobra de descarga',
    UnloadManeuverTimeAB: 'T. de Man. de Desc.',
    EmptyTrafficTime: 'Tiempo de tránsito vacío',
    EmptyTrafficTimeAB: 'T. tránsito vacío',
    FullTrafficTime: 'Tiempo de tránsito cargado',
    FullTrafficTimeAB: 'T. tránsito cargado',
    EmptyTrafficDistance: 'Distancia en tránsito vacío',
    EmptyTrafficDistanceAB: 'D. tránsito vacío',
    FullTrafficDistance: 'Distancia en tránsito cargado',
    FullTrafficDistanceAB: 'D. tránsito cargado',
    MaintenanceStopTime: 'Tiempo de paradas por mantenimiento',
    MaintenanceStopTimeAB: 'T. Paradas Mantenimiento',
    LoadDefault: 'Carga estándar',
    LoadDefaultAB: 'Carga Estándar',
    LoadBalanceAB: 'Carga pesaje (Kg)',
    DMTRangesRegister: 'Registro de rangos de DMT',
    RangeCostRegister: 'Registro de costo por rango',
    ManageMoneyPerWorkedHour: 'Gestionar R$/HT',
    RangeName: 'Nombre del rango',
    InitialM: 'Inicial (m)',
    FinalM: 'Final (m)',
    InitialRangeM: 'Rango Inicial (metros)',
    FinalRangeM: 'Rango Final (metros)',
    CostMoneyTime: 'Costo (R$/t)',
    ValueMoneyTime: 'Valor (R$/ht)',
    Checklist: 'Checklist',
    CheckListItem: 'Item de Checklist',
    ConnectChecklist: 'Asociar Checklist',
    FilterByEquipmentType: 'Filtrar por tipo de equipo',
    ChecklistItems: 'Items de Checklist',
    ObligatoryStop: 'Parada obligatoria',
    DurationMinutes: 'Duración (minutos)',
    MaintenanceData: 'Datos de mantenimiento',
    CodeTab: 'Códigos',
    TractorTab: 'Tractor',
    NumOfBoons: 'Nº de Lanzas',
    BitDiameterName: 'Nombre Diámetro Broca',
    BitDiameterNameSecond: 'Nombre Diámetro Broca 2',
    EntryType: 'Tipo de Registro',
    Cycle: 'Ciclo',
    EndTime: 'Hora Fin',
    Initial: 'Inicial',
    Final: 'Final',
    NamesVisibility: 'Nombres/Visibilidad',
    InitialHourmeterDiesel: 'Horómetro Motor Diésel Inicial',
    FinalHourmeterDiesel: 'Horómetro Motor Diésel Final',
    InitialHourmeterElectric: 'Horómetro Motor Eléctrico Inicial',
    FinalHourmeterElectric: 'Horómetro Motor Eléctrico Final',

    DispatchModule: 'Despacho',
    AllocatedTrucks: 'Camiones asignados',
    ClearAllocations: 'Limpiar asignaciones',
    AvailableEquipments: 'Maquinarias disponibles',
    MaintenanceEquipments: 'Maquinarias en mantenimiento',
    NewAllocation: 'Nueva asignación',
    TruckEquipments: 'Camiones',
    TruckEquipmentGroups: 'Grupos de camión',
    NoRegisteredAllocations: 'Sin asignaciones registradas',
    DeleteAllocation: 'Eliminar asignación',
    Allocation: 'Asignación',
    LoadManager: 'Volumen de material',
    ApplyFilterToFetchData: 'Aplica filtros para buscar datos',
    Mapping: 'Mapeo',
    Filter: 'Filtrar',
    Filters: 'Filtros',
    LoadSchedules: 'Programación de carga',
    ShowAll: 'Mostrar todo',
    ShiftGroupConnectedToMaintenanceModule: 'Grupo de turno asociado al módulo mantenimiento',
    NoOptions: 'Sin opciones',
    DestinationElement: 'Elemento de destino',
    DestinationSubElement: 'Subelemento de destino',
    LoadEquipment: 'Maquinaria de Carga',
    LoadEquipmentGroup: 'Grupo de maquinaria de Carga',
    TruckEquipment: 'Camión',
    TruckEquipmentGroup: 'Grupo de camión',
    RodNumber: 'Número de varillas',
    RodPosition: 'Posición de la varilla',
    FireDescription: 'Descripción Fuego',
    HoleType: 'Tipo de perforación',
    HolePosition: 'Posición de la perforación',
    Rod: 'Varilla',
    Fan: 'Corte',
    FanName: 'Nombre del Corte',
    NewSchedule: 'Nueva programación',
    RpmRanges: 'Rangos RPM',
    HourmeterLimits: 'Límites de Horómetro',
    HourmeterStart: 'Horómetro Inicial',
    HourmeterMax: 'Horómetro Máximo',
    EquipmentStatus: 'Estado del maquinaria',
    EquipmentStatusAbbreviated: 'Estado Maquinaria',
    EquipmentStatusAbbreviatedV2: 'Estado del Maquinaria',
    AverageAdvance: 'Avance promedio',
    InputRework: 'Retrabajo',
    InputEffective: 'Efectivo',
    ConnectItems: 'Asociar elementos de sistema',
    Codes: 'Códigos',
    HourmeterTab: 'Horómetro',
    LoadTab: 'Carga',
    PerforatorTab: 'Perforadora',
    RefuelerTab: 'Abastecimiento',
    TransportTab: 'Transporte',
    Transport: 'Transporte',
    Tractor: 'Tractor',
    LoaderTab: 'Cargador',
    InfrastructureTab: 'Equipos de Apoyo',
    ShaftTab: 'Shaft',
    Active: 'Activo',
    InpUnit: 'Un. de insumo',
    InputUnit: 'Unidad de insumo',
    Unit: 'Unidad',
    Until: 'Hasta',
    DailyPartsModule: 'Registros diarios',
    ManagementModule: 'Gestión',
    FuelModule: 'Combustible',
    ContractsModule: 'Contratos',
    UndergroundModule: 'Underground',
    OpenPitModule: 'Open Pit',
    DynamicModule: 'Dynamic',
    MaintenanceModule: 'Mantenimiento',
    TelemetryModule: 'Telemetría',
    LineupModule: 'Line-Up',
    DateAndTurn: 'Fecha y turno',
    No: 'No',
    Yes: 'Sí',
    Start: 'Inicio',
    Finish: 'Fin',
    All: 'Todos',
    Add: 'Agregar',
    Year: 'Año',
    Month: 'Mes',
    Days: 'Días',
    Day: 'Día',
    DaysQuantity: 'Cantidad de días',
    Register: 'Registrar',
    Enter: 'Entrar',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    NoName: 'Sin nombre',
    NoEntries: 'Sin registros',
    Select: 'Seleccionar...',
    Understood: 'Entendido',
    Origin: 'Origen',
    Destination: 'Destino',
    DestinationPoint: 'Punto de destino',
    DestinationPointAB: 'P. destino',
    OriginPoint: 'Punto de origen',
    OriginPointAB: 'P. origen',
    Name: 'Nombre',
    Password: 'Contraseña',
    MaxVariation: 'Variación Máxima',
    PasswordRedefiniton: 'Restablecer contraseña',
    ConfirmPassword: 'Confirmar contraseña',
    Description: 'Descripción',
    Code: 'Código',
    OriginCode: 'Código de Origen',
    OriginCodeMatch: 'Código Actual',
    DestinationCode: 'Código de Destino',
    DestinationCodeMatch: 'Código Agregado',
    CodeReportTable: 'Registro de Estados',
    CloudPointReportTable: 'Histórico de Puntos',
    CodeGroup: 'Grupo de código',
    OriginCodeGroup: 'Grupo de código de origen',
    DestinationCodeGroup: 'Grupo de código de destino',
    CodeGroups: 'Grupos de código',
    CodeType: 'Tipo de código',
    OriginCodeType: 'Tipo de Código de origen',
    DestinationCodeType: 'Tipo de Código de destino',
    CodeTypes: 'Tipos de código',
    CodeTime: 'Tiempo de código',
    Visible: 'Visible',
    Equipment: 'Maquinaria',
    EquipmentMach: 'Equipo',
    EquipmentType: 'Tipo de Maquinaria',
    EquipmentTypeAB: 'Tipo Equipo',
    EquipmentGroup: 'Grupo de Maquinaria',
    EquipmentGroupMatch: 'Grupo de Maquinaria',
    EquipmentGroupAB: 'Grupo Maquinaria',
    Range: 'Rango',
    Material: 'Material',
    UpperSieveOpening: 'Apertura de malla superior',
    UpperLimitPercentage: 'Porcentaje límite superior',
    LowerSieveOpening: 'Apertura de malla inferior',
    LowerLimitPercentage: 'Porcentaje límite inferior',
    ControlSieves: 'Mallas de control',
    MaterialSpecifications: 'Especificaciones del material',
    ControlParams: 'Parámetros de control',
    AssociationRegistry: 'Registro de asociación',
    MaterialsGroup: 'Grupo de materiales',
    MaterialGroup: 'Grupo del material',
    Materials: 'Materiales',
    BitDiameter: 'Diámetro Broca',
    BitDiameterSecond: 'Diámetro Broca 2',
    Footage: 'Metraje',
    RodFootage: 'Metraje de varilla',
    Diameter: 'Diámetro',
    Element: 'Elemento',
    Elements: 'Elementos',
    SubElement: 'Subelemento',
    SubElements: 'Subelementos',
    Polygon: 'Polígono',
    RailRoadTab: 'Locomotora',
    Polygons: 'Polígonos',
    Type: 'Tipo',
    Group: 'Grupo',
    Warning: 'Advertencia',
    Success: 'Éxito',
    Error: 'Error',
    NetworkError: 'Error de red',
    NoConnection: 'FALLO DE CONEXIÓN A INTERNET',
    DiscardChanges: 'Descartar cambios',
    End: 'Finalizar',
    InsertNewEntries: 'Insertar nuevos registros',
    ImportSheet: 'Importar planilla',
    EditEntries: 'Editar registros',
    EditRecordsInBatches: 'Editar registros en lotes',
    ExportEntries: 'Exportar Registros',
    EntyType: 'Tipo de registro',
    Movement: 'Movimiento',
    MovementType: 'Tipo de movimiento',
    ProjectGroup: 'Grupo de proyecto',
    Order: 'Orden',
    Priority: 'Prioridad',
    Priorities: 'Prioridades',
    UnitOperation: 'Operación Unitaria',
    UnitOperationGroup: 'Grupo de operación unitaria',
    UnitOperationTime: 'Tiempo de operación unitaria',
    SaveData: 'Guardar datos',
    Save: 'Guardar',
    Cycles: 'Ciclos',
    CycleId: 'ID del ciclo',
    CycleTime: 'Tiempo de ciclo',
    CycleDuration: 'Duración del ciclo',
    CycleType: 'Tipo de ciclo',
    CycleInitialTime: 'Hora inicio ciclo',
    CycleFinalTime: 'Hora fin ciclo',
    CycleInitialDate: 'Fecha inicio ciclo',
    CycleFinalDate: 'Fecha fin ciclo',
    SaveDataAndStartNewCycle: 'Guardar datos e iniciar nuevo ciclo',
    Comment: 'Comentario',
    ClearFilters: 'Limpiar filtros',
    FilterBy: 'Filtrar por',
    NoElement: 'Sin elemento',
    NotConnected: 'No asociado',
    Productivity: 'Productividad',
    OperationType: 'Tipo de operación',
    Value: 'Valor',
    Operator: 'Operador',
    OperatorGroup: 'Grupo de operadores',
    OperatorGroupAB: 'Grupo operadores',
    OperatorTeam: 'Equipo del operador',
    Registration: 'Patente',
    Team: 'Equipo',
    Teams: 'Equipos',
    TeamGroup: 'Grupo de trabajo',
    TeamGroups: 'Grupo de trabajo',
    TeamsGroup: 'Grupos de trabajo',
    TeamsListing: 'Listado de equipos',
    Associations: 'Asociaciones',
    Pause: 'Pausa',
    AddPause: 'Agregar pausa',
    Period: 'Período',
    Shift: 'Turno',
    ShiftsGroup: 'Grupo de turnos',
    ShiftGroup: 'Grupo de turno',
    ShiftRegistration: 'Registro de turno',
    ShiftSchedule: 'Programa del turno',
    ConnectShift: 'Asociar turno',
    Color: 'Color',
    InitialDate: 'Fecha inicial',
    StartDate: 'Fecha inicio',
    FinalDate: 'Fecha final',
    StartDateTime: 'Fecha y hora inicio',
    EndDateTime: 'Fecha y hora final',
    EndDate: 'Fecha fin',
    FinalTime: 'Hora fin',
    Date: 'Fecha',
    DateMatch: 'Fecha/Hora inicio',
    EndDateMatch: 'Fecha/Hora fin',
    Hour: 'Hora',
    InitialHour: 'Hora inicial',
    FinalHour: 'Hora final',
    InitialTime: 'Hora inicio',
    AddEditPause: 'Agregar/Editar pausa',
    DayOff: 'Día libre',
    Interval: 'Descanso',
    Inactive: 'Inactivo',
    Weighing: 'Peso',
    Advances: 'Avances',
    Advance: 'Avance',
    EstimatedAdvance: 'Avance estimado',
    MeasuredAdvance: 'Avance medido',
    Search: 'Buscar',
    Find: 'Buscar',
    ResultsFor: 'Resultados para',
    Pointer: 'Usuario Web',
    SeeMore: 'Ver más',
    Export: 'Exportar',
    Duration: 'Duración',
    DurationMatch: 'Duración Actual (min)',
    DurationPercentage: 'Duración (%)',
    Latitude: 'Latitud',
    Longitude: 'Longitud',
    Altitude: 'Altitud',
    InitialHourmeter: 'Horómetro inicial',
    FinalHourmeter: 'Horómetro final',
    Hourmeter: 'Horómetro',
    InitialKilometer: 'Kilometraje inicial',
    FinalKilometer: 'Kilometraje final',
    HourMachine: 'Horómetro',
    HourMachineTab: 'Horómetros',
    BulkUpdateTransportReportTab: 'Edición masiva',
    MaterialWeight: 'Peso del material',
    MaterialAndOrigin: 'Material y Origen',
    LoadTime: 'Tiempo de carga',
    LoadTimeAB: 'T. carga',
    IdleTime: 'Tiempo Ocioso',
    Drilling: 'Perforación',
    DrillingStartTime: 'Hora inicio perforación',
    DrillingStartDate: 'Fecha inicio perforación',
    DrillingType: 'Tipo de hueco',
    DrillingID: 'Identificador del pozo',
    DrillingCount: 'Número de pozos',
    DrillingCountSecond: 'Número de pozos 2',
    DrillingDepth: 'Profundidad del pozo',
    DrillingDepthSecond: 'Profundidad del pozo 2',
    DrillingDuration: 'Tiempo de perforación',
    DrillingInformation: 'Información de perforación',
    DrillingEquipment: 'Equipo de perforación',
    Bulldozer: 'Excavadora',
    SleepLevel: 'Nivel de sueño',
    SleepLevelAB: 'N. sueño',
    TaskCodes: 'Actividades',
    Task: 'Actividad',
    TaskCodeGroup: 'Grupo de actividad',
    TaskCodeType: 'Tipo de actividad',
    TaskCodeItem: 'Elemento de actividad',
    MandatoryStop: 'Parada obligatoria',
    System: 'Sistema',
    SystemItems: 'Elementos del sistema',
    FailureModes: 'Modos de falla',
    ConnectFailureModes: 'Asociar modos de falla',
    FilterSystem: 'Filtrar Sistema',
    FilterSystemItem: 'Filtrar elemento de Sistema',
    UpdateApps: 'Actualizar aplicaciones',
    PageNotFound: 'Página no encontrada',
    Control: 'Control',
    DailyParts: 'R. Diarios',
    Projects: 'Proyectos',
    UnitOp: 'Op. Unitaria',
    Configuration: 'Configuración',
    AverageLoad: 'Carga media',
    Load: 'Carga',
    ServerError: 'Error del Servidor',
    EquipScheduling: 'Programación',
    QualityControlModule: 'Calidad',
    Content: 'Contenido',
    FireID: 'ID fuego',
    Flow: 'Flujo',
    OriginType: 'Tipo de Origen',
    DestinationType: 'Tipo de Destino',
    Version: 'Versión',
    UpdateToVersion: 'Actualizar a versión',
    UpdateTablets: 'Actualizar tablets',
    AndroidAppVersion: 'Administrador de versiones de Android',
    TabletConfiguration: 'Configuración de tablets',
    PlatformConfiguration: 'Configuración de plataforma',
    CurrentVersion: 'Versión actual',
    Key: 'Clave',
    User: 'Usuario',
    Users: 'Usuarios',
    Level: 'Nivel',
    PlatformLevel: 'Nivel en Plataforma',
    ReportsLevel: 'Nivel en Informes',
    InvalidPassword: 'Las contraseñas deben tener al menos 8 caracteres y ser iguales',
    RockFillTab: 'Relleno',
    Batch: 'Lote',
    StopTime: 'Tiempo parada',
    EnableEdit: 'Habilitar Editar',
    MassEdit: 'Edición masiva',
    NotChange: 'Sin cambios',
    ResetPassword: 'Restablecer contraseña',
    ResetPasswordDisclaimer: '¿Estás seguro de restablecer la contraseña?',
    Parent: 'Padre',
    IsDefault: 'Modelo Predeterminado',
    Upload: 'Subir',
    Process: 'Procesar',
    Review: 'Revisar',
    LayerType: 'Tipo de capa',
    LayerName: 'Nombre de capa',
    Modules: 'Módulos',
    PlatformModules: 'Módulos en Plataforma',
    LoadAllocation: 'Asignación de carga',
    ScissorLiftTab: 'Plataforma Elevadora',
    OperationActivity: 'Actividad Operativa',
    TotalDimension: 'Dimensiones Totales',
    OperationTime: 'Tiempo de Operación',
    Page: 'Página',
    Table: 'Tabla',
    UpdateTimestamp: 'Marca tiempo última actualización',
    ControlSync: 'Control Sync',
    MassInput: 'Inserción masiva',
    Equipament: 'Maquinaria',
    Plate: 'Patente',
    WeighingTare: 'Tara',
    Workflow: 'Flujo de Trabajo',
    VelocityLimit: 'Límite de Velocidad',
    None: 'Ninguno',
    FailToLoadData: 'Error al cargar datos',
    ReminderByTimeMinutes: 'Recordatorio por tiempo (min)',
    RequestByCode: 'Solicitud por código',
    Railroad_associate_material: 'Obligatorio asociar al menos un material',
    CyclesNumber: 'Número de Ciclos',
    'Commit Changes': 'Confirmar cambios',
    'Discard Changes': 'Descartar cambios',
    Edit: 'Editar',
    Import: 'Importar',
    TotalLoad: 'Carga Total',
    EquipmentAllocation: 'Asignación de equipos',
    CodeMaintenanceType: 'Mantenimiento',
    CodeOperationalStopType: 'Parada Operacional',
    CodeEffectiveType: 'Efectivo',
    CodeInactiveType: 'Inactivo',
    CodeIdleType: 'Omisión',
    IsPersistent: 'Registro Definitivo',
    CicleAdvance: 'Avance de ciclo',
    AdvanceRegister: 'Registro de Avance',
    DistanceKm: 'Kilometraje',
    StepsPerformedByAutomation: 'Pasos realizados por automatización',
    LAE: 'HAL',
    OperatorLoad: 'Operador que cargó',
    LS: 'IC',
    LE: 'FC',
    US: 'ID',
    UE: 'FD',
    LocalAutomationEnable: 'Habilitar automatización local',
    LoadStart: 'Inicio de carga',
    LoadEnd: 'Fin de carga',
    UnloadStart: 'Inicio Descarga',
    UnloadEnd: 'Fin Descarga',
    Automatic: 'Automático',
    Manual: 'Manual',
    transport_cycle_empty: 'Tránsito Vacío',
    transport_cycle_full: 'Tránsito Cargado',
    transport_cycle_load_queue: 'Cola de Carga',
    transport_cycle_load_maneuver: 'Maniobra de Carga',
    transport_cycle_load: 'Carga',
    transport_cycle_unload_queue: 'Cola de Descarga',
    transport_cycle_unload_maneuver: 'Maniobra de Descarga',
    transport_cycle_unload: 'Descarga',
    TransportCycleStopped: 'Detención',
    TransportCycleOverload: 'Sobrecarga',
    TransportCycleInterrupted: 'Interrumpido',
    TransportCycleOpen: 'Abierto',
    TransportCycleChecklist: 'Checklist',
    TransportCycleDefault: 'Estándar',
    TransportCycleEmptyStop: 'Detención Vacío',
    TransportCycleReleasedEquipment: 'Equipo Liberado',
    TransportCycleWeighting: 'Pesaje',
    TransportCycleSupply: 'Abastecimiento',
    TransportCycleDestinationSelection: 'Selección de Destino',
    TransportCycleExcavatorSelection: 'Selección de Excavadora',
    TransportCycleReturn: 'Retorno',
    TransportCycleCut: 'Corte',
    TransportCycleStrandingScreening: 'Relaves y Cribado',
    HoleID: 'ID del Pozo',
    ShowInactive: 'Mostrar Inactivos',
    ChatBeta: 'Chat (Beta)',
    MessageRegistration: 'Registro de Mensajes',
    MessageCategory: 'Categoría de Mensajes',
    NameMessageCategory: 'Nombre Categoría de Mensajes',
    Message: 'Mensaje',
    JumboTab: 'Jumbo',
    Reason: 'Razón',
    JumboExplanation: 'Razones para Jumbo de dos brazos opere con un brazo',
    InactivateAllSelectedItems: 'Desactivar elementos seleccionados',
    RemoveAllSelectedItems: 'Eliminar elementos seleccionados',
    ClearAllSelectedItems: 'Limpiar elementos seleccionados',
    ChooseEquipmentType: 'Elegir tipo de equipo',
    Frequency: 'Frecuencia',
    Indicators: 'Indicadores',
    CodeMigrationRules: 'Reglas de migración de código',
    MaxTimeInOriginCode: 'Tiempo máximo en código origen',
    NewCurrentDuration: 'Duración nuevo código actual (min)',
    NewCodeDuration: 'Duración código agregado (min)',
    CodesMigrations: 'Códigos de duración excedida',
    AleatoryDurationPercentage: 'Duración Período aleatorio (%)',
    AleatoryProbabilityPercentage: 'Probabilidad aleatoria (%)',
    Closure: 'Cierre',
    ClosureDate: 'Fecha de Cierre',
    ConfirmationDate: 'Fecha de Confirmación',
    MovementAlreadyRegistered: 'Movimiento ya registrado.',
    ReplacedEquipment: 'Equipo Reemplazado',
    ShowOnlyReservedEquips: 'Filtrar solo equipo reservado',
    RegistrationSteps: 'Pasos de Registro',
    CargoEquipment: 'Equipo de Carguío',
    RockFill: 'Rock Fill',
    Wagon: 'Vagón',
    TypesCargo: 'Camión, equipo de carga, rock fill, y vagón',
    DataUnavailable: 'Datos no disponibles',
    AllocationEdit: 'Edición de Asignación',
    LoadingEquipments: 'Equipo de carga',
    SubOrigin: 'Sub Origen',
    Restriction: 'Restricción',
    NotAllowedFor: 'no permitido para el equipo',
    CodeLocation: 'Ubicación',
    ProgrammedOrigin: 'Origen Prog.',
    ProgrammedOriginPoint: 'P. Origen Prog.',
    ProgrammedMaterial: 'Material Prog.',
    ProgrammedDestinationPoint1st: '1º P. Destino Prog.',
    ProgrammedDestinationPoint2nd: '2º P. Destino Prog.',
    Rows: 'Filas',
    EditField: 'editar campo',
    EditFields: 'Editar campos',
    NewValue: 'Nuevo valor',
    Visibility: 'Visibilidad',
    InvisibleForAll: 'Invisible para todos',
    VisibleForAll: 'Visible para todos',
    VisibleOperation: 'Visible operación',
    VisibleChecklist: 'Visible pre-checklist',
    SubElementType: 'Tipo de Subelemento',
    ScreensNumber: 'Número de pantallas',
    SearchFor: 'Buscar por',
    EditHistory: 'Hist. edición',
    EditHistoryDatetime: 'Editar fecha/hora',
    Editor: 'Editor',
    RouteHistory: 'Ruta',
    NoFilterMessage: 'Sin filtro de Equipo y/o Grupo de Equipos',
    FilteredEquipment: 'Equipos filtrados',
    FilteredEquipmentGroups: 'Grupos de Equipos filtrados',
    UnlockPassword: 'Contraseña de Desbloqueo',
    UnlockPasswordValidUntil: 'La contraseña de desbloqueo es válida hasta',
    ShowPassword: 'Mostrar contraseña',
    Preview: 'Vista previa',
    CurrentlyInUse: 'En uso actualmente',
    Icon: 'Icono',
    CodeIcon: 'Icono de Código',
    Dispatch: 'Despacho',
    Chat: 'Chat',
    GotIn: 'entró en',
    SentMessage: 'envió mensaje',
    MessageGroupsBeta: 'Grupos de Mensajes (Beta)',
    GroupsConfiguration: 'Configuración de Grupos',
    AddGroup: 'Agregar grupo',
    MessageGroupName: 'Nombre Grupo de Mensajes',
    ConfirmActivateMessageGroup: '¿Está seguro de ACTIVAR el grupo de mensajes?',
    ConfirmDeactivateMessageGroup: '¿Está seguro de DESACTIVAR el grupo de mensajes?',
    MessageGroups: 'Grupos de Mensajes',
    SendMessagesToGroup: 'Enviar mensajes al grupo',
    SendMessage: 'Enviar mensaje',
    FilterEquipment: 'Filtrar Equipo',
    SendToGroup: 'Enviar al grupo',
    AllocationGroupExplanation: 'Define a qué grupo de asignación pertenece cada equipo de carga',
    AssessmentInterval: 'Intervalo de evaluación',
    AutoAllocationLogs: 'Asignación de registros dinámicos',
    AvailableMass: 'Masa disponible (t)',
    CalculatePrecedences: 'Calcular precedencias',
    Class: 'Clase',
    CodesRawTab: 'Códigos',
    DatetimeEnd: 'Fecha/hora fin',
    DatetimeStart: 'Fecha/hora inicio',
    DependentElements: 'Elementos dependientes',
    DependentSubElements: 'Subelementos dependientes',
    DynamicAllocation: 'Asignación dinámica',
    DynamicAllocationExplanation: 'Determina si la asignación dinámica debe admitir esta asignación',
    FilterByElevation: 'Filtrar por elevación',
    FilterByName: 'Filtrar por nombre',
    Goals: 'Target',
    MaxAllocationCapacity: 'Máx. capacidad asignación',
    MinAllocationCapacityExplanation: 'Define una capacidad mínima de transporte para una excavadora',
    MaxAllocationCapacityExplanation: 'Establece capacidad máxima de equipo de transporte permitido en excavadora',
    MaxCapacityOfAllocations: 'Máx. capacidad asignación',
    MaxLoadQueueTime: 'Tiempo máximo cola carga (min)',
    MaxLoadQueueTimeExplanation: 'Tiempo máximo de cola para equipo de carga',
    MaxTemporaryAllocationCyclesExplanation: 'Ciclos máximos en asignaciones temporales',
    MaxTimeLoadingQueue: 'Tiempo máximo en cola carga',
    MaximumTemporaryAllocationCycles: 'Ciclos máximos asignación temporal',
    MeanQueueTimeRange: 'Intervalo evaluación cola (min)',
    MeanQueueTimeRangeExplanation: 'Ventana de tiempo para calcular tiempo promedio de espera',
    MinPermanentAllocationCyclesExplanation: 'Ciclos mínimos en asignación permanente',
    MinAllocationCapacityExplanation: 'Cantidad máxima de ciclos que el camión debe permanecer en asignaciones temporales, antes de estar obligado a volver a su asignación permanente',
    MinAllocationCapacity: 'Capacidad Mín. de Asignaciones',
    MineAvailability: 'Disponibilidad minera',
    MinimumPermanentAllocationCycles: 'Ciclos mínimos asignación permanente',
    Precedences: 'Precedencias',
    Production: 'Producción',
    ReportModule: 'Informes',
    Standby: 'En espera',
    State: 'Estado',
    UnitOpGroup: 'Grupo Operaciones Unitarias',
    DMT: 'DMT',
    LastTimestampUpdate: 'Última actualización',
    Standard: 'Estándar',
    Updated: 'Actualizado',
    DuplicatedPlate: 'Patente ya registrada',
    SelectEquipmentType: 'Seleccionar tipo de maquinaria',
    DistanceInEmptyTraffic: 'Distancia tránsito vacío',
    DistanceInFullTraffic: 'Distancia tránsito cargado',
    FieldsForEditing: 'Complete campos a modificar (campos vacíos no se modificarán):',
    BulkEdit: 'Edición masiva',
    TotalOf: 'Total de',
    ChangedResults: 'resultados seleccionados para cambio',
    OriginalPoint: 'Punto Origen',
    BulkUpdate: 'Confirmar edición masiva',
    ConfirmContinue: '¿Continuar?',
    BulkUpdateInstructions: 'Para editar más filas, navegue por páginas para cargar datos adicionales',
    InsertValue: 'Insertar valor',
    RowRangeToEdit: 'Elija rango de filas a cambiar:',
    NumberOfLinesEdited: 'Número de líneas a editar:',
    ItMoves: 'Permite movimiento',
    TypeAMessage: 'Escribe un mensaje...',
    DynamicAllocationAbrev: 'Asig. Dinámica.',
    EnableAllDynamicAlloc: 'Habilitar toda asignación dinámica',
    DisableAllDynamicAlloc: 'Deshabilitar toda asignación dinámica',
    BulkConfigDynamicAlloc: 'Asignación dinámica de configuración masiva',
    WorkfaceControl: 'Control Frentes',
    CodeAndCodeDuration: 'Código y duración del código',
    CodeDateAndTime: 'Fecha y hora del código',
    Highlight: 'Destacado',
    CyclesNumberKanban: 'Número de ciclos',
    Legend: 'Leyenda',
    StartDateAndTime: 'Fecha y hora de inicio',
    NoColumnsAvailable: 'No hay columnas disponibles',
    Detonation: 'Detonación',
    Attention: 'Atención',
    Favorite: 'Favorito',
    ExpediteModule: 'Expedición',
    ExternalMaterialId: 'ID del Material Externo',
    EntryDateAndTime: 'Fecha/Hora de Entrada',
    ExitDateAndTime: 'Fecha/Hora de Salida',
    NetWeight: 'Peso Neto',
    OriginLot: 'Lote de Origen',
    TicketNumber: 'Número de Ticket',
    HideDeletedOrders: 'Ocultar órdenes eliminadas',
    InOperation: 'En Operación',
    Company: 'Empresa',
    AttentionAlert: 'ATENCIÓN',
    ChangeWillBeSent: 'El cambio se enviará a la aplicación.',
    OperatorWillReceiveMessageAlert: 'Si este registro es más reciente que el existente en la aplicación, el operador recibirá un mensaje de alerta informándole sobre el cambio de su estado.',
    DoYouWantToContinue: '¿Desea continuar?',
    InvisibleCodeAlert: 'Este código está invisible en la tablet, por lo tanto no se enviará a ella.',
    OnlyVisibleOnPlatform: 'Solo se refleja en la Plataforma.',
    ToSendTurnOnVisible: 'Para enviarlo a la tablet, hágalo visible y actualice la estructura de la tablet',
    Continue: 'Continuar',
    Back: 'Volver',
    Tube: 'Tubo',
    GrindingWheel: 'Muela',
    ShockAbsorber: 'Amortiguador',
    Hammer: 'Martillo',
    Rod: 'Cuerda',
    BitHolder: 'Porta Bit',
    Breech: 'Culatra',
    Handle: 'Punho',
  },
};

export const date = {
  en: {
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    DateFormat: 'MM/DD/YYYY',
    DateTimeFormat: 'MM/DD/YYYY HH:mm',
    FullDateTimeFormat: 'MM/DD/YYYY HH:mm:ss',
    ShortDateTimeFormat: 'MM/DD/YY HH:mm',
    Locale: 'en-US',
  },
  ptbr: {
    Mon: 'Seg',
    Tue: 'Ter',
    Wed: 'Qua',
    Thu: 'Qui',
    Fri: 'Sex',
    Sat: 'Sab',
    Sun: 'Dom',
    January: 'Janeiro',
    February: 'Fevereiro',
    March: 'Março',
    April: 'Abril',
    May: 'Maio',
    June: 'Junho',
    July: 'Julho',
    August: 'Agosto',
    September: 'Setembro',
    October: 'Outubro',
    November: 'Novembro',
    December: 'Dezembro',
    DateFormat: 'DD/MM/YYYY',
    DateTimeFormat: 'DD/MM/YYYY HH:mm',
    FullDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    ShortDateTimeFormat: 'DD/MM/YY HH:mm',
    Locale: 'pt-BR',
  },
  es: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Vie',
    Sat: 'Sáb',
    Sun: 'Dom',
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
    DateFormat: 'DD/MM/YYYY',
    DateTimeFormat: 'DD/MM/YYYY HH:mm',
    FullDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    ShortDateTimeFormat: 'DD/MM/YY HH:mm',
    Locale: 'es',
  },
  esmx: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Vie',
    Sat: 'Sáb',
    Sun: 'Dom',
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
    DateFormat: 'DD/MM/YYYY',
    DateTimeFormat: 'DD/MM/YYYY HH:mm',
    FullDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    ShortDateTimeFormat: 'DD/MM/YY HH:mm',
    Locale: 'es-MX', // 🇲🇽 changed from "es"
  },
  escl: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mié',
    Thu: 'Jue',
    Fri: 'Vie',
    Sat: 'Sáb',
    Sun: 'Dom',
    January: 'Ene',
    February: 'Feb',
    March: 'Mar',
    April: 'Abr',
    May: 'May',
    June: 'Jun',
    July: 'Jul',
    August: 'Ago',
    September: 'Sep',
    October: 'Oct',
    November: 'Nov',
    December: 'Dic',
    DateFormat: 'DD/MM/YYYY',
    DateTimeFormat: 'DD/MM/YYYY HH:mm',
    FullDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    ShortDateTimeFormat: 'DD/MM/YY HH:mm',
    Locale: 'es',
  },
};

export const validation = {
  en: {
    FinalDateSmallerThanInitialDate: 'End date can\'t be less than start date',
    PrecedenceCalculationWillOverrideCurrentConfiguration: 'Precedence calculation will override your current configuration. Would you like to continue?',
    FinalElevationMustBeBiggerThanInitialElevation: 'Final elevation has to be higher than initial elevation',
    LineupScenariosInDateRangeWillBeOverriden: 'Scenarios in this date range will be overriden',
    FormWasNotFilledCorrectly: 'The form was not fille correctly',
    ExistingSchedule: 'This equipment is already scheduled for this period',
    WarningScheduleChange: 'The modifications will affect subsequent schedules. Would you like to continue?',
    WarningTerrainModelDelete: 'Are you sure you want to delete this terrain model?',
    WarningNoDefaultModelSelected: 'You must select a default model',
    ThisActionWillClearAllYourAllocations: 'This action will remove all allocations. Would you like to continue?',
    ExpiredSession: 'Your session has expired, login to continue',
    DateIntervalAlreadyRegistered: 'Date interval already registered',
    AlreadyHasFootage: 'Depth already registered',
    TurnGroupAlreadyRegisteredForEquipGroup: 'A turn group has already been registered for this equipment group',
    ThereAreBlankFields: 'You must fill all fields before saving',
    CantHaveMultipleTurnsWithSameTeam: 'A team can\'t be assigned to multiple turns in the same day',
    AlreadyRegisteredUnit: 'Unit was already registered',
    WouldYouLikeToUpdateApps: 'Would you like to update the apps?',
    WouldYouLikeToExit: 'Would you like to quit?',
    RequiredField: 'Required Field',
    AlreadyRegisteredFootage: 'Footage already registered',
    AlreadyRegisteredDiameter: 'Diameter already registered',
    AlreadyRegisteredName: 'Name already registered',
    CantHaveSameOrder: 'Order can\' be the same as in other operations',
    SameOrderInSameGroupNotAllowed: 'Repeated orders are not allowed in the same group',
    SameNameInSameGroupNotAllowed: 'Repeated names are not allowed in the same group',
    ProductivityAlreadyExists: 'Productivity already exists',
    InitialDateRequired: 'Start date is required',
    FinalDateRequired: 'End date is required',
    FinalDateSmallerThanInitialDate: 'End date can\'t be less than start date',
    SearchTimeRangeCantExceed: 'Search time can\'t exceed',
    CodeTypeDoesntAllowNewGroups: 'Code type doesn\'t allow new groups',
    ThereAreUnsavedPriorities: 'There are unsaved priorities. Would you like to save anyway?',
    CantHaveSubElementsWithSamePriority: 'Two sub-elements can\'t have the same priority',
    NoDataMessage: 'No data to show yet',
    YouHaveUnsavedData: 'You have unsaved data',
    SheetImportSuccess: 'Spreadsheet imported successfully',
    SavedSuccess: 'Saved successfully',
    UpdateSentSuccessfully: 'Update sent successfuly',
    InvalidDate: 'Invalid date',
    InvalidPeriodDate: 'Period date before limit date',
    InvalidHour: 'Invalid hour',
    FutureDateCantBeSelected: 'Future date can\'t be selected',
    FutureTimeCantBeSelected: 'Future hour can\'t be selected',
    NoMaintenanceItems: 'No maintenance items registered',
    ModelUploadSuccess: 'Model uploaded successfully',
    ModelUploadError: 'Model upload error',
    ModelProcessingSuccess: 'Model processed successfully',
    UploadCanceled: 'Upload canceled',
    ClosureSavingWarning: 'This action will block the insertion and editing of data history from the registered date. Do you want to continue?',
    InvalidClosurePeriod: 'The closing period cannot be shorter than the last one completed.',
    YouCanCheckYourDates: 'Attention! By submitting changes you may generate inconsistency in the timeline, are you sure you want to continue?',
    EndMomentCantBeLowerThanStartMoment: 'End moment can\'t be lower than Start moment',
    DateCantBeLowerThanConsolidation: 'Date can\'t be lower than consolidation time',
    ImportErrors: 'Import Errors',
    Row: 'Row',
    Col: 'Column',
    notEmpty: 'Cannot be empty',
    LimitCharactersExceeded: 'The limit of characters has been exceeded',
    maxLength20: 'Can only have 20 characters',
    maxLength55: 'Can only have 55 characters',
    maxLength64: 'Can only have 64 characters',
    maxLength128: 'Can only have 128 characters',
    mustBeNumeric: 'Must be numeric',
    validChars: "Can only contain -, _, |, +, ), (, ', º, ., /",
    GroupNotFound: 'Group not found.',
    DuplicatedRegister: 'Duplicated register.',
    CannotEditId: 'Cannot edit ID.',
    CannotEditIdOrGroup: 'Cannot edit ID or Group.',
    Inactive: 'Inactive',
    EquipTypeNotFound: 'Equip type not found.',
    CodeTypeNotFound: 'Code type not found.',
    CodeNotFound: 'Code not found.',
    OperatorNotFound: 'Operator not found.',
    CodeTypeAndCodeGroupNotRelated: 'Code type, code group aren\'t related.',
    EquipTypeAndGroupTypeAndGroupCodeNotRelated: 'Equip type, code type, code group aren\'t related.',
    MaterialGroupNotFound: 'Material group not found.',
    MaterialGroupNotFoundOrInactive: 'Material Group not found or inactive.',
    MaterialNotFound: 'Material not found.',
    ReportUrlNotRegistered: 'Please enter your report URL into the\nplatform\'s configuration database.\nKey: url_reports and url_reports_maps.',
    OperatorExistent: 'Operator already exists.',
    RegistrationExistent: 'Registration already exists',
    EquipmentGroupNotFound: 'Equipment Group not found.',
    TurnNotFound: 'Turn not found.',
    CompleteTheRegistration: 'To complete the registration of the equipment and equipment group, if applicable, register:',
    CompleteTheRegistrationMenuTabs: 'To complete the shift and class registration, follow the registration flow in the menu tabs.',
    utmXOutOfRange: 'The UTM X value must be between 100,000 and 999,999.',
    utmYOutOfRange: 'The UTM Y value must be between 0,0 and 10,000,000.',
    MustBeAtLeastOne: 'Value must be at least one.',
    ValidationDispachModule: 'Agility and practicality for optimization, programming and allocation of equipment in real time. Want to know how Despacho can transform your business? Our commercial team is available to offer all the details and benefits.',
    ActionEdit: 'This action will edit',
    DoYouContinue: 'Do you want to continue?',
    ContentAlreadyRegistered: 'Content already registered for the chosen date.',
    InitialDateGreaterThanStartDate: 'Start date cannot be greater than the end date.',
    ElementNotFound: 'Element not found.',
    SubElementNotFound: 'Sub-element not found.',
    NotificationMaximumMessage: 'Maximum number of messages logged for categories',
    NotificationMaximumCategory: 'Maximum number of 10 registered categories.',
    CantDefineRodNumber: '\'Rod Number\' allowed only when \'Operation Type\' is \'Suporte em Desenvolvimento\'.',
    InvalidRodNumber: '\'Rod Number\' must be an integer greater than or equal to 0.',
    InvalidScreensNumber: '\'Screens Number\' must be an integer greater than or equal to 0.',
    UniqueGroupMessageName: 'Message group name already exists.',
    GroupMessageSendSuccess: 'Message sent successfully!',
    MustBeGreaterThanZero: 'Value must be greater than 0.',
    FuelLevelMustBeBetween: 'Fuel level must be between 1 and 100.',
    DateCantBeInTheFuture: 'The date cannot be in the future',
    DateMustBeInTheFuture: 'The date must be in the future',
    BulkActiveDynamic: 'This action will enable dynamic allocation for all allocations. Do you want to continue?',
    BulkInactiveDynamic: 'This action will disable dynamic allocation for all allocations. Do you want to continue?',
    BulkEditAllEquipmentsStatus: 'This action will edit all selected equipment. Do you wish to continue?',
    ConflictingLoadFactorPeriod: 'A period that conflicts with another load factor.',
    JustNumbers: 'Just numbers',
    InvalidFormat: 'Invalid format',
    EquipmentAllocatedCannotDeactivate: 'The equipment is allocated and cannot be deactivated.',
  },
  ptbr: {
    FinalDateSmallerThanInitialDate: 'Data final não pode ser menor que data inicial',
    PrecedenceCalculationWillOverrideCurrentConfiguration: 'O cálculo de precedências irá sobrescrever sua configuração atual. Deseja continuar?',
    FinalElevationMustBeBiggerThanInitialElevation: 'Elevação final deve ser maior que a inicial',
    LineupScenariosInDateRangeWillBeOverriden: 'Cenários neste intervalo de datas serão sobrescritos',
    FormWasNotFilledCorrectly: 'O formulário não foi preenchido corretamente',
    ExistingSchedule: 'Este equipamento ja está programado para este período',
    WarningScheduleChange: 'A modificação afetará programações subsequentes. Deseja continuar?',
    WarningTerrainModelDelete: 'Tem certeza que deseja excluir este modelo de terreno?',
    WarningNoDefaultModelSelected: 'Você deve selecionar um modelo padrão',
    ThisActionWillClearAllYourAllocations: 'Esta ação excluirá todas as alocações atuais. Deseja continuar?',
    ExpiredSession: 'Sua sessão expirou, faça login novamente para continuar',
    DateIntervalAlreadyRegistered: 'Intervalo de datas já registrado',
    AlreadyHasFootage: 'Metragem já cadastrada',
    TurnGroupAlreadyRegisteredForEquipGroup: 'Já existe um grupo de turnos cadastrado para este grupo de equipamentos',
    ThereAreBlankFields: 'Todos os campos devem ser preenchidos antes de salvar',
    CantHaveMultipleTurnsWithSameTeam: 'Uma turma não pode ser associada a dois turnos distintos no mesmo dia',
    AlreadyRegisteredUnit: 'Unidade já cadastrada',
    WouldYouLikeToUpdateApps: 'Você gostaria de atualizar os aplicativos?',
    WouldYouLikeToExit: 'Você gostaria de sair do sistema?',
    RequiredField: 'Campo obrigatório',
    AlreadyRegisteredFootage: 'Metragem já cadastrada',
    AlreadyRegisteredDiameter: 'Diâmetro já cadastrado',
    AlreadyRegisteredName: 'Nome já cadastrado',
    CantHaveSameOrder: 'Não pode ter a mesma ordem que outra operação',
    SameOrderInSameGroupNotAllowed: 'Não é permitido mesma ordem no mesmo grupo',
    SameNameInSameGroupNotAllowed: 'Não é permitido mesmo nome no mesmo grupo',
    ProductivityAlreadyExists: 'Produtividade já existe',
    InitialDateRequired: 'Data inicial deve ser preenchida',
    FinalDateRequired: 'Data final deve ser preenchida',
    FinalDateSmallerThanInitialDate: 'Data final não pode ser menor que data inicial',
    SearchTimeRangeCantExceed: 'Tempo de pesquisa não pode exceder',
    CodeTypeDoesntAllowNewGroups: 'Tipo de código não permite grupos novos',
    ThereAreUnsavedPriorities: 'Existem prioridades ainda não definidas. Gostaria de salvar mesmo assim?',
    CantHaveSubElementsWithSamePriority: 'Você não pode ter sub-elementos com mesma prioridade.',
    NoDataMessage: 'Ainda não existem dados disponíveis',
    YouHaveUnsavedData: 'Você possui dados alterados que precisam ser salvos',
    SheetImportSuccess: 'Planilha importada com sucesso',
    SavedSuccess: 'Salvo com sucesso',
    UpdateSentSuccessfully: 'Atualização enviada com sucesso',
    InvalidDate: 'Data inválida',
    InvalidPeriodDate: 'Data anterior a data limite',
    InvalidHour: 'Hora inválida',
    FutureDateCantBeSelected: 'Data futura não pode ser selecionada',
    FutureTimeCantBeSelected: 'Hora futura não pode ser selecionada',
    NoMaintenanceItems: 'Não existem dados de manutenção cadastrados',
    ModelUploadSuccess: 'Modelo enviado com sucesso',
    ModelUploadError: 'Erro ao enviar modelo',
    ModelProcessingSuccess: 'Modelo processado com sucesso',
    UploadCanceled: 'Upload cancelado',
    ClosureSavingWarning: 'Esta ação irá bloquear a inserção e edição do histórico de dados a partir da data cadastrada. Deseja continuar ?',
    InvalidClosurePeriod: 'O período de fechamento não pode ser menor que o último realizado.',
    YouCanCheckYourDates: 'Atenção! Ao enviar as alterações você pode gerar inconsistência na linha do tempo, tem certeza que deseja continuar?',
    EndMomentCantBeLowerThanStartMoment: 'Momento Final não pode ser menor que o inicial',
    DateCantBeLowerThanConsolidation: 'A data não pode ser menor do que a data de consolidação',
    ImportErrors: 'Erros de Importação',
    Row: 'Linha',
    Col: 'Coluna',
    notEmpty: 'Não pode estar vazio',
    LimitCharactersExceeded: 'Limite de caracteres excedido',
    maxLength20: 'Pode ter no máximo 20 caracteres',
    maxLength55: 'Pode ter no máximo 55 caracteres',
    maxLength64: 'Pode ter no máximo 64 caracteres',
    maxLength128: 'Pode ter no máximo 128 caracteres',
    mustBeNumeric: 'Deve ser numérico',
    validChars: "Pode conter apenas -, _, |, +, ), (, ', º, ., /",
    GroupNotFound: 'Grupo não encontrado.',
    DuplicatedRegister: 'Registro duplicado.',
    CannotEditIdOrGroup: 'Não é possível editar o ID ou o Grupo.',
    CannotEditId: 'Não é possível editar o ID.',
    Inactive: 'Inativo',
    EquipTypeNotFound: 'Tipo de equipamento não encontrado.',
    CodeTypeNotFound: 'Tipo de código não encontrado.',
    CodeNotFound: 'Código não encontrado.',
    OperatorNotFound: 'Operador não encontrado.',
    CodeTypeAndCodeGroupNotRelated: 'Tipo de código e grupo de código não estão relacionados.',
    EquipTypeAndGroupTypeAndGroupCodeNotRelated: 'Tipo de equipamento, tipo de código e grupo de código não estão relacionados.',
    MaterialGroupNotFound: 'Grupo de Material não encontrado',
    MaterialGroupNotFoundOrInactive: 'Grupo de Material não encontrado ou inativo',
    MaterialNotFound: 'Material não encontrado.',
    ReportUrlNotRegistered: 'Por favor, insira a URL do seu relatório no banco de dados\nde configuração da plataforma.\nChave: url_reports e url_reports_maps.',
    OperatorExistent: 'Operador já existe',
    RegistrationExistent: 'Registro já existe',
    EquipmentGroupNotFound: 'Grupo de Equipamento não encontrado.',
    TurnNotFound: 'Turno não encontrado.',
    CompleteTheRegistration: 'Para finalizar o cadastro do grupo de equipamento e equipamento, se aplicável, cadastre:',
    CompleteTheRegistrationMenuTabs: 'Para finalizar o cadastro de turno e turma, siga o fluxo de cadastro das abas do menu.',
    utmXOutOfRange: 'O valor da UTM X deve estar entre 100.000 e 999.999.',
    utmYOutOfRange: 'O valor da UTM Y deve estar entre 0.0 e 10.000.000.',
    MustBeAtLeastOne: 'O valor deve ser pelo menos um.',
    ValidationDispachModule: 'Agilidade e praticidade para otimização, programação e alocação de equipamentos em tempo real. Quer saber como o Despacho pode transformar seu negócio? Nossa equipe comercial está à disposição para oferecer todos os detalhes e benefícios.',
    ActionEdit: 'Esta ação irá editar',
    DoYouContinue: 'Deseja continuar?',
    ContentAlreadyRegistered: 'Teor já registrado para data escolhida.',
    InitialDateGreaterThanStartDate: 'Data inicial não pode ser maior que a data final.',
    ElementNotFound: 'Elemento não encontrado.',
    SubElementNotFound: 'Sub-elemento não encontrado.',
    NotificationMaximumMessage: 'Limite máximo de mensagens registradas para categorias',
    NotificationMaximumCategory: 'Limite máximo de 10 categorias registradas.',
    CantDefineRodNumber: '\'Número de Hastes\' permitido apenas com \'Tipo de Operação\' = \'Suporte em Desenvolvimento\'.',
    InvalidRodNumber: 'O \'Número de Hastes\' deve ser um valor inteiro maior ou igual a 0.',
    InvalidScreensNumber: 'O \'Número de Telas\' deve ser um valor inteiro maior ou igual a 0.',
    UniqueGroupMessageName: 'Nome de grupo de mensagem já existe.',
    GroupMessageSendSuccess: 'Mensagem enviada com sucesso!',
    MustBeGreaterThanZero: 'O valor deve ser maior que 0.',
    FuelLevelMustBeBetween: 'Nível de combustível deve estar entre 1 e 100.',
    DateCantBeInTheFuture: 'A data não pode ser futura',
    DateMustBeInTheFuture: 'A data deve ser futura',
    BulkActiveDynamic: 'Esta ação irá ativar a alocação dinâmica para todas as alocações. Deseja continuar?',
    BulkInactiveDynamic: 'Esta ação irá inativar a alocação dinâmica para todas as alocações. Deseja continuar?',
    BulkEditAllEquipmentsStatus: 'Esta ação editará todos os equipamentos selecionados. Deseja continuar?',
    ConflictingLoadFactorPeriod: 'Período conflitante com outro fator de carga.',
    JustNumbers: 'Apenas números',
    InvalidFormat: 'Formato inválido',
    EquipmentAllocatedCannotDeactivate: 'Equipamento está alocado e não pode ser inativado.',
  },
  es: {
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser menor que la fecha inicial',
    FinalElevationMustBeBiggerThanInitialElevation: 'La elevación final debe ser mayor que la inicial',
    LineupScenariosInDateRangeWillBeOverriden: 'Los escenarios en este rango de fechas se sobrescribirán',
    FormWasNotFilledCorrectly: 'El formulario no se ha llenado correctamente',
    ExistingSchedule: 'Este equipamento ja está programado para este período',
    WarningScheduleChange: 'A modificação afetará programações subsequentes. Deseja continuar?',
    WarningTerrainModelDelete: '¿Está seguro de que desea eliminar este modelo de terreno?',
    WarningNoDefaultModelSelected: 'Debe seleccionar un modelo predeterminado',
    AlreadyHasFootage: 'Metraje ya registrado',
    YouHaveUnsavedData: 'Se han modificado datos que deben guardarse',
    ThisActionWillClearAllYourAllocations: 'Esta acción eliminará todas las selecciones actuales. ¿Desea continuar?',
    ExpiredSession: 'Su sesión ha expirado, vuelva a iniciar sesión para continuar',
    DateIntervalAlreadyRegistered: 'Intervalo de fechas ya registrado',
    AlreadyRegisteredFootage: 'Metraje ya registrado',
    TurnGroupAlreadyRegisteredForEquipGroup: 'Ya hay un grupo de turnos registrados para este grupo de equipos',
    ThereAreBlankFields: 'Todos los campos deben completarse antes de guardar',
    CantHaveMultipleTurnsWithSameTeam: 'Un equipo no se puede asociar a dos turnos diferentes en el mismo día',
    AlreadyRegisteredUnit: 'Unidad ya registrada',
    WouldYouLikeToUpdateApps: '¿Le gustaría actualizar las aplicaciones?',
    WouldYouLikeToExit: '¿Le gustaría salir del sistema?',
    RequiredField: 'Campo obligatorio',
    AlreadyRegisteredDiameter: 'Diámetro ya registrado',
    AlreadyRegisteredName: 'Nombre ya registrado',
    CantHaveSameOrder: 'No puede tener el mismo orden que otra operación',
    SameOrderInSameGroupNotAllowed: 'No se permite el mismo orden en el mismo grupo',
    SameNameInSameGroupNotAllowed: 'No se permite el mismo nombre en el mismo grupo',
    ProductivityAlreadyExists: 'Productividad ya existente',
    InitialDateRequired: 'Se debe completar la fecha de inicio',
    FinalDateRequired: 'Se debe completar la fecha de final',
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser menor que la fecha inicial',
    SearchTimeRangeCantExceed: 'El tiempo de búsqueda no puede excederse',
    CodeTypeDoesntAllowNewGroups: 'El tipo de código no permite grupos nuevos',
    ThereAreUnsavedPriorities: 'Hay prioridades que aún no se han definido. ¿Le gustaría guardar de todos modos?',
    CantHaveSubElementsWithSamePriority: 'No puede tener subelementos con la misma prioridad.',
    NoDataMessage: 'Aún no hay datos disponibles',
    SheetImportSuccess: 'Planilla importada correctamente',
    SavedSuccess: 'Se ha guardado exitosamente',
    UpdateSentSuccessfully: 'Actualización enviada exitosamente',
    InvalidDate: 'Fecha inválida',
    InvalidPeriodDate: 'Fecha antes de la fecha límite',
    InvalidHour: 'Hora inválida',
    FutureDateCantBeSelected: 'No se puede seleccionar la fecha futura',
    FutureTimeCantBeSelected: 'No se puede seleccionar la hora futura',
    NoMaintenanceItems: 'No hay datos de mantenimiento registrados',
    ModelUploadSuccess: 'Modelo subido exitosamente',
    ModelUploadError: 'Error al subir modelo',
    ModelProcessingSuccess: 'Modelo procesado exitosamente',
    UploadCanceled: 'Subida cancelada',
    ClosureSavingWarning: 'Esta acción bloqueará la inserción y edición del historial de datos a partir de la fecha registrada. ¿Desea continuar?',
    InvalidClosurePeriod: 'El período de cierre no puede ser menor que el último realizado.',
    YouCanCheckYourDates: '¡Atención! Al enviar cambios, puede generar inconsistencias en la programación. Estás seguro de que quieres continuar?',
    EndMomentCantBeLowerThanStartMoment: 'La hora de finalización no puede ser anterior a la hora de inicio',
    DateCantBeLowerThanConsolidation: 'La fecha no puede ser anterior a la fecha de consolidación',
    ImportErrors: 'Errores de Importación',
    Row: 'Fila',
    Col: 'Columna',
    notEmpty: 'No puede estar vacío',
    LimitCharactersExceeded: 'El límite de caracteres ha sido excedido',
    maxLength20: 'Puede tener un máximo de 20 caracteres',
    maxLength55: 'Puede tener un máximo de 55 caracteres',
    maxLength64: 'Puede tener un máximo de 64 caracteres',
    maxLength128: 'Puede tener un máximo de 128 caracteres',
    mustBeNumeric: 'Debe ser numérico',
    validChars: "Solo puede contener -, _, |, +, ), (, ', º, ., /",
    GroupNotFound: 'Grupo no encontrado.',
    DuplicatedRegister: 'Registro duplicado.',
    CannotEditIdOrGroup: 'No se puede editar el ID o el Grupo.',
    CannotEditId: 'No se puede editar el ID',
    Inactive: 'Inactivo',
    EquipTypeNotFound: 'Tipo de equipo no encontrado.',
    CodeTypeNotFound: 'Tipo de código no encontrado.',
    CodeNotFound: 'Código no encontrado.',
    OperatorNotFound: 'Operador no encontrado.',
    CodeTypeAndCodeGroupNotRelated: 'Tipo de código y grupo de código no están relacionados.',
    EquipTypeAndGroupTypeAndGroupCodeNotRelated: 'Tipo de equipo, tipo de código y grupo de código no están relacionados.',
    MaterialGroupNotFound: 'Grupo de material no encontrado.',
    MaterialNotFound: 'Material no encontrado',
    MaterialGroupNotFoundOrInactive: 'Grupo de Material no encontrado o inactivo',
    ReportUrlNotRegistered: 'Por favor, ingrese la URL de su informe en la base de datos\nde configuración de la plataforma.\nClave: url_reports e url_reports_maps.',
    OperatorExistent: 'El operador ya existe',
    RegistrationExistent: 'El registro ya existe',
    EquipmentGroupNotFound: 'Grupo de Equipos no encontrado.',
    TurnNotFound: 'Turno no encontrado.',
    CompleteTheRegistration: 'Para completar el registro del equipo y grupo de equipos, en su caso, registre:',
    CompleteTheRegistrationMenuTabs: 'Para completar el registro de turnos y clases, siga el flujo de registro en las pestañas del menú.',
    utmXOutOfRange: 'El valor de la UTM X debe estar entre 100.000 y 999.999',
    utmYOutOfRange: 'El valor de la UTM Y debe estar entre 0.0 y 10.000.000',
    MustBeAtLeastOne: 'El valor debe ser al menos uno.',
    ValidationDispachModule: 'Agilidad y practicidad para la optimización, programación y asignación de equipos en tiempo real. ¿Quieres saber cómo Despacho puede transformar tu negocio? Nuestro equipo comercial está disponible para ofrecer todos los detalles y ventajas.',
    ActionEdit: 'Esta acción editará',
    DoYouContinue: '¿Quieres continuar?',
    ContentAlreadyRegistered: 'Teor ya registrada para la fecha elegida.',
    InitialDateGreaterThanStartDate: 'La fecha de inicio no puede ser mayor que la fecha final.',
    ElementNotFound: 'Elemento no encontrado.',
    SubElementNotFound: 'Sublemento no encontrado.',
    NotificationMaximumMessage: 'Limite máximo de mensajes registrados para categorías',
    NotificationMaximumCategory: 'Limite máximo de 10 categorías registradas.',
    CantDefineRodNumber: '\'Número de Varillas\' permitido solo cuando el \'Tipo de Operación\' es \'Suporte em Desenvolvimento\'.',
    InvalidRodNumber: 'El \'Número de Varillas\' debe ser un valor entero mayor o igual a 0.',
    InvalidScreensNumber: 'El \'Número de Pantallas\' debe ser un valor entero mayor o igual a 0.',
    UniqueGroupMessageName: 'El nombre del grupo de mensajes ya existe.',
    GroupMessageSendSuccess: 'Mensaje enviado con éxito!',
    PrecedenceCalculationWillOverrideCurrentConfiguration: 'El cálculo de precedencia sobrescribirá su configuración actual. ¿Desea continuar?',
    MustBeGreaterThanZero: 'El valor debe ser mayor que 0.',
    FuelLevelMustBeBetween: 'El nivel de combustible debe estar entre 0 y 100.',
    DateCantBeInTheFuture: 'La fecha no puede ser futura',
    DateMustBeInTheFuture: 'La fecha debe ser futura',
    BulkActiveDynamic: 'Esta acción activará la asignación dinámica para todas las asignaciones. ¿Desea continuar?',
    BulkInactiveDynamic: 'Esta acción desactivará la asignación dinámica para todas las asignaciones. ¿Desea continuar?',
    BulkEditAllEquipmentsStatus: 'Esta acción editará todos los dispositivos seleccionados. ¿Desea continuar?',
    ConflictingLoadFactorPeriod: 'Un período que entra en conflicto con otro factor de carga.',
    JustNumbers: 'Solo números',
    InvalidFormat: 'Formato no válido',
    EquipmentAllocatedCannotDeactivate: 'El equipo está asignado y no se puede desactivar.',
  },
  esmx: {
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser menor que la fecha inicial',
    FinalElevationMustBeBiggerThanInitialElevation: 'La elevación final debe ser mayor que la inicial',
    LineupScenariosInDateRangeWillBeOverriden: 'Los escenarios dentro de este rango de fechas se sobrescribirán', // 🇲🇽 changed "en este" → "dentro de este"
    FormWasNotFilledCorrectly: 'El formulario no fue llenado correctamente', // 🇲🇽 changed "no se ha llenado"
    ExistingSchedule: 'Este equipo ya está programado para este periodo', // 🇲🇽 "equipamento" → "equipo", "período" → "periodo"
    WarningScheduleChange: 'La modificación afectará programaciones posteriores. ¿Deseas continuar?', // 🇲🇽 "subsequentes" → "posteriores"
    WarningTerrainModelDelete: '¿Estás seguro de que deseas eliminar este modelo de terreno?', // 🇲🇽 "Está" → "Estás"
    WarningNoDefaultModelSelected: 'Debes seleccionar un modelo predeterminado', // 🇲🇽 informal tone
    AlreadyHasFootage: 'Metraje ya registrado',
    YouHaveUnsavedData: 'Tienes datos sin guardar', // 🇲🇽 changed from formal tone
    ThisActionWillClearAllYourAllocations: 'Esta acción eliminará todas tus asignaciones actuales. ¿Deseas continuar?', // 🇲🇽 "selecciones" → "asignaciones", tone
    ExpiredSession: 'Tu sesión ha expirado, vuelve a iniciar sesión para continuar', // 🇲🇽 informal tone
    DateIntervalAlreadyRegistered: 'Intervalo de fechas ya registrado',
    AlreadyRegisteredFootage: 'Metraje ya registrado',
    TurnGroupAlreadyRegisteredForEquipGroup: 'Ya hay un grupo de turnos registrado para este grupo de equipos',
    ThereAreBlankFields: 'Debes completar todos los campos antes de guardar', // 🇲🇽 reordered & informal
    CantHaveMultipleTurnsWithSameTeam: 'Un equipo no puede asignarse a dos turnos distintos en el mismo día', // 🇲🇽 smoother phrasing
    AlreadyRegisteredUnit: 'Unidad ya registrada',
    WouldYouLikeToUpdateApps: '¿Deseas actualizar las aplicaciones?', // 🇲🇽 more common than "le gustaría"
    WouldYouLikeToExit: '¿Deseas salir del sistema?', // 🇲🇽 tone
    RequiredField: 'Campo obligatorio',
    AlreadyRegisteredDiameter: 'Diámetro ya registrado',
    AlreadyRegisteredName: 'Nombre ya registrado',
    CantHaveSameOrder: 'No puedes tener el mismo orden que otra operación', // 🇲🇽 informal & active
    SameOrderInSameGroupNotAllowed: 'No se permite usar el mismo orden dentro del mismo grupo',
    SameNameInSameGroupNotAllowed: 'No se permite usar el mismo nombre dentro del mismo grupo',
    ProductivityAlreadyExists: 'La productividad ya existe', // 🇲🇽 article added
    InitialDateRequired: 'La fecha de inicio es obligatoria', // 🇲🇽 smoother
    FinalDateRequired: 'La fecha de finalización es obligatoria',
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser anterior a la fecha inicial',
    SearchTimeRangeCantExceed: 'El rango de búsqueda no puede excederse',
    CodeTypeDoesntAllowNewGroups: 'Este tipo de código no permite crear nuevos grupos',
    ThereAreUnsavedPriorities: 'Hay prioridades sin guardar. ¿Deseas continuar de todos modos?', // 🇲🇽 smoother
    CantHaveSubElementsWithSamePriority: 'No puedes asignar la misma prioridad a múltiples subelementos',
    NoDataMessage: 'Aún no hay datos disponibles',
    SheetImportSuccess: 'Hoja de cálculo importada correctamente', // 🇲🇽 changed from "Planilla"
    SavedSuccess: 'Guardado exitosamente',
    UpdateSentSuccessfully: 'Actualización enviada con éxito', // 🇲🇽 more common
    InvalidDate: 'Fecha no válida', // 🇲🇽 common variant
    InvalidPeriodDate: 'La fecha es anterior al límite permitido', // 🇲🇽 clearer
    InvalidHour: 'Hora no válida',
    FutureDateCantBeSelected: 'No puedes seleccionar una fecha futura',
    FutureTimeCantBeSelected: 'No puedes seleccionar una hora futura',
    NoMaintenanceItems: 'No hay datos de mantenimiento registrados',
    ModelUploadSuccess: 'Modelo cargado con éxito', // 🇲🇽 changed from "subido"
    ModelUploadError: 'Error al cargar el modelo',
    ModelProcessingSuccess: 'Modelo procesado con éxito',
    UploadCanceled: 'Carga cancelada', // 🇲🇽 changed from "Subida"
    ClosureSavingWarning: 'Esta acción bloqueará la edición del historial de datos a partir de la fecha registrada. ¿Deseas continuar?',
    InvalidClosurePeriod: 'El período de cierre no puede ser anterior al último registrado', // 🇲🇽 more precise
    YouCanCheckYourDates: '¡Atención! Al guardar los cambios puedes generar inconsistencias. ¿Deseas continuar?', // 🇲🇽 smoother tone
    EndMomentCantBeLowerThanStartMoment: 'La hora de finalización no puede ser anterior a la hora de inicio',
    DateCantBeLowerThanConsolidation: 'La fecha no puede ser anterior a la de consolidación',
    ImportErrors: 'Errores de importación',
    Row: 'Fila',
    Col: 'Columna',
    notEmpty: 'Este campo no puede estar vacío', // 🇲🇽 more descriptive
    maxLength64: 'Máximo 64 caracteres',
    maxLength128: 'Máximo 128 caracteres',
    mustBeNumeric: 'Debe contener solo números',
    validChars: "Solo se permiten -, _, |, +, ), (, ', º, ., /",
    GroupNotFound: 'Grupo no encontrado',
    DuplicatedRegister: 'Registro duplicado',
    CannotEditIdOrGroup: 'No se puede editar el ID ni el grupo',
    CannotEditId: 'No se puede editar el ID',
    Inactive: 'Inactivo',
    EquipTypeNotFound: 'Tipo de equipo no encontrado',
    CodeTypeNotFound: 'Tipo de código no encontrado',
    CodeNotFound: 'Código no encontrado',
    OperatorNotFound: 'Operador no encontrado',
    CodeTypeAndCodeGroupNotRelated: 'El tipo de código y el grupo no están relacionados',
    EquipTypeAndGroupTypeAndGroupCodeNotRelated: 'Tipo de equipo, tipo de código y grupo de código no están relacionados',
    MaterialGroupNotFound: 'Grupo de material no encontrado',
    MaterialNotFound: 'Material no encontrado',
    MaterialGroupNotFoundOrInactive: 'Grupo de material no encontrado o inactivo',
    ReportUrlNotRegistered: 'Ingresa la URL del informe en la base de datos de configuración de la plataforma.\nClave: url_reports e url_reports_maps.',
    OperatorExistent: 'El operador ya existe',
    RegistrationExistent: 'El registro ya existe',
    EquipmentGroupNotFound: 'Grupo de equipos no encontrado',
    TurnNotFound: 'Turno no encontrado',
    CompleteTheRegistration: 'Para completar el registro del equipo y su grupo, registra:',
    CompleteTheRegistrationMenuTabs: 'Para completar el registro de turnos y clases, sigue el flujo en las pestañas del menú',
    utmXOutOfRange: 'El valor de UTM X debe estar entre 100,000 y 999,999',
    utmYOutOfRange: 'El valor de UTM Y debe estar entre 0.0 y 10,000,000',
    MustBeAtLeastOne: 'El valor debe ser al menos uno',
    ValidationDispachModule: 'Optimiza la programación y asignación de equipos en tiempo real. ¿Quieres saber cómo el módulo de Despacho puede transformar tu operación? Nuestro equipo comercial está listo para ayudarte.', // 🇲🇽 rewritten
    ActionEdit: 'Esta acción editará',
    DoYouContinue: '¿Deseas continuar?', // 🇲🇽 tone
    ContentAlreadyRegistered: 'Contenido ya registrado para la fecha seleccionada', // 🇲🇽 changed from "Teor"
    InitialDateGreaterThanStartDate: 'La fecha de inicio no puede ser mayor que la fecha final',
    ElementNotFound: 'Elemento no encontrado',
    SubElementNotFound: 'Subelemento no encontrado',
    UniqueGroupMessageName: 'El nombre del grupo de mensajes ya existe.',
    GroupMessageSendSuccess: '¡Mensaje enviado exitosamente!',
    CantDefineRodNumber: '\'Número de Varillas\' permitido solo cuando el \'Tipo de Operación\' es \'Suporte em Desenvolvimento\'.',
    InvalidRodNumber: 'El \'Número de Varillas\' debe ser un valor entero mayor o igual a 0.',
    InvalidScreensNumber: 'El \'Número de Pantallas\' debe ser un valor entero mayor o igual a 0.',
    NotificationMaximumMessage: 'Limite máximo de mensajes registrados para categorías',
    PrecedenceCalculationWillOverrideCurrentConfiguration: 'El cálculo de precedencia sobrescribirá su configuración actual. ¿Desea continuar?',
    maxLength55: 'Puede tener un máximo de 55 caracteres',
    MustBeGreaterThanZero: 'El valor debe ser mayor que 0.',
    FuelLevelMustBeBetween: 'El nivel de combustible debe estar entre 0 y 100.',
    DateCantBeInTheFuture: 'La fecha no puede ser futura',
    BulkActiveDynamic: 'Esta acción activará la asignación dinámica para todas las asignaciones. ¿Deseas continuar?',
    BulkInactiveDynamic: 'Esta acción desactivará la asignación dinámica para todas las asignaciones. ¿Deseas continuar?',
    BulkEditAllEquipmentsStatus: 'Esta acción editará todos los dispositivos seleccionados. ¿Desea continuar?',
    ConflictingLoadFactorPeriod: 'Un período que entra en conflicto con otro factor de carga.',
    JustNumbers: 'Solo números',
    InvalidFormat: 'Formato no válido',
    EquipmentAllocatedCannotDeactivate: 'El equipo está asignado y no se puede desactivar.',
  },
  escl: {
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser menor que la fecha inicial',
    FinalElevationMustBeBiggerThanInitialElevation: 'La elevación final debe ser mayor que la inicial',
    LineupScenariosInDateRangeWillBeOverriden: 'Los escenarios en este rango de fechas se reemplazarán',
    FormWasNotFilledCorrectly: 'El formulario no se completó correctamente',
    ExistingSchedule: 'Este equipo ya está programado para este período',
    WarningScheduleChange: 'El cambio afectará programaciones posteriores. ¿Continuar?',
    WarningTerrainModelDelete: '¿Está seguro de eliminar este modelo de terreno?',
    WarningNoDefaultModelSelected: 'Debe seleccionar un modelo predeterminado',
    AlreadyHasFootage: 'Metraje ya registrado',
    YouHaveUnsavedData: 'Hay datos modificados sin guardar',
    ThisActionWillClearAllYourAllocations: 'Esta acción eliminará todas las asignaciones actuales. ¿Continuar?',
    ExpiredSession: 'Sesión expirada, ingrese nuevamente para continuar',
    DateIntervalAlreadyRegistered: 'Intervalo de fechas ya registrado',
    AlreadyRegisteredFootage: 'Metraje ya registrado',
    TurnGroupAlreadyRegisteredForEquipGroup: 'Ya existe un grupo de turnos para este grupo de equipos',
    ThereAreBlankFields: 'Todos los campos deben completarse antes de guardar',
    CantHaveMultipleTurnsWithSameTeam: 'Un equipo no puede tener dos turnos diferentes el mismo día',
    AlreadyRegisteredUnit: 'Unidad ya registrada',
    WouldYouLikeToUpdateApps: '¿Desea actualizar las aplicaciones?',
    WouldYouLikeToExit: '¿Desea salir del sistema?',
    RequiredField: 'Campo requerido',
    AlreadyRegisteredDiameter: 'Diámetro ya registrado',
    AlreadyRegisteredName: 'Nombre ya registrado',
    CantHaveSameOrder: 'No puede tener el mismo orden que otra operación',
    SameOrderInSameGroupNotAllowed: 'No se permite mismo orden en el mismo grupo',
    SameNameInSameGroupNotAllowed: 'No se permite mismo nombre en el mismo grupo',
    ProductivityAlreadyExists: 'Productividad ya existe',
    InitialDateRequired: 'Fecha de inicio requerida',
    FinalDateRequired: 'Fecha final requerida',
    FinalDateSmallerThanInitialDate: 'La fecha final no puede ser menor que la inicial',
    SearchTimeRangeCantExceed: 'El tiempo de búsqueda no puede excederse',
    CodeTypeDoesntAllowNewGroups: 'Este tipo de código no permite nuevos grupos',
    ThereAreUnsavedPriorities: 'Hay prioridades sin definir. ¿Guardar de todos modos?',
    CantHaveSubElementsWithSamePriority: 'No puede haber subelementos con la misma prioridad',
    NoDataMessage: 'Aún no hay datos disponibles',
    SheetImportSuccess: 'Planilla importada correctamente',
    SavedSuccess: 'Guardado exitosamente',
    UpdateSentSuccessfully: 'Actualización enviada exitosamente',
    InvalidDate: 'Fecha inválida',
    InvalidPeriodDate: 'Fecha anterior a la fecha límite',
    InvalidHour: 'Hora inválida',
    FutureDateCantBeSelected: 'No se puede seleccionar fecha futura',
    FutureTimeCantBeSelected: 'No se puede seleccionar hora futura',
    NoMaintenanceItems: 'No hay datos de mantenimiento registrados',
    ModelUploadSuccess: 'Modelo subido exitosamente',
    ModelUploadError: 'Error al subir modelo',
    ModelProcessingSuccess: 'Modelo procesado exitosamente',
    UploadCanceled: 'Subida cancelada',
    ClosureSavingWarning: 'Esta acción bloqueará la inserción y edición de datos desde la fecha registrada. ¿Continuar?',
    InvalidClosurePeriod: 'El período de cierre no puede ser menor al último realizado',
    YouCanCheckYourDates: '¡Atención! Los cambios pueden generar inconsistencias en la programación. ¿Continuar?',
    EndMomentCantBeLowerThanStartMoment: 'La hora final no puede ser anterior a la hora inicial',
    DateCantBeLowerThanConsolidation: 'La fecha no puede ser anterior a la fecha de consolidación',
    ImportErrors: 'Errores de Importación',
    Row: 'Fila',
    Col: 'Columna',
    notEmpty: 'No puede estar vacío',
    LimitCharactersExceeded: 'El límite de caracteres ha sido excedido',
    maxLength20: 'Máximo 20 caracteres',
    maxLength55: 'Máximo 55 caracteres',
    maxLength64: 'Máximo 64 caracteres',
    maxLength128: 'Máximo 128 caracteres',
    mustBeNumeric: 'Debe ser numérico',
    validChars: "Solo caracteres: -, _, |, +, ), (, ', º, ., /",
    GroupNotFound: 'Grupo no encontrado',
    DuplicatedRegister: 'Registro duplicado',
    CannotEditIdOrGroup: 'No se puede editar ID o Grupo',
    CannotEditId: 'No se puede editar el ID',
    Inactive: 'Inactivo',
    EquipTypeNotFound: 'Tipo de equipo no encontrado',
    CodeTypeNotFound: 'Tipo de código no encontrado',
    CodeNotFound: 'Código no encontrado',
    OperatorNotFound: 'Operador no encontrado',
    CodeTypeAndCodeGroupNotRelated: 'Tipo de código y grupo de código no relacionados',
    EquipTypeAndGroupTypeAndGroupCodeNotRelated: 'Tipo de equipo, tipo de código y grupo de código no relacionados',
    MaterialGroupNotFound: 'Grupo de material no encontrado',
    MaterialNotFound: 'Material no encontrado',
    MaterialGroupNotFoundOrInactive: 'Grupo de Material no encontrado o inactivo',
    ReportUrlNotRegistered: 'Ingrese la URL de informes en la configuración de la plataforma.\nClave: url_reports e url_reports_maps.',
    OperatorExistent: 'El operador ya existe',
    RegistrationExistent: 'El registro ya existe',
    EquipmentGroupNotFound: 'Grupo de Equipos no encontrado',
    TurnNotFound: 'Turno no encontrado',
    CompleteTheRegistration: 'Para completar el registro del equipo y grupo, registre:',
    CompleteTheRegistrationMenuTabs: 'Para completar registro de turnos y clases, siga el flujo en las pestañas del menú',
    utmXOutOfRange: 'UTM X debe estar entre 100.000 y 999.999',
    utmYOutOfRange: 'UTM Y debe estar entre 0.0 y 10.000.000',
    MustBeAtLeastOne: 'El valor debe ser al menos 1',
    ValidationDispachModule: 'Agilidad para optimización, programación y asignación de equipos en tiempo real. ¿Quieres saber cómo el Despacho puede transformar tu operación? Nuestro equipo comercial está disponible para detalles.',
    ActionEdit: 'Esta acción editará',
    DoYouContinue: '¿Desea continuar?',
    ContentAlreadyRegistered: 'Contenido ya registrado para la fecha elegida',
    InitialDateGreaterThanStartDate: 'La fecha inicial no puede ser mayor que la final',
    ElementNotFound: 'Elemento no encontrado',
    SubElementNotFound: 'Subelemento no encontrado',
    NotificationMaximumMessage: 'Límite máximo de mensajes para categorías',
    NotificationMaximumCategory: 'Límite máximo de 10 categorías registradas',
    CantDefineRodNumber: '\'Número de Varillas\' solo permitido cuando el \'Tipo de Operación\' es \'Soporte en Desarrollo\'',
    InvalidRodNumber: '\'Número de Varillas\' debe ser entero mayor o igual a 0',
    InvalidScreensNumber: '\'Número de Pantallas\' debe ser entero mayor o igual a 0',
    UniqueGroupMessageName: 'El nombre del grupo de mensajes ya existe',
    GroupMessageSendSuccess: '¡Mensaje enviado con éxito!',
    PrecedenceCalculationWillOverrideCurrentConfiguration: 'El cálculo de precedencia reemplazará su configuración actual. ¿Continuar?',
    MustBeGreaterThanZero: 'El valor debe ser mayor que 0',
    DateCantBeInTheFuture: 'La fecha no puede ser futura',
    DateMustBeInTheFuture: 'La fecha debe ser futura',
    BulkActiveDynamic: 'Esta acción activará la asignación dinámica para todas las asignaciones. ¿Deseas continuar?',
    BulkInactiveDynamic: 'Esta acción desactivará la asignación dinámica para todas las asignaciones. ¿Deseas continuar?',
    BulkEditAllEquipmentsStatus: 'Esta acción editará todos los dispositivos seleccionados. ¿Desea continuar?',
    ConflictingLoadFactorPeriod: 'Un período que entra en conflicto con otro factor de carga.',
    JustNumbers: 'Solo números',
    InvalidFormat: 'Formato no válido',
    EquipmentAllocatedCannotDeactivate: 'El equipo está asignado y no se puede desactivar.',
  },
};

export const tips = {
  en: {
    CharacterLimitExceeded: 'Character limit exceeded',
    YouMustSelectAllFilters: 'You must select all filters',
    LimitExceeded: 'Limit exceeded',
    DynamicText: `Discover the power of the Dynamic Module!
    Automate your transportation and loading cycles, manage your database intelligently and get dynamic allocations in dispatch.
    With Data Driven triggers and many other advanced features, Dynamic is the tool you need to optimize your operations.
    Want to know how Dynamic can transform your business? Our sales team is available to provide all the details and benefits.`,
    NoModuleText: `You don't have this module yet.
    Would you like to know more about it? Our sales team will be happy to assist you.`,
  },
  ptbr: {
    CharacterLimitExceeded: 'Limite de caracteres excedido',
    YouMustSelectAllFilters: 'Você deve selecionar todos os filtros',
    LimitExceeded: 'Limite excedido',
    DynamicText: `Descubra o poder do Módulo Dynamic!
    Automatize seus ciclos de transporte e carga, gerencie sua base de dados de forma inteligente e obtenha alocações dinâmicas no despacho.
    Com gatilhos Data Driven e muitas outras funcionalidades avançadas, o Dynamic é a ferramenta que você precisa para otimizar suas operações.
    Quer saber como o Dynamic pode transformar seu negócio? Nossa equipe comercial está à disposição para oferecer todos os detalhes e benefícios.`,
    NoModuleText: `Você ainda não tem esse módulo contratado.
    Deseja saber mais sobre? Nossa equipe comercial vai ter o prazer de atendê-lo.`,
  },
  es: {
    CharacterLimitExceeded: 'Límite de caracteres excedido',
    YouMustSelectAllFilters: 'Debe seleccionar todos los filtros',
    LimitExceeded: 'Límite excedido',
    DynamicText: `¡Descubre el poder del Módulo Dynamic!
    Automatiza tus ciclos de transporte y carga, gestiona tu base de datos de forma inteligente y obtén asignaciones dinámicas en el despacho.
    Con disparadores Data Driven y muchas otras funciones avanzadas, Dynamic es la herramienta que necesitas para optimizar tus operaciones.
    ¿Quieres saber cómo Dynamic puede transformar tu negocio? Nuestro equipo de ventas está disponible para proporcionarte todos los detalles y beneficios.`,
    NoModuleText: `Aún no tienes este módulo contratado.
    ¿Te gustaría saber más sobre él? Nuestro equipo de ventas estará encantado de ayudarte.`,
  },
  esmx: {
    CharacterLimitExceeded: 'Se superó el límite de caracteres', // 🇲🇽 changed from "Límite de caracteres excedido"
    YouMustSelectAllFilters: 'Debes seleccionar todos los filtros', // 🇲🇽 tone changed from "Debe"
    LimitExceeded: 'Límite superado', // 🇲🇽 more natural in MX context
    DynamicText: `¡Descubre el poder del módulo Dynamic!
    Automatiza tus ciclos de transporte y carga, gestiona tu base de datos de forma inteligente y obtén asignaciones dinámicas en el módulo de despacho.
    Con disparadores orientados por datos (Data Driven) y muchas funciones avanzadas, Dynamic es la herramienta ideal para optimizar tus operaciones.
    ¿Quieres saber cómo Dynamic puede transformar tu operación? Nuestro equipo de ventas está listo para darte todos los detalles y beneficios.`, // 🇲🇽 adjusted vocabulary and tone
    NoModuleText: `Aún no tienes este módulo contratado.
    ¿Te gustaría saber más sobre él? Nuestro equipo de ventas estará encantado de apoyarte.`, // 🇲🇽 changed "ayudarte" → "apoyarte" (more local)
  },
  escl: {
    CharacterLimitExceeded: 'Límite de caracteres excedido',
    YouMustSelectAllFilters: 'Debe seleccionar todos los filtros',
    LimitExceeded: 'Límite excedido',
    DynamicText: `¡Descubre el Módulo Dynamic!
    Automatiza tus ciclos de transporte y carga, gestiona tu base de datos de forma inteligente y obtén asignaciones dinámicas.
    Con disparadores Data Driven y funciones avanzadas, Dynamic es la herramienta para optimizar tus operaciones.
    ¿Quieres saber cómo Dynamic puede transformar tu operación? Nuestro equipo de ventas está disponible para darte todos los detalles.`,
    NoModuleText: `Aún no tienes este módulo contratado.
    ¿Te gustaría saber más? Nuestro equipo de ventas puede ayudarte.`,
  },
};

export const indicators = {
  en: {
    load_queue_time: 'Loading Queue Time',
    unload_queue_time: 'Unloading Queue Time',
    total_queue_time: 'Total Queue Time',
    load_maneuver_time: 'Loading Maneuver Time',
    unload_maneuver_time: 'Unloading Maneuver Time',
    total_maneuver_time: 'Total Maneuver Time',
    unload_time: 'Unloading Time',
    load_time: 'Loading Time',
    empty_time: 'Empty Time',
    full_time: 'Full Time',
    total_transport_time: 'Total Transport Time',
    empty_distance: 'Empty Distance',
    full_distance: 'Full Distance',
    total_distance: 'Average Distance',
    load_manager: 'Material Volume',
    stop_time: 'Stop Time',
    last_1_cicles: 'Last Cycle',
    last_10_cicles: 'Last 10 Cycles',
    no_records_to_display: 'No records to display',
  },
  ptbr: {
    load_queue_time: 'Tempo de Fila de Carregamento',
    unload_queue_time: 'Tempo de Fila de Descarregamento',
    total_queue_time: 'Tempo Total de Fila',
    load_maneuver_time: 'Tempo de Manobra de Carregamento',
    unload_maneuver_time: 'Tempo de Manobra de Basculamento',
    total_maneuver_time: 'Tempo Total de Manobra',
    unload_time: 'Tempo de Basculamento',
    load_time: 'Tempo de Carregamento',
    empty_time: 'Tempo Vazio',
    full_time: 'Tempo Cheio',
    total_transport_time: 'Tempo Total de Transporte',
    empty_distance: 'Distância Vazia',
    full_distance: 'Distância Cheia',
    total_distance: 'Distância Média',
    load_manager: 'Volume de Material',
    stop_time: 'Tempo de Parada',
    last_1_cicles: 'Último ciclo',
    last_10_cicles: 'Últimos 10 ciclos',
    no_records_to_display: 'Nenhum registro para exibir',
  },
  es: {
    load_queue_time: 'Tiempo de Cola de Carga',
    unload_queue_time: 'Tiempo de Cola de Descarga',
    total_queue_time: 'Tiempo Total de Cola',
    load_maneuver_time: 'Tiempo de Maniobra de Carga',
    unload_maneuver_time: 'Tiempo de Maniobra de Descarga',
    total_maneuver_time: 'Tiempo Total de Maniobra',
    unload_time: 'Tiempo de Descarga',
    load_time: 'Tiempo de Carga',
    empty_time: 'Tiempo Vacío',
    full_time: 'Tiempo Lleno',
    total_transport_time: 'Tiempo Total de Transporte',
    empty_distance: 'Distancia Vacía',
    full_distance: 'Distancia Llena',
    total_distance: 'Distancia Promedio',
    load_manager: 'Volumen de Material',
    stop_time: 'Tiempo de Parada',
    last_1_cicles: 'Último Ciclo',
    last_10_cicles: 'Últimos 10 Ciclos',
    no_records_to_display: 'No hay registros para mostrar',
  },
  esmx: {
    load_queue_time: 'Tiempo de fila de carga', // 🇲🇽 changed "Cola" → "fila"
    unload_queue_time: 'Tiempo de fila de descarga', // 🇲🇽 changed
    total_queue_time: 'Tiempo total de fila', // 🇲🇽 changed
    load_maneuver_time: 'Tiempo de maniobra de carga',
    unload_maneuver_time: 'Tiempo de maniobra de descarga',
    total_maneuver_time: 'Tiempo total de maniobra',
    unload_time: 'Tiempo de descarga',
    load_time: 'Tiempo de carga',
    empty_time: 'Tiempo vacío', // 🇲🇽 changed from "Vacío"
    full_time: 'Tiempo lleno', // 🇲🇽 changed from "Lleno"
    total_transport_time: 'Tiempo total de transporte',
    empty_distance: 'Distancia vacío', // 🇲🇽 changed
    full_distance: 'Distancia lleno', // 🇲🇽 changed
    total_distance: 'Distancia total', // 🇲🇽 changed from "Promedio"
    load_manager: 'Gestión de carga', // 🇲🇽 changed from "Volumen de Material"
    stop_time: 'Tiempo de parada',
    last_1_cicles: 'Último ciclo', // 🇲🇽 corrected spelling: "cicles" → "cycles"
    last_10_cicles: 'Últimos 10 ciclos', // 🇲🇽 spelling
    no_records_to_display: 'No hay registros disponibles para mostrar', // 🇲🇽 slightly more natural
  },
  escl: {
    load_queue_time: 'Tiempo Cola Carga',
    unload_queue_time: 'Tiempo Cola Descarga',
    total_queue_time: 'Tiempo Total Cola',
    load_maneuver_time: 'Tiempo Maniobra Carga',
    unload_maneuver_time: 'Tiempo Maniobra Descarga',
    total_maneuver_time: 'Tiempo Total Maniobra',
    unload_time: 'Tiempo Descarga',
    load_time: 'Tiempo Carga',
    empty_time: 'Tiempo Vacío',
    full_time: 'Tiempo Cargado',
    total_transport_time: 'Tiempo Total Transporte',
    empty_distance: 'Distancia Vacío',
    full_distance: 'Distancia Cargado',
    total_distance: 'Distancia Promedio',
    load_manager: 'Volumen Material',
    stop_time: 'Tiempo Parada',
    last_1_cicles: 'Último Ciclo',
    last_10_cicles: 'Últimos 10 Ciclos',
    no_records_to_display: 'No hay registros para mostrar',
  },
};
